typeof navigator !== "undefined" && function(root1, factory1) {
    if (typeof define === "function" && define.amd) define(function() {
        return factory1(root1);
    });
    else if (typeof module === "object" && module.exports) module.exports = factory1(root1);
    else {
        root1.lottie = factory1(root1);
        root1.bodymovin = root1.lottie;
    }
}(window || {}, function(window) {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", initialDefaultFrame = -999999, subframeEnabled = !0, idPrefix = "", expressionsPlugin, isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), cachedColors = {}, bmRnd, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    function ProjectInterface() {
        return {};
    }
    !function() {
        var t1, e1 = [
            "abs",
            "acos",
            "acosh",
            "asin",
            "asinh",
            "atan",
            "atanh",
            "atan2",
            "ceil",
            "cbrt",
            "expm1",
            "clz32",
            "cos",
            "cosh",
            "exp",
            "floor",
            "fround",
            "hypot",
            "imul",
            "log",
            "log1p",
            "log2",
            "log10",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sign",
            "sin",
            "sinh",
            "sqrt",
            "tan",
            "tanh",
            "trunc",
            "E",
            "LN10",
            "LN2",
            "LOG10E",
            "LOG2E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ], r1 = e1.length;
        for(t1 = 0; t1 < r1; t1 += 1)BMMath[e1[t1]] = Math[e1[t1]];
    }(), BMMath.random = Math.random, BMMath.abs = function(t1) {
        if ("object" === typeof t1 && t1.length) {
            var e1, r1 = createSizedArray(t1.length), i1 = t1.length;
            for(e1 = 0; e1 < i1; e1 += 1)r1[e1] = Math.abs(t1[e1]);
            return r1;
        }
        return Math.abs(t1);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
    function roundValues(t1) {
        bmRnd = t1 ? Math.round : function(t1) {
            return t1;
        };
    }
    function styleDiv(t1) {
        t1.style.position = "absolute", t1.style.top = 0, t1.style.left = 0, t1.style.display = "block", t1.style.transformOrigin = "0 0", t1.style.webkitTransformOrigin = "0 0", t1.style.backfaceVisibility = "visible", t1.style.webkitBackfaceVisibility = "visible", t1.style.transformStyle = "preserve-3d", t1.style.webkitTransformStyle = "preserve-3d", t1.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(t1, e1, r1, i1) {
        this.type = t1, this.currentTime = e1, this.totalTime = r1, this.direction = i1 < 0 ? -1 : 1;
    }
    function BMCompleteEvent(t1, e1) {
        this.type = t1, this.direction = e1 < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(t1, e1, r1, i1) {
        this.type = t1, this.currentLoop = r1, this.totalLoops = e1, this.direction = i1 < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(t1, e1, r1) {
        this.type = t1, this.firstFrame = e1, this.totalFrames = r1;
    }
    function BMDestroyEvent(t1, e1) {
        this.type = t1, this.target = e1;
    }
    function BMRenderFrameErrorEvent(t1, e1) {
        this.type = "renderFrameError", this.nativeError = t1, this.currentTime = e1;
    }
    function BMConfigErrorEvent(t1) {
        this.type = "configError", this.nativeError = t1;
    }
    function BMAnimationConfigErrorEvent(t1, e1) {
        this.type = t1, this.nativeError = e1;
    }
    roundValues(!1);
    var createElementID = (F = 0, function() {
        return idPrefix + "__lottie_element_" + (F += 1);
    }), F;
    function HSVtoRGB(t1, e1, r1) {
        var i1, s1, a1, n1, o1, h1, l1, p1;
        switch(h1 = r1 * (1 - e1), l1 = r1 * (1 - (o1 = 6 * t1 - (n1 = Math.floor(6 * t1))) * e1), p1 = r1 * (1 - (1 - o1) * e1), n1 % 6){
            case 0:
                i1 = r1, s1 = p1, a1 = h1;
                break;
            case 1:
                i1 = l1, s1 = r1, a1 = h1;
                break;
            case 2:
                i1 = h1, s1 = r1, a1 = p1;
                break;
            case 3:
                i1 = h1, s1 = l1, a1 = r1;
                break;
            case 4:
                i1 = p1, s1 = h1, a1 = r1;
                break;
            case 5:
                i1 = r1, s1 = h1, a1 = l1;
        }
        return [
            i1,
            s1,
            a1
        ];
    }
    function RGBtoHSV(t1, e1, r1) {
        var i1, s1 = Math.max(t1, e1, r1), a1 = Math.min(t1, e1, r1), n1 = s1 - a1, o1 = 0 === s1 ? 0 : n1 / s1, h1 = s1 / 255;
        switch(s1){
            case a1:
                i1 = 0;
                break;
            case t1:
                i1 = e1 - r1 + n1 * (e1 < r1 ? 6 : 0), i1 /= 6 * n1;
                break;
            case e1:
                i1 = r1 - t1 + 2 * n1, i1 /= 6 * n1;
                break;
            case r1:
                i1 = t1 - e1 + 4 * n1, i1 /= 6 * n1;
        }
        return [
            i1,
            o1,
            h1
        ];
    }
    function addSaturationToRGB(t1, e1) {
        var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
        return r1[1] += e1, 1 < r1[1] ? r1[1] = 1 : r1[1] <= 0 && (r1[1] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
    }
    function addBrightnessToRGB(t1, e1) {
        var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
        return r1[2] += e1, 1 < r1[2] ? r1[2] = 1 : r1[2] < 0 && (r1[2] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
    }
    function addHueToRGB(t1, e1) {
        var r1 = RGBtoHSV(255 * t1[0], 255 * t1[1], 255 * t1[2]);
        return r1[0] += e1 / 360, 1 < r1[0] ? r1[0] -= 1 : r1[0] < 0 && (r1[0] += 1), HSVtoRGB(r1[0], r1[1], r1[2]);
    }
    var rgbToHex = function() {
        var t1, e1, i1 = [];
        for(t1 = 0; t1 < 256; t1 += 1)e1 = t1.toString(16), i1[t1] = 1 === e1.length ? "0" + e1 : e1;
        return function(t1, e1, r1) {
            return t1 < 0 && (t1 = 0), e1 < 0 && (e1 = 0), r1 < 0 && (r1 = 0), "#" + i1[t1] + i1[e1] + i1[r1];
        };
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function(t1, e1) {
            if (this._cbs[t1]) for(var r1 = this._cbs[t1], i1 = 0; i1 < r1.length; i1 += 1)r1[i1](e1);
        },
        addEventListener: function(t1, e1) {
            return this._cbs[t1] || (this._cbs[t1] = []), this._cbs[t1].push(e1), (function() {
                this.removeEventListener(t1, e1);
            }).bind(this);
        },
        removeEventListener: function(t1, e1) {
            if (e1) {
                if (this._cbs[t1]) {
                    for(var r1 = 0, i1 = this._cbs[t1].length; r1 < i1;)this._cbs[t1][r1] === e1 && (this._cbs[t1].splice(r1, 1), r1 -= 1, i1 -= 1), r1 += 1;
                    this._cbs[t1].length || (this._cbs[t1] = null);
                }
            } else this._cbs[t1] = null;
        }
    };
    var createTypedArray = function() {
        function r1(t1, e1) {
            var r1, i1 = 0, s1 = [];
            switch(t1){
                case "int16":
                case "uint8c":
                    r1 = 1;
                    break;
                default:
                    r1 = 1.1;
            }
            for(i1 = 0; i1 < e1; i1 += 1)s1.push(r1);
            return s1;
        }
        return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(t1, e1) {
            return "float32" === t1 ? new Float32Array(e1) : "int16" === t1 ? new Int16Array(e1) : "uint8c" === t1 ? new Uint8ClampedArray(e1) : r1(t1, e1);
        } : r1;
    }();
    function createSizedArray(t1) {
        return Array.apply(null, {
            length: t1
        });
    }
    function createNS(t1) {
        return document.createElementNS(svgNS, t1);
    }
    function createTag(t1) {
        return document.createElement(t1);
    }
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function(t1) {
            -1 === this.dynamicProperties.indexOf(t1) && (this.dynamicProperties.push(t1), this.container.addDynamicProperty(this), this._isAnimated = !0);
        },
        iterateDynamicProperties: function() {
            var t1;
            this._mdf = !1;
            var e1 = this.dynamicProperties.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue(), this.dynamicProperties[t1]._mdf && (this._mdf = !0);
        },
        initDynamicPropertyContainer: function(t1) {
            this.container = t1, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
        }
    };
    var getBlendMode = (Oa = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
    }, function(t1) {
        return Oa[t1] || "";
    }), Oa, lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
    }, lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
    }, Matrix = function() {
        var s1 = Math.cos, a1 = Math.sin, n1 = Math.tan, i1 = Math.round;
        function t1() {
            return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
        }
        function e1(t1) {
            if (0 === t1) return this;
            var e1 = s1(t1), r1 = a1(t1);
            return this._t(e1, -r1, 0, 0, r1, e1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function r1(t1) {
            if (0 === t1) return this;
            var e1 = s1(t1), r1 = a1(t1);
            return this._t(1, 0, 0, 0, 0, e1, -r1, 0, 0, r1, e1, 0, 0, 0, 0, 1);
        }
        function o1(t1) {
            if (0 === t1) return this;
            var e1 = s1(t1), r1 = a1(t1);
            return this._t(e1, 0, r1, 0, 0, 1, 0, 0, -r1, 0, e1, 0, 0, 0, 0, 1);
        }
        function h1(t1) {
            if (0 === t1) return this;
            var e1 = s1(t1), r1 = a1(t1);
            return this._t(e1, -r1, 0, 0, r1, e1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function l1(t1, e1) {
            return this._t(1, e1, t1, 1, 0, 0);
        }
        function p1(t1, e1) {
            return this.shear(n1(t1), n1(e1));
        }
        function m1(t1, e1) {
            var r1 = s1(e1), i1 = a1(e1);
            return this._t(r1, i1, 0, 0, -i1, r1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n1(t1), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(r1, -i1, 0, 0, i1, r1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function f1(t1, e1, r1) {
            return r1 || 0 === r1 || (r1 = 1), 1 === t1 && 1 === e1 && 1 === r1 ? this : this._t(t1, 0, 0, 0, 0, e1, 0, 0, 0, 0, r1, 0, 0, 0, 0, 1);
        }
        function c1(t1, e1, r1, i1, s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1, u1) {
            return this.props[0] = t1, this.props[1] = e1, this.props[2] = r1, this.props[3] = i1, this.props[4] = s1, this.props[5] = a1, this.props[6] = n1, this.props[7] = o1, this.props[8] = h1, this.props[9] = l1, this.props[10] = p1, this.props[11] = m1, this.props[12] = f1, this.props[13] = c1, this.props[14] = d1, this.props[15] = u1, this;
        }
        function d1(t1, e1, r1) {
            return r1 = r1 || 0, 0 !== t1 || 0 !== e1 || 0 !== r1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t1, e1, r1, 1) : this;
        }
        function u1(t1, e1, r1, i1, s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1, u1) {
            var y1 = this.props;
            if (1 === t1 && 0 === e1 && 0 === r1 && 0 === i1 && 0 === s1 && 1 === a1 && 0 === n1 && 0 === o1 && 0 === h1 && 0 === l1 && 1 === p1 && 0 === m1) return y1[12] = y1[12] * t1 + y1[15] * f1, y1[13] = y1[13] * a1 + y1[15] * c1, y1[14] = y1[14] * p1 + y1[15] * d1, y1[15] *= u1, this._identityCalculated = !1, this;
            var g1 = y1[0], v1 = y1[1], b1 = y1[2], P1 = y1[3], E1 = y1[4], x1 = y1[5], S1 = y1[6], A1 = y1[7], C1 = y1[8], _1 = y1[9], T1 = y1[10], k1 = y1[11], D1 = y1[12], M1 = y1[13], F1 = y1[14], w1 = y1[15];
            return y1[0] = g1 * t1 + v1 * s1 + b1 * h1 + P1 * f1, y1[1] = g1 * e1 + v1 * a1 + b1 * l1 + P1 * c1, y1[2] = g1 * r1 + v1 * n1 + b1 * p1 + P1 * d1, y1[3] = g1 * i1 + v1 * o1 + b1 * m1 + P1 * u1, y1[4] = E1 * t1 + x1 * s1 + S1 * h1 + A1 * f1, y1[5] = E1 * e1 + x1 * a1 + S1 * l1 + A1 * c1, y1[6] = E1 * r1 + x1 * n1 + S1 * p1 + A1 * d1, y1[7] = E1 * i1 + x1 * o1 + S1 * m1 + A1 * u1, y1[8] = C1 * t1 + _1 * s1 + T1 * h1 + k1 * f1, y1[9] = C1 * e1 + _1 * a1 + T1 * l1 + k1 * c1, y1[10] = C1 * r1 + _1 * n1 + T1 * p1 + k1 * d1, y1[11] = C1 * i1 + _1 * o1 + T1 * m1 + k1 * u1, y1[12] = D1 * t1 + M1 * s1 + F1 * h1 + w1 * f1, y1[13] = D1 * e1 + M1 * a1 + F1 * l1 + w1 * c1, y1[14] = D1 * r1 + M1 * n1 + F1 * p1 + w1 * d1, y1[15] = D1 * i1 + M1 * o1 + F1 * m1 + w1 * u1, this._identityCalculated = !1, this;
        }
        function y1() {
            return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
        }
        function g1(t1) {
            for(var e1 = 0; e1 < 16;){
                if (t1.props[e1] !== this.props[e1]) return !1;
                e1 += 1;
            }
            return !0;
        }
        function v1(t1) {
            var e1;
            for(e1 = 0; e1 < 16; e1 += 1)t1.props[e1] = this.props[e1];
            return t1;
        }
        function b1(t1) {
            var e1;
            for(e1 = 0; e1 < 16; e1 += 1)this.props[e1] = t1[e1];
        }
        function P1(t1, e1, r1) {
            return {
                x: t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                y: t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                z: t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
            };
        }
        function E1(t1, e1, r1) {
            return t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12];
        }
        function x1(t1, e1, r1) {
            return t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13];
        }
        function S1(t1, e1, r1) {
            return t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14];
        }
        function A1() {
            var t1 = this.props[0] * this.props[5] - this.props[1] * this.props[4], e1 = this.props[5] / t1, r1 = -this.props[1] / t1, i1 = -this.props[4] / t1, s1 = this.props[0] / t1, a1 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t1, n1 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t1, o1 = new Matrix;
            return o1.props[0] = e1, o1.props[1] = r1, o1.props[4] = i1, o1.props[5] = s1, o1.props[12] = a1, o1.props[13] = n1, o1;
        }
        function C1(t1) {
            return this.getInverseMatrix().applyToPointArray(t1[0], t1[1], t1[2] || 0);
        }
        function _1(t1) {
            var e1, r1 = t1.length, i1 = [];
            for(e1 = 0; e1 < r1; e1 += 1)i1[e1] = C1(t1[e1]);
            return i1;
        }
        function T1(t1, e1, r1) {
            var i1 = createTypedArray("float32", 6);
            if (this.isIdentity()) i1[0] = t1[0], i1[1] = t1[1], i1[2] = e1[0], i1[3] = e1[1], i1[4] = r1[0], i1[5] = r1[1];
            else {
                var s1 = this.props[0], a1 = this.props[1], n1 = this.props[4], o1 = this.props[5], h1 = this.props[12], l1 = this.props[13];
                i1[0] = t1[0] * s1 + t1[1] * n1 + h1, i1[1] = t1[0] * a1 + t1[1] * o1 + l1, i1[2] = e1[0] * s1 + e1[1] * n1 + h1, i1[3] = e1[0] * a1 + e1[1] * o1 + l1, i1[4] = r1[0] * s1 + r1[1] * n1 + h1, i1[5] = r1[0] * a1 + r1[1] * o1 + l1;
            }
            return i1;
        }
        function k1(t1, e1, r1) {
            return this.isIdentity() ? [
                t1,
                e1,
                r1
            ] : [
                t1 * this.props[0] + e1 * this.props[4] + r1 * this.props[8] + this.props[12],
                t1 * this.props[1] + e1 * this.props[5] + r1 * this.props[9] + this.props[13],
                t1 * this.props[2] + e1 * this.props[6] + r1 * this.props[10] + this.props[14]
            ];
        }
        function D1(t1, e1) {
            if (this.isIdentity()) return t1 + "," + e1;
            var r1 = this.props;
            return Math.round(100 * (t1 * r1[0] + e1 * r1[4] + r1[12])) / 100 + "," + Math.round(100 * (t1 * r1[1] + e1 * r1[5] + r1[13])) / 100;
        }
        function M1() {
            for(var t1 = 0, e1 = this.props, r1 = "matrix3d("; t1 < 16;)r1 += i1(1e4 * e1[t1]) / 1e4, r1 += 15 === t1 ? ")" : ",", t1 += 1;
            return r1;
        }
        function F1(t1) {
            return t1 < 1e-6 && 0 < t1 || -0.000001 < t1 && t1 < 0 ? i1(1e4 * t1) / 1e4 : t1;
        }
        function w1() {
            var t1 = this.props;
            return "matrix(" + F1(t1[0]) + "," + F1(t1[1]) + "," + F1(t1[4]) + "," + F1(t1[5]) + "," + F1(t1[12]) + "," + F1(t1[13]) + ")";
        }
        return function() {
            this.reset = t1, this.rotate = e1, this.rotateX = r1, this.rotateY = o1, this.rotateZ = h1, this.skew = p1, this.skewFromAxis = m1, this.shear = l1, this.scale = f1, this.setTransform = c1, this.translate = d1, this.transform = u1, this.applyToPoint = P1, this.applyToX = E1, this.applyToY = x1, this.applyToZ = S1, this.applyToPointArray = k1, this.applyToTriplePoints = T1, this.applyToPointStringified = D1, this.toCSS = M1, this.to2dCSS = w1, this.clone = v1, this.cloneFromProps = b1, this.equals = g1, this.inversePoints = _1, this.inversePoint = C1, this.getInverseMatrix = A1, this._t = this.transform, this.isIdentity = y1, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
        };
    }();
    !function(o1, h1) {
        var l1, p1 = this, m1 = 256, f1 = 6, c1 = "random", d1 = h1.pow(m1, f1), u1 = h1.pow(2, 52), y1 = 2 * u1, g1 = m1 - 1;
        function v1(t1) {
            var e1, r1 = t1.length, n1 = this, i1 = 0, s1 = n1.i = n1.j = 0, a1 = n1.S = [];
            for(r1 || (t1 = [
                r1++
            ]); i1 < m1;)a1[i1] = i1++;
            for(i1 = 0; i1 < m1; i1++)a1[i1] = a1[s1 = g1 & s1 + t1[i1 % r1] + (e1 = a1[i1])], a1[s1] = e1;
            n1.g = function(t1) {
                for(var e1, r1 = 0, i1 = n1.i, s1 = n1.j, a1 = n1.S; t1--;)e1 = a1[i1 = g1 & i1 + 1], r1 = r1 * m1 + a1[g1 & (a1[i1] = a1[s1 = g1 & s1 + e1]) + (a1[s1] = e1)];
                return n1.i = i1, n1.j = s1, r1;
            };
        }
        function b1(t1, e1) {
            return e1.i = t1.i, e1.j = t1.j, e1.S = t1.S.slice(), e1;
        }
        function P1(t1, e1) {
            for(var r1, i1 = t1 + "", s1 = 0; s1 < i1.length;)e1[g1 & s1] = g1 & (r1 ^= 19 * e1[g1 & s1]) + i1.charCodeAt(s1++);
            return E1(e1);
        }
        function E1(t1) {
            return String.fromCharCode.apply(0, t1);
        }
        h1["seed" + c1] = function(t1, e1, r1) {
            var i1 = [], s1 = P1(function t1(e1, r1) {
                var i1, s1 = [], a1 = typeof e1;
                if (r1 && "object" == a1) for(i1 in e1)try {
                    s1.push(t1(e1[i1], r1 - 1));
                } catch (t1) {}
                return s1.length ? s1 : "string" == a1 ? e1 : e1 + "\x00";
            }((e1 = !0 === e1 ? {
                entropy: !0
            } : e1 || {}).entropy ? [
                t1,
                E1(o1)
            ] : null === t1 ? function() {
                try {
                    if (l1) return E1(l1.randomBytes(m1));
                    var t1 = new Uint8Array(m1);
                    return (p1.crypto || p1.msCrypto).getRandomValues(t1), E1(t1);
                } catch (t1) {
                    var e1 = p1.navigator, r1 = e1 && e1.plugins;
                    return [
                        +new Date,
                        p1,
                        r1,
                        p1.screen,
                        E1(o1)
                    ];
                }
            }() : t1, 3), i1), a1 = new v1(i1), n1 = function() {
                for(var t1 = a1.g(f1), e1 = d1, r1 = 0; t1 < u1;)t1 = (t1 + r1) * m1, e1 *= m1, r1 = a1.g(1);
                for(; y1 <= t1;)t1 /= 2, e1 /= 2, r1 >>>= 1;
                return (t1 + r1) / e1;
            };
            return n1.int32 = function() {
                return 0 | a1.g(4);
            }, n1.quick = function() {
                return a1.g(4) / 4294967296;
            }, n1.double = n1, P1(E1(a1.S), o1), (e1.pass || r1 || function(t1, e1, r1, i1) {
                return i1 && (i1.S && b1(i1, a1), t1.state = function() {
                    return b1(a1, {});
                }), r1 ? (h1[c1] = t1, e1) : t1;
            })(n1, s1, "global" in e1 ? e1.global : this == h1, e1.state);
        }, P1(h1.random(), o1);
    }([], BMMath);
    var BezierFactory = function() {
        var t1 = {
            getBezierEasing: function(t1, e1, r1, i1, s1) {
                var a1 = s1 || ("bez_" + t1 + "_" + e1 + "_" + r1 + "_" + i1).replace(/\./g, "p");
                if (o1[a1]) return o1[a1];
                var n1 = new h1([
                    t1,
                    e1,
                    r1,
                    i1
                ]);
                return o1[a1] = n1;
            }
        }, o1 = {};
        var l1 = 11, p1 = 1 / (l1 - 1), e1 = "function" == typeof Float32Array;
        function i1(t1, e1) {
            return 1 - 3 * e1 + 3 * t1;
        }
        function s1(t1, e1) {
            return 3 * e1 - 6 * t1;
        }
        function a1(t1) {
            return 3 * t1;
        }
        function m1(t1, e1, r1) {
            return ((i1(e1, r1) * t1 + s1(e1, r1)) * t1 + a1(e1)) * t1;
        }
        function f1(t1, e1, r1) {
            return 3 * i1(e1, r1) * t1 * t1 + 2 * s1(e1, r1) * t1 + a1(e1);
        }
        function h1(t1) {
            this._p = t1, this._mSampleValues = e1 ? new Float32Array(l1) : new Array(l1), this._precomputed = !1, this.get = this.get.bind(this);
        }
        return h1.prototype = {
            get: function(t1) {
                var e1 = this._p[0], r1 = this._p[1], i1 = this._p[2], s1 = this._p[3];
                return this._precomputed || this._precompute(), e1 === r1 && i1 === s1 ? t1 : 0 === t1 ? 0 : 1 === t1 ? 1 : m1(this._getTForX(t1), r1, s1);
            },
            _precompute: function() {
                var t1 = this._p[0], e1 = this._p[1], r1 = this._p[2], i1 = this._p[3];
                this._precomputed = !0, t1 === e1 && r1 === i1 || this._calcSampleValues();
            },
            _calcSampleValues: function() {
                for(var t1 = this._p[0], e1 = this._p[2], r1 = 0; r1 < l1; ++r1)this._mSampleValues[r1] = m1(r1 * p1, t1, e1);
            },
            _getTForX: function(t1) {
                for(var e1 = this._p[0], r1 = this._p[2], i1 = this._mSampleValues, s1 = 0, a1 = 1, n1 = l1 - 1; a1 !== n1 && i1[a1] <= t1; ++a1)s1 += p1;
                var o1 = s1 + (t1 - i1[--a1]) / (i1[a1 + 1] - i1[a1]) * p1, h1 = f1(o1, e1, r1);
                return .001 <= h1 ? function(t1, e1, r1, i1) {
                    for(var s1 = 0; s1 < 4; ++s1){
                        var a1 = f1(e1, r1, i1);
                        if (0 === a1) return e1;
                        e1 -= (m1(e1, r1, i1) - t1) / a1;
                    }
                    return e1;
                }(t1, o1, e1, r1) : 0 === h1 ? o1 : function(t1, e1, r1, i1, s1) {
                    for(var a1, n1, o1 = 0; 0 < (a1 = m1(n1 = e1 + (r1 - e1) / 2, i1, s1) - t1) ? r1 = n1 : e1 = n1, 1e-7 < Math.abs(a1) && ++o1 < 10;);
                    return n1;
                }(t1, s1, s1 + p1, e1, r1);
            }
        }, t1;
    }();
    function extendPrototype(t1, e1) {
        var r1, i1, s1 = t1.length;
        for(r1 = 0; r1 < s1; r1 += 1)for(var a1 in i1 = t1[r1].prototype)Object.prototype.hasOwnProperty.call(i1, a1) && (e1.prototype[a1] = i1[a1]);
    }
    function getDescriptor(t1, e1) {
        return Object.getOwnPropertyDescriptor(t1, e1);
    }
    function createProxyFunction(t1) {
        function e1() {}
        return e1.prototype = t1, e1;
    }
    function bezFunction() {
        var D1 = Math;
        function y1(t1, e1, r1, i1, s1, a1) {
            var n1 = t1 * i1 + e1 * s1 + r1 * a1 - s1 * i1 - a1 * t1 - r1 * e1;
            return -0.001 < n1 && n1 < .001;
        }
        var p1 = function(t1, e1, r1, i1) {
            var s1, a1, n1, o1, h1, l1, p1 = defaultCurveSegments, m1 = 0, f1 = [], c1 = [], d1 = bezierLengthPool.newElement();
            for(n1 = r1.length, s1 = 0; s1 < p1; s1 += 1){
                for(h1 = s1 / (p1 - 1), a1 = l1 = 0; a1 < n1; a1 += 1)o1 = bmPow(1 - h1, 3) * t1[a1] + 3 * bmPow(1 - h1, 2) * h1 * r1[a1] + 3 * (1 - h1) * bmPow(h1, 2) * i1[a1] + bmPow(h1, 3) * e1[a1], f1[a1] = o1, null !== c1[a1] && (l1 += bmPow(f1[a1] - c1[a1], 2)), c1[a1] = f1[a1];
                l1 && (m1 += l1 = bmSqrt(l1)), d1.percents[s1] = h1, d1.lengths[s1] = m1;
            }
            return d1.addedLength = m1, d1;
        };
        function g1(t1) {
            this.segmentLength = 0, this.points = new Array(t1);
        }
        function v1(t1, e1) {
            this.partialLength = t1, this.point = e1;
        }
        var b1, t1 = (b1 = {}, function(t1, e1, r1, i1) {
            var s1 = (t1[0] + "_" + t1[1] + "_" + e1[0] + "_" + e1[1] + "_" + r1[0] + "_" + r1[1] + "_" + i1[0] + "_" + i1[1]).replace(/\./g, "p");
            if (!b1[s1]) {
                var a1, n1, o1, h1, l1, p1, m1, f1 = defaultCurveSegments, c1 = 0, d1 = null;
                2 === t1.length && (t1[0] !== e1[0] || t1[1] !== e1[1]) && y1(t1[0], t1[1], e1[0], e1[1], t1[0] + r1[0], t1[1] + r1[1]) && y1(t1[0], t1[1], e1[0], e1[1], e1[0] + i1[0], e1[1] + i1[1]) && (f1 = 2);
                var u1 = new g1(f1);
                for(o1 = r1.length, a1 = 0; a1 < f1; a1 += 1){
                    for(m1 = createSizedArray(o1), l1 = a1 / (f1 - 1), n1 = p1 = 0; n1 < o1; n1 += 1)h1 = bmPow(1 - l1, 3) * t1[n1] + 3 * bmPow(1 - l1, 2) * l1 * (t1[n1] + r1[n1]) + 3 * (1 - l1) * bmPow(l1, 2) * (e1[n1] + i1[n1]) + bmPow(l1, 3) * e1[n1], m1[n1] = h1, null !== d1 && (p1 += bmPow(m1[n1] - d1[n1], 2));
                    c1 += p1 = bmSqrt(p1), u1.points[a1] = new v1(p1, m1), d1 = m1;
                }
                u1.segmentLength = c1, b1[s1] = u1;
            }
            return b1[s1];
        });
        function M1(t1, e1) {
            var r1 = e1.percents, i1 = e1.lengths, s1 = r1.length, a1 = bmFloor((s1 - 1) * t1), n1 = t1 * e1.addedLength, o1 = 0;
            if (a1 === s1 - 1 || 0 === a1 || n1 === i1[a1]) return r1[a1];
            for(var h1 = i1[a1] > n1 ? -1 : 1, l1 = !0; l1;)if (i1[a1] <= n1 && i1[a1 + 1] > n1 ? (o1 = (n1 - i1[a1]) / (i1[a1 + 1] - i1[a1]), l1 = !1) : a1 += h1, a1 < 0 || s1 - 1 <= a1) {
                if (a1 === s1 - 1) return r1[a1];
                l1 = !1;
            }
            return r1[a1] + (r1[a1 + 1] - r1[a1]) * o1;
        }
        var F1 = createTypedArray("float32", 8);
        return {
            getSegmentsLength: function(t1) {
                var e1, r1 = segmentsLengthPool.newElement(), i1 = t1.c, s1 = t1.v, a1 = t1.o, n1 = t1.i, o1 = t1._length, h1 = r1.lengths, l1 = 0;
                for(e1 = 0; e1 < o1 - 1; e1 += 1)h1[e1] = p1(s1[e1], s1[e1 + 1], a1[e1], n1[e1 + 1]), l1 += h1[e1].addedLength;
                return i1 && o1 && (h1[e1] = p1(s1[e1], s1[0], a1[e1], n1[0]), l1 += h1[e1].addedLength), r1.totalLength = l1, r1;
            },
            getNewSegment: function(t1, e1, r1, i1, s1, a1, n1) {
                s1 < 0 ? s1 = 0 : 1 < s1 && (s1 = 1);
                var o1, h1 = M1(s1, n1), l1 = M1(a1 = 1 < a1 ? 1 : a1, n1), p1 = t1.length, m1 = 1 - h1, f1 = 1 - l1, c1 = m1 * m1 * m1, d1 = h1 * m1 * m1 * 3, u1 = h1 * h1 * m1 * 3, y1 = h1 * h1 * h1, g1 = m1 * m1 * f1, v1 = h1 * m1 * f1 + m1 * h1 * f1 + m1 * m1 * l1, b1 = h1 * h1 * f1 + m1 * h1 * l1 + h1 * m1 * l1, P1 = h1 * h1 * l1, E1 = m1 * f1 * f1, x1 = h1 * f1 * f1 + m1 * l1 * f1 + m1 * f1 * l1, S1 = h1 * l1 * f1 + m1 * l1 * l1 + h1 * f1 * l1, A1 = h1 * l1 * l1, C1 = f1 * f1 * f1, _1 = l1 * f1 * f1 + f1 * l1 * f1 + f1 * f1 * l1, T1 = l1 * l1 * f1 + f1 * l1 * l1 + l1 * f1 * l1, k1 = l1 * l1 * l1;
                for(o1 = 0; o1 < p1; o1 += 1)F1[4 * o1] = D1.round(1e3 * (c1 * t1[o1] + d1 * r1[o1] + u1 * i1[o1] + y1 * e1[o1])) / 1e3, F1[4 * o1 + 1] = D1.round(1e3 * (g1 * t1[o1] + v1 * r1[o1] + b1 * i1[o1] + P1 * e1[o1])) / 1e3, F1[4 * o1 + 2] = D1.round(1e3 * (E1 * t1[o1] + x1 * r1[o1] + S1 * i1[o1] + A1 * e1[o1])) / 1e3, F1[4 * o1 + 3] = D1.round(1e3 * (C1 * t1[o1] + _1 * r1[o1] + T1 * i1[o1] + k1 * e1[o1])) / 1e3;
                return F1;
            },
            getPointInSegment: function(t1, e1, r1, i1, s1, a1) {
                var n1 = M1(s1, a1), o1 = 1 - n1;
                return [
                    D1.round(1e3 * (o1 * o1 * o1 * t1[0] + (n1 * o1 * o1 + o1 * n1 * o1 + o1 * o1 * n1) * r1[0] + (n1 * n1 * o1 + o1 * n1 * n1 + n1 * o1 * n1) * i1[0] + n1 * n1 * n1 * e1[0])) / 1e3,
                    D1.round(1e3 * (o1 * o1 * o1 * t1[1] + (n1 * o1 * o1 + o1 * n1 * o1 + o1 * o1 * n1) * r1[1] + (n1 * n1 * o1 + o1 * n1 * n1 + n1 * o1 * n1) * i1[1] + n1 * n1 * n1 * e1[1])) / 1e3
                ];
            },
            buildBezierData: t1,
            pointOnLine2D: y1,
            pointOnLine3D: function(t1, e1, r1, i1, s1, a1, n1, o1, h1) {
                if (0 === r1 && 0 === a1 && 0 === h1) return y1(t1, e1, i1, s1, n1, o1);
                var l1, p1 = D1.sqrt(D1.pow(i1 - t1, 2) + D1.pow(s1 - e1, 2) + D1.pow(a1 - r1, 2)), m1 = D1.sqrt(D1.pow(n1 - t1, 2) + D1.pow(o1 - e1, 2) + D1.pow(h1 - r1, 2)), f1 = D1.sqrt(D1.pow(n1 - i1, 2) + D1.pow(o1 - s1, 2) + D1.pow(h1 - a1, 2));
                return -0.0001 < (l1 = m1 < p1 ? f1 < p1 ? p1 - m1 - f1 : f1 - m1 - p1 : m1 < f1 ? f1 - m1 - p1 : m1 - p1 - f1) && l1 < 1e-4;
            }
        };
    }
    !function() {
        for(var s1 = 0, t1 = [
            "ms",
            "moz",
            "webkit",
            "o"
        ], e1 = 0; e1 < t1.length && !window.requestAnimationFrame; ++e1)window.requestAnimationFrame = window[t1[e1] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[t1[e1] + "CancelAnimationFrame"] || window[t1[e1] + "CancelRequestAnimationFrame"];
        window.requestAnimationFrame || (window.requestAnimationFrame = function(t1) {
            var e1 = (new Date).getTime(), r1 = Math.max(0, 16 - (e1 - s1)), i1 = setTimeout(function() {
                t1(e1 + r1);
            }, r1);
            return s1 = e1 + r1, i1;
        }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(t1) {
            clearTimeout(t1);
        });
    }();
    var bez = bezFunction();
    function dataFunctionManager() {
        function m1(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1, l1 = t1.length;
            for(s1 = 0; s1 < l1; s1 += 1)if ("ks" in (i1 = t1[s1]) && !i1.completed) {
                if (i1.completed = !0, i1.tt && (t1[s1 - 1].td = i1.tt), i1.hasMask) {
                    var p1 = i1.masksProperties;
                    for(n1 = p1.length, a1 = 0; a1 < n1; a1 += 1)if (p1[a1].pt.k.i) d1(p1[a1].pt.k);
                    else for(h1 = p1[a1].pt.k.length, o1 = 0; o1 < h1; o1 += 1)p1[a1].pt.k[o1].s && d1(p1[a1].pt.k[o1].s[0]), p1[a1].pt.k[o1].e && d1(p1[a1].pt.k[o1].e[0]);
                }
                0 === i1.ty ? (i1.layers = f1(i1.refId, e1), m1(i1.layers, e1, r1)) : 4 === i1.ty ? c1(i1.shapes) : 5 === i1.ty && u1(i1);
            }
        }
        function f1(t1, e1) {
            for(var r1 = 0, i1 = e1.length; r1 < i1;){
                if (e1[r1].id === t1) return e1[r1].layers.__used ? JSON.parse(JSON.stringify(e1[r1].layers)) : (e1[r1].layers.__used = !0, e1[r1].layers);
                r1 += 1;
            }
            return null;
        }
        function c1(t1) {
            var e1, r1, i1;
            for(e1 = t1.length - 1; 0 <= e1; e1 -= 1)if ("sh" === t1[e1].ty) {
                if (t1[e1].ks.k.i) d1(t1[e1].ks.k);
                else for(i1 = t1[e1].ks.k.length, r1 = 0; r1 < i1; r1 += 1)t1[e1].ks.k[r1].s && d1(t1[e1].ks.k[r1].s[0]), t1[e1].ks.k[r1].e && d1(t1[e1].ks.k[r1].e[0]);
            } else "gr" === t1[e1].ty && c1(t1[e1].it);
        }
        function d1(t1) {
            var e1, r1 = t1.i.length;
            for(e1 = 0; e1 < r1; e1 += 1)t1.i[e1][0] += t1.v[e1][0], t1.i[e1][1] += t1.v[e1][1], t1.o[e1][0] += t1.v[e1][0], t1.o[e1][1] += t1.v[e1][1];
        }
        function o1(t1, e1) {
            var r1 = e1 ? e1.split(".") : [
                100,
                100,
                100
            ];
            return t1[0] > r1[0] || !(r1[0] > t1[0]) && (t1[1] > r1[1] || !(r1[1] > t1[1]) && (t1[2] > r1[2] || !(r1[2] > t1[2]) && null));
        }
        var h1, r1 = function() {
            var i1 = [
                4,
                4,
                14
            ];
            function s1(t1) {
                var e1, r1, i1, s1 = t1.length;
                for(e1 = 0; e1 < s1; e1 += 1)5 === t1[e1].ty && (r1 = t1[e1], i1 = r1.t.d, r1.t.d = {
                    k: [
                        {
                            s: i1,
                            t: 0
                        }
                    ]
                });
            }
            return function(t1) {
                if (o1(i1, t1.v) && (s1(t1.layers), t1.assets)) {
                    var e1, r1 = t1.assets.length;
                    for(e1 = 0; e1 < r1; e1 += 1)t1.assets[e1].layers && s1(t1.assets[e1].layers);
                }
            };
        }(), i1 = (h1 = [
            4,
            7,
            99
        ], function(t1) {
            if (t1.chars && !o1(h1, t1.v)) {
                var e1, r1, i1, s1, a1, n1 = t1.chars.length;
                for(e1 = 0; e1 < n1; e1 += 1)if (t1.chars[e1].data && t1.chars[e1].data.shapes) for(i1 = (a1 = t1.chars[e1].data.shapes[0].it).length, r1 = 0; r1 < i1; r1 += 1)(s1 = a1[r1].ks.k).__converted || (d1(a1[r1].ks.k), s1.__converted = !0);
            }
        }), s1 = function() {
            var i1 = [
                4,
                1,
                9
            ];
            function a1(t1) {
                var e1, r1, i1, s1 = t1.length;
                for(e1 = 0; e1 < s1; e1 += 1)if ("gr" === t1[e1].ty) a1(t1[e1].it);
                else if ("fl" === t1[e1].ty || "st" === t1[e1].ty) {
                    if (t1[e1].c.k && t1[e1].c.k[0].i) for(i1 = t1[e1].c.k.length, r1 = 0; r1 < i1; r1 += 1)t1[e1].c.k[r1].s && (t1[e1].c.k[r1].s[0] /= 255, t1[e1].c.k[r1].s[1] /= 255, t1[e1].c.k[r1].s[2] /= 255, t1[e1].c.k[r1].s[3] /= 255), t1[e1].c.k[r1].e && (t1[e1].c.k[r1].e[0] /= 255, t1[e1].c.k[r1].e[1] /= 255, t1[e1].c.k[r1].e[2] /= 255, t1[e1].c.k[r1].e[3] /= 255);
                    else t1[e1].c.k[0] /= 255, t1[e1].c.k[1] /= 255, t1[e1].c.k[2] /= 255, t1[e1].c.k[3] /= 255;
                }
            }
            function s1(t1) {
                var e1, r1 = t1.length;
                for(e1 = 0; e1 < r1; e1 += 1)4 === t1[e1].ty && a1(t1[e1].shapes);
            }
            return function(t1) {
                if (o1(i1, t1.v) && (s1(t1.layers), t1.assets)) {
                    var e1, r1 = t1.assets.length;
                    for(e1 = 0; e1 < r1; e1 += 1)t1.assets[e1].layers && s1(t1.assets[e1].layers);
                }
            };
        }(), a1 = function() {
            var i1 = [
                4,
                4,
                18
            ];
            function l1(t1) {
                var e1, r1, i1;
                for(e1 = t1.length - 1; 0 <= e1; e1 -= 1)if ("sh" === t1[e1].ty) {
                    if (t1[e1].ks.k.i) t1[e1].ks.k.c = t1[e1].closed;
                    else for(i1 = t1[e1].ks.k.length, r1 = 0; r1 < i1; r1 += 1)t1[e1].ks.k[r1].s && (t1[e1].ks.k[r1].s[0].c = t1[e1].closed), t1[e1].ks.k[r1].e && (t1[e1].ks.k[r1].e[0].c = t1[e1].closed);
                } else "gr" === t1[e1].ty && l1(t1[e1].it);
            }
            function s1(t1) {
                var e1, r1, i1, s1, a1, n1, o1 = t1.length;
                for(r1 = 0; r1 < o1; r1 += 1){
                    if ((e1 = t1[r1]).hasMask) {
                        var h1 = e1.masksProperties;
                        for(s1 = h1.length, i1 = 0; i1 < s1; i1 += 1)if (h1[i1].pt.k.i) h1[i1].pt.k.c = h1[i1].cl;
                        else for(n1 = h1[i1].pt.k.length, a1 = 0; a1 < n1; a1 += 1)h1[i1].pt.k[a1].s && (h1[i1].pt.k[a1].s[0].c = h1[i1].cl), h1[i1].pt.k[a1].e && (h1[i1].pt.k[a1].e[0].c = h1[i1].cl);
                    }
                    4 === e1.ty && l1(e1.shapes);
                }
            }
            return function(t1) {
                if (o1(i1, t1.v) && (s1(t1.layers), t1.assets)) {
                    var e1, r1 = t1.assets.length;
                    for(e1 = 0; e1 < r1; e1 += 1)t1.assets[e1].layers && s1(t1.assets[e1].layers);
                }
            };
        }();
        function u1(t1) {
            0 !== t1.t.a.length || "m" in t1.t.p || (t1.singleShape = !0);
        }
        var t1 = {
            completeData: function(t1, e1) {
                t1.__complete || (s1(t1), r1(t1), i1(t1), a1(t1), m1(t1.layers, t1.assets, e1), t1.__complete = !0);
            }
        };
        return t1.checkColors = s1, t1.checkChars = i1, t1.checkShapes = a1, t1.completeLayers = m1, t1;
    }
    var dataManager = dataFunctionManager();
    function getFontProperties(t1) {
        for(var e1 = t1.fStyle ? t1.fStyle.split(" ") : [], r1 = "normal", i1 = "normal", s1 = e1.length, a1 = 0; a1 < s1; a1 += 1)switch(e1[a1].toLowerCase()){
            case "italic":
                i1 = "italic";
                break;
            case "bold":
                r1 = "700";
                break;
            case "black":
                r1 = "900";
                break;
            case "medium":
                r1 = "500";
                break;
            case "regular":
            case "normal":
                r1 = "400";
                break;
            case "light":
            case "thin":
                r1 = "200";
        }
        return {
            style: i1,
            weight: t1.fWeight || r1
        };
    }
    var FontManager = function() {
        var a1 = {
            w: 0,
            size: 0,
            shapes: []
        }, t1 = [];
        function f1(t1, e1) {
            var r1 = createTag("span");
            r1.setAttribute("aria-hidden", !0), r1.style.fontFamily = e1;
            var i1 = createTag("span");
            i1.innerText = "giItT1WQy@!-/#", r1.style.position = "absolute", r1.style.left = "-10000px", r1.style.top = "-10000px", r1.style.fontSize = "300px", r1.style.fontVariant = "normal", r1.style.fontStyle = "normal", r1.style.fontWeight = "normal", r1.style.letterSpacing = "0", r1.appendChild(i1), document.body.appendChild(r1);
            var s1 = i1.offsetWidth;
            return i1.style.fontFamily = function(t1) {
                var e1, r1 = t1.split(","), i1 = r1.length, s1 = [];
                for(e1 = 0; e1 < i1; e1 += 1)"sans-serif" !== r1[e1] && "monospace" !== r1[e1] && s1.push(r1[e1]);
                return s1.join(",");
            }(t1) + ", " + e1, {
                node: i1,
                w: s1,
                parent: r1
            };
        }
        function c1(t1, e1) {
            var r1 = createNS("text");
            r1.style.fontSize = "100px";
            var i1 = getFontProperties(e1);
            return r1.setAttribute("font-family", e1.fFamily), r1.setAttribute("font-style", i1.style), r1.setAttribute("font-weight", i1.weight), r1.textContent = "1", e1.fClass ? (r1.style.fontFamily = "inherit", r1.setAttribute("class", e1.fClass)) : r1.style.fontFamily = e1.fFamily, t1.appendChild(r1), createTag("canvas").getContext("2d").font = e1.fWeight + " " + e1.fStyle + " 100px " + e1.fFamily, r1;
        }
        t1 = t1.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var e1 = function() {
            this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        return e1.getCombinedCharacterCodes = function() {
            return t1;
        }, e1.prototype = {
            addChars: function(t1) {
                if (t1) {
                    var e1;
                    this.chars || (this.chars = []);
                    var r1, i1, s1 = t1.length, a1 = this.chars.length;
                    for(e1 = 0; e1 < s1; e1 += 1){
                        for(r1 = 0, i1 = !1; r1 < a1;)this.chars[r1].style === t1[e1].style && this.chars[r1].fFamily === t1[e1].fFamily && this.chars[r1].ch === t1[e1].ch && (i1 = !0), r1 += 1;
                        i1 || (this.chars.push(t1[e1]), a1 += 1);
                    }
                }
            },
            addFonts: function(t1, e1) {
                if (t1) {
                    if (this.chars) return this.isLoaded = !0, void (this.fonts = t1.list);
                    var r1, i1 = t1.list, s1 = i1.length, a1 = s1;
                    for(r1 = 0; r1 < s1; r1 += 1){
                        var n1, o1, h1 = !0;
                        if (i1[r1].loaded = !1, i1[r1].monoCase = f1(i1[r1].fFamily, "monospace"), i1[r1].sansCase = f1(i1[r1].fFamily, "sans-serif"), i1[r1].fPath) {
                            if ("p" === i1[r1].fOrigin || 3 === i1[r1].origin) {
                                if (0 < (n1 = document.querySelectorAll('style[f-forigin="p"][f-family="' + i1[r1].fFamily + '"], style[f-origin="3"][f-family="' + i1[r1].fFamily + '"]')).length && (h1 = !1), h1) {
                                    var l1 = createTag("style");
                                    l1.setAttribute("f-forigin", i1[r1].fOrigin), l1.setAttribute("f-origin", i1[r1].origin), l1.setAttribute("f-family", i1[r1].fFamily), l1.type = "text/css", l1.innerText = "@font-face {font-family: " + i1[r1].fFamily + "; font-style: normal; src: url('" + i1[r1].fPath + "');}", e1.appendChild(l1);
                                }
                            } else if ("g" === i1[r1].fOrigin || 1 === i1[r1].origin) {
                                for(n1 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), o1 = 0; o1 < n1.length; o1 += 1)-1 !== n1[o1].href.indexOf(i1[r1].fPath) && (h1 = !1);
                                if (h1) {
                                    var p1 = createTag("link");
                                    p1.setAttribute("f-forigin", i1[r1].fOrigin), p1.setAttribute("f-origin", i1[r1].origin), p1.type = "text/css", p1.rel = "stylesheet", p1.href = i1[r1].fPath, document.body.appendChild(p1);
                                }
                            } else if ("t" === i1[r1].fOrigin || 2 === i1[r1].origin) {
                                for(n1 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), o1 = 0; o1 < n1.length; o1 += 1)i1[r1].fPath === n1[o1].src && (h1 = !1);
                                if (h1) {
                                    var m1 = createTag("link");
                                    m1.setAttribute("f-forigin", i1[r1].fOrigin), m1.setAttribute("f-origin", i1[r1].origin), m1.setAttribute("rel", "stylesheet"), m1.setAttribute("href", i1[r1].fPath), e1.appendChild(m1);
                                }
                            }
                        } else i1[r1].loaded = !0, a1 -= 1;
                        i1[r1].helper = c1(e1, i1[r1]), i1[r1].cache = {}, this.fonts.push(i1[r1]);
                    }
                    0 === a1 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                } else this.isLoaded = !0;
            },
            getCharData: function(t1, e1, r1) {
                for(var i1 = 0, s1 = this.chars.length; i1 < s1;){
                    if (this.chars[i1].ch === t1 && this.chars[i1].style === e1 && this.chars[i1].fFamily === r1) return this.chars[i1];
                    i1 += 1;
                }
                return ("string" == typeof t1 && 13 !== t1.charCodeAt(0) || !t1) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", t1, e1, r1)), a1;
            },
            getFontByName: function(t1) {
                for(var e1 = 0, r1 = this.fonts.length; e1 < r1;){
                    if (this.fonts[e1].fName === t1) return this.fonts[e1];
                    e1 += 1;
                }
                return this.fonts[0];
            },
            measureText: function(t1, e1, r1) {
                var i1 = this.getFontByName(e1), s1 = t1.charCodeAt(0);
                if (!i1.cache[s1 + 1]) {
                    var a1 = i1.helper;
                    if (" " === t1) {
                        a1.textContent = "|" + t1 + "|";
                        var n1 = a1.getComputedTextLength();
                        a1.textContent = "||";
                        var o1 = a1.getComputedTextLength();
                        i1.cache[s1 + 1] = (n1 - o1) / 100;
                    } else a1.textContent = t1, i1.cache[s1 + 1] = a1.getComputedTextLength() / 100;
                }
                return i1.cache[s1 + 1] * r1;
            },
            checkLoadedFonts: function() {
                var t1, e1, r1, i1 = this.fonts.length, s1 = i1;
                for(t1 = 0; t1 < i1; t1 += 1)this.fonts[t1].loaded ? s1 -= 1 : "n" === this.fonts[t1].fOrigin || 0 === this.fonts[t1].origin ? this.fonts[t1].loaded = !0 : (e1 = this.fonts[t1].monoCase.node, r1 = this.fonts[t1].monoCase.w, e1.offsetWidth !== r1 ? (s1 -= 1, this.fonts[t1].loaded = !0) : (e1 = this.fonts[t1].sansCase.node, r1 = this.fonts[t1].sansCase.w, e1.offsetWidth !== r1 && (s1 -= 1, this.fonts[t1].loaded = !0)), this.fonts[t1].loaded && (this.fonts[t1].sansCase.parent.parentNode.removeChild(this.fonts[t1].sansCase.parent), this.fonts[t1].monoCase.parent.parentNode.removeChild(this.fonts[t1].monoCase.parent)));
                0 !== s1 && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
            },
            setIsLoaded: function() {
                this.isLoaded = !0;
            }
        }, e1;
    }(), PropertyFactory = function() {
        var m1 = initialDefaultFrame, s1 = Math.abs;
        function f1(t1, e1) {
            var r1, i1 = this.offsetTime;
            "multidimensional" === this.propType && (r1 = createTypedArray("float32", this.pv.length));
            for(var s1, a1, n1, o1, h1, l1, p1, m1, f1 = e1.lastIndex, c1 = f1, d1 = this.keyframes.length - 1, u1 = !0; u1;){
                if (s1 = this.keyframes[c1], a1 = this.keyframes[c1 + 1], c1 === d1 - 1 && t1 >= a1.t - i1) {
                    s1.h && (s1 = a1), f1 = 0;
                    break;
                }
                if (a1.t - i1 > t1) {
                    f1 = c1;
                    break;
                }
                c1 < d1 - 1 ? c1 += 1 : (f1 = 0, u1 = !1);
            }
            var y1, g1, v1, b1, P1, E1, x1, S1, A1, C1, _1 = a1.t - i1, T1 = s1.t - i1;
            if (s1.to) {
                s1.bezierData || (s1.bezierData = bez.buildBezierData(s1.s, a1.s || s1.e, s1.to, s1.ti));
                var k1 = s1.bezierData;
                if (_1 <= t1 || t1 < T1) {
                    var D1 = _1 <= t1 ? k1.points.length - 1 : 0;
                    for(o1 = k1.points[D1].point.length, n1 = 0; n1 < o1; n1 += 1)r1[n1] = k1.points[D1].point[n1];
                } else {
                    s1.__fnct ? m1 = s1.__fnct : (m1 = BezierFactory.getBezierEasing(s1.o.x, s1.o.y, s1.i.x, s1.i.y, s1.n).get, s1.__fnct = m1), h1 = m1((t1 - T1) / (_1 - T1));
                    var M1, F1 = k1.segmentLength * h1, w1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === c1 ? e1._lastAddedLength : 0;
                    for(p1 = e1.lastFrame < t1 && e1._lastKeyframeIndex === c1 ? e1._lastPoint : 0, u1 = !0, l1 = k1.points.length; u1;){
                        if (w1 += k1.points[p1].partialLength, 0 === F1 || 0 === h1 || p1 === k1.points.length - 1) {
                            for(o1 = k1.points[p1].point.length, n1 = 0; n1 < o1; n1 += 1)r1[n1] = k1.points[p1].point[n1];
                            break;
                        }
                        if (w1 <= F1 && F1 < w1 + k1.points[p1 + 1].partialLength) {
                            for(M1 = (F1 - w1) / k1.points[p1 + 1].partialLength, o1 = k1.points[p1].point.length, n1 = 0; n1 < o1; n1 += 1)r1[n1] = k1.points[p1].point[n1] + (k1.points[p1 + 1].point[n1] - k1.points[p1].point[n1]) * M1;
                            break;
                        }
                        p1 < l1 - 1 ? p1 += 1 : u1 = !1;
                    }
                    e1._lastPoint = p1, e1._lastAddedLength = w1 - k1.points[p1].partialLength, e1._lastKeyframeIndex = c1;
                }
            } else {
                var I1, V1, B1, R1, L1;
                if (d1 = s1.s.length, y1 = a1.s || s1.e, this.sh && 1 !== s1.h) {
                    if (_1 <= t1) r1[0] = y1[0], r1[1] = y1[1], r1[2] = y1[2];
                    else if (t1 <= T1) r1[0] = s1.s[0], r1[1] = s1.s[1], r1[2] = s1.s[2];
                    else {
                        var G1 = N1(s1.s), z1 = N1(y1);
                        g1 = r1, v1 = function(t1, e1, r1) {
                            var i1, s1, a1, n1, o1, h1 = [], l1 = t1[0], p1 = t1[1], m1 = t1[2], f1 = t1[3], c1 = e1[0], d1 = e1[1], u1 = e1[2], y1 = e1[3];
                            (s1 = l1 * c1 + p1 * d1 + m1 * u1 + f1 * y1) < 0 && (s1 = -s1, c1 = -c1, d1 = -d1, u1 = -u1, y1 = -y1);
                            o1 = 1e-6 < 1 - s1 ? (i1 = Math.acos(s1), a1 = Math.sin(i1), n1 = Math.sin((1 - r1) * i1) / a1, Math.sin(r1 * i1) / a1) : (n1 = 1 - r1, r1);
                            return h1[0] = n1 * l1 + o1 * c1, h1[1] = n1 * p1 + o1 * d1, h1[2] = n1 * m1 + o1 * u1, h1[3] = n1 * f1 + o1 * y1, h1;
                        }(G1, z1, (t1 - T1) / (_1 - T1)), b1 = v1[0], P1 = v1[1], E1 = v1[2], x1 = v1[3], S1 = Math.atan2(2 * P1 * x1 - 2 * b1 * E1, 1 - 2 * P1 * P1 - 2 * E1 * E1), A1 = Math.asin(2 * b1 * P1 + 2 * E1 * x1), C1 = Math.atan2(2 * b1 * x1 - 2 * P1 * E1, 1 - 2 * b1 * b1 - 2 * E1 * E1), g1[0] = S1 / degToRads, g1[1] = A1 / degToRads, g1[2] = C1 / degToRads;
                    }
                } else for(c1 = 0; c1 < d1; c1 += 1)1 !== s1.h && (h1 = _1 <= t1 ? 1 : t1 < T1 ? 0 : (s1.o.x.constructor === Array ? (s1.__fnct || (s1.__fnct = []), s1.__fnct[c1] ? m1 = s1.__fnct[c1] : (I1 = void 0 === s1.o.x[c1] ? s1.o.x[0] : s1.o.x[c1], V1 = void 0 === s1.o.y[c1] ? s1.o.y[0] : s1.o.y[c1], B1 = void 0 === s1.i.x[c1] ? s1.i.x[0] : s1.i.x[c1], R1 = void 0 === s1.i.y[c1] ? s1.i.y[0] : s1.i.y[c1], m1 = BezierFactory.getBezierEasing(I1, V1, B1, R1).get, s1.__fnct[c1] = m1)) : s1.__fnct ? m1 = s1.__fnct : (I1 = s1.o.x, V1 = s1.o.y, B1 = s1.i.x, R1 = s1.i.y, m1 = BezierFactory.getBezierEasing(I1, V1, B1, R1).get, s1.__fnct = m1), m1((t1 - T1) / (_1 - T1)))), y1 = a1.s || s1.e, L1 = 1 === s1.h ? s1.s[c1] : s1.s[c1] + (y1[c1] - s1.s[c1]) * h1, "multidimensional" === this.propType ? r1[c1] = L1 : r1 = L1;
            }
            return e1.lastIndex = f1, r1;
        }
        function N1(t1) {
            var e1 = t1[0] * degToRads, r1 = t1[1] * degToRads, i1 = t1[2] * degToRads, s1 = Math.cos(e1 / 2), a1 = Math.cos(r1 / 2), n1 = Math.cos(i1 / 2), o1 = Math.sin(e1 / 2), h1 = Math.sin(r1 / 2), l1 = Math.sin(i1 / 2);
            return [
                o1 * h1 * n1 + s1 * a1 * l1,
                o1 * a1 * n1 + s1 * h1 * l1,
                s1 * h1 * n1 - o1 * a1 * l1,
                s1 * a1 * n1 - o1 * h1 * l1
            ];
        }
        function c1() {
            var t1 = this.comp.renderedFrame - this.offsetTime, e1 = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t1 === this._caching.lastFrame || this._caching.lastFrame !== m1 && (this._caching.lastFrame >= r1 && r1 <= t1 || this._caching.lastFrame < e1 && t1 < e1))) {
                this._caching.lastFrame >= t1 && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var i1 = this.interpolateValue(t1, this._caching);
                this.pv = i1;
            }
            return this._caching.lastFrame = t1, this.pv;
        }
        function d1(t1) {
            var e1;
            if ("unidimensional" === this.propType) e1 = t1 * this.mult, 1e-5 < s1(this.v - e1) && (this.v = e1, this._mdf = !0);
            else for(var r1 = 0, i1 = this.v.length; r1 < i1;)e1 = t1[r1] * this.mult, 1e-5 < s1(this.v[r1] - e1) && (this.v[r1] = e1, this._mdf = !0), r1 += 1;
        }
        function u1() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t1;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e1 = this.effectsSequence.length, r1 = this.kf ? this.pv : this.data.k;
                    for(t1 = 0; t1 < e1; t1 += 1)r1 = this.effectsSequence[t1](r1);
                    this.setVValue(r1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function y1(t1) {
            this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
        }
        function n1(t1, e1, r1, i1) {
            this.propType = "unidimensional", this.mult = r1 || 1, this.data = e1, this.v = r1 ? e1.k * r1 : e1.k, this.pv = e1.k, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = u1, this.setVValue = d1, this.addEffect = y1;
        }
        function o1(t1, e1, r1, i1) {
            var s1;
            this.propType = "multidimensional", this.mult = r1 || 1, this.data = e1, this._mdf = !1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var a1 = e1.k.length;
            for(this.v = createTypedArray("float32", a1), this.pv = createTypedArray("float32", a1), this.vel = createTypedArray("float32", a1), s1 = 0; s1 < a1; s1 += 1)this.v[s1] = e1.k[s1] * this.mult, this.pv[s1] = e1.k[s1];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = u1, this.setVValue = d1, this.addEffect = y1;
        }
        function h1(t1, e1, r1, i1) {
            this.propType = "unidimensional", this.keyframes = e1.k, this.offsetTime = t1.data.st, this.frameId = -1, this._caching = {
                lastFrame: m1,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e1, this.mult = r1 || 1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.v = m1, this.pv = m1, this._isFirstFrame = !0, this.getValue = u1, this.setVValue = d1, this.interpolateValue = f1, this.effectsSequence = [
                c1.bind(this)
            ], this.addEffect = y1;
        }
        function l1(t1, e1, r1, i1) {
            var s1;
            this.propType = "multidimensional";
            var a1, n1, o1, h1, l1 = e1.k.length;
            for(s1 = 0; s1 < l1 - 1; s1 += 1)e1.k[s1].to && e1.k[s1].s && e1.k[s1 + 1] && e1.k[s1 + 1].s && (a1 = e1.k[s1].s, n1 = e1.k[s1 + 1].s, o1 = e1.k[s1].to, h1 = e1.k[s1].ti, (2 === a1.length && (a1[0] !== n1[0] || a1[1] !== n1[1]) && bez.pointOnLine2D(a1[0], a1[1], n1[0], n1[1], a1[0] + o1[0], a1[1] + o1[1]) && bez.pointOnLine2D(a1[0], a1[1], n1[0], n1[1], n1[0] + h1[0], n1[1] + h1[1]) || 3 === a1.length && (a1[0] !== n1[0] || a1[1] !== n1[1] || a1[2] !== n1[2]) && bez.pointOnLine3D(a1[0], a1[1], a1[2], n1[0], n1[1], n1[2], a1[0] + o1[0], a1[1] + o1[1], a1[2] + o1[2]) && bez.pointOnLine3D(a1[0], a1[1], a1[2], n1[0], n1[1], n1[2], n1[0] + h1[0], n1[1] + h1[1], n1[2] + h1[2])) && (e1.k[s1].to = null, e1.k[s1].ti = null), a1[0] === n1[0] && a1[1] === n1[1] && 0 === o1[0] && 0 === o1[1] && 0 === h1[0] && 0 === h1[1] && (2 === a1.length || a1[2] === n1[2] && 0 === o1[2] && 0 === h1[2]) && (e1.k[s1].to = null, e1.k[s1].ti = null));
            this.effectsSequence = [
                c1.bind(this)
            ], this.data = e1, this.keyframes = e1.k, this.offsetTime = t1.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r1 || 1, this.elem = t1, this.container = i1, this.comp = t1.comp, this.getValue = u1, this.setVValue = d1, this.interpolateValue = f1, this.frameId = -1;
            var p1 = e1.k[0].s.length;
            for(this.v = createTypedArray("float32", p1), this.pv = createTypedArray("float32", p1), s1 = 0; s1 < p1; s1 += 1)this.v[s1] = m1, this.pv[s1] = m1;
            this._caching = {
                lastFrame: m1,
                lastIndex: 0,
                value: createTypedArray("float32", p1)
            }, this.addEffect = y1;
        }
        return {
            getProp: function(t1, e1, r1, i1, s1) {
                var a1;
                if (e1.k.length) {
                    if ("number" == typeof e1.k[0]) a1 = new o1(t1, e1, i1, s1);
                    else switch(r1){
                        case 0:
                            a1 = new h1(t1, e1, i1, s1);
                            break;
                        case 1:
                            a1 = new l1(t1, e1, i1, s1);
                    }
                } else a1 = new n1(t1, e1, i1, s1);
                return a1.effectsSequence.length && s1.addDynamicProperty(a1), a1;
            }
        };
    }(), TransformPropertyFactory = function() {
        var n1 = [
            0,
            0
        ];
        function i1(t1, e1, r1) {
            if (this.elem = t1, this.frameId = -1, this.propType = "transform", this.data = e1, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r1 || t1), e1.p && e1.p.s ? (this.px = PropertyFactory.getProp(t1, e1.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t1, e1.p.y, 0, 0, this), e1.p.z && (this.pz = PropertyFactory.getProp(t1, e1.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t1, e1.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this), e1.rx) {
                if (this.rx = PropertyFactory.getProp(t1, e1.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t1, e1.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t1, e1.rz, 0, degToRads, this), e1.or.k[0].ti) {
                    var i1, s1 = e1.or.k.length;
                    for(i1 = 0; i1 < s1; i1 += 1)e1.or.k[i1].to = null, e1.or.k[i1].ti = null;
                }
                this.or = PropertyFactory.getProp(t1, e1.or, 1, degToRads, this), this.or.sh = !0;
            } else this.r = PropertyFactory.getProp(t1, e1.r || {
                k: 0
            }, 0, degToRads, this);
            e1.sk && (this.sk = PropertyFactory.getProp(t1, e1.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t1, e1.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t1, e1.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, .01, this), e1.o ? this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, t1) : this.o = {
                _mdf: !1,
                v: 1
            }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
        }
        return i1.prototype = {
            applyToMatrix: function(t1) {
                var e1 = this._mdf;
                this.iterateDynamicProperties(), this._mdf = this._mdf || e1, this.a && t1.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t1.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t1.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t1.rotate(-this.r.v) : t1.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t1.translate(this.px.v, this.py.v, -this.pz.v) : t1.translate(this.px.v, this.py.v, 0) : t1.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            },
            getValue: function(t1) {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || t1) {
                        var e1;
                        if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                            var r1, i1;
                            if (e1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) i1 = this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (r1 = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / e1, 0), this.p.getValueAtTime(this.p.keyframes[0].t / e1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (r1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / e1, 0), this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / e1, 0)) : (r1 = this.p.pv, this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / e1, this.p.offsetTime));
                            else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                r1 = [], i1 = [];
                                var s1 = this.px, a1 = this.py;
                                s1._caching.lastFrame + s1.offsetTime <= s1.keyframes[0].t ? (r1[0] = s1.getValueAtTime((s1.keyframes[0].t + .01) / e1, 0), r1[1] = a1.getValueAtTime((a1.keyframes[0].t + .01) / e1, 0), i1[0] = s1.getValueAtTime(s1.keyframes[0].t / e1, 0), i1[1] = a1.getValueAtTime(a1.keyframes[0].t / e1, 0)) : s1._caching.lastFrame + s1.offsetTime >= s1.keyframes[s1.keyframes.length - 1].t ? (r1[0] = s1.getValueAtTime(s1.keyframes[s1.keyframes.length - 1].t / e1, 0), r1[1] = a1.getValueAtTime(a1.keyframes[a1.keyframes.length - 1].t / e1, 0), i1[0] = s1.getValueAtTime((s1.keyframes[s1.keyframes.length - 1].t - .01) / e1, 0), i1[1] = a1.getValueAtTime((a1.keyframes[a1.keyframes.length - 1].t - .01) / e1, 0)) : (r1 = [
                                    s1.pv,
                                    a1.pv
                                ], i1[0] = s1.getValueAtTime((s1._caching.lastFrame + s1.offsetTime - .01) / e1, s1.offsetTime), i1[1] = a1.getValueAtTime((a1._caching.lastFrame + a1.offsetTime - .01) / e1, a1.offsetTime));
                            } else r1 = i1 = n1;
                            this.v.rotate(-Math.atan2(r1[1] - i1[1], r1[0] - i1[0]));
                        }
                        this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                    }
                    this.frameId = this.elem.globalData.frameId;
                }
            },
            precalculateMatrix: function() {
                if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                    if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                        if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                        this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                    }
                    this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                }
            },
            autoOrient: function() {}
        }, extendPrototype([
            DynamicPropertyContainer
        ], i1), i1.prototype.addDynamicProperty = function(t1) {
            this._addDynamicProperty(t1), this.elem.addDynamicProperty(t1), this._isDirty = !0;
        }, i1.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
            getTransformProperty: function(t1, e1, r1) {
                return new i1(t1, e1, r1);
            }
        };
    }();
    function ShapePath() {
        this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(t1, e1) {
        this.c = t1, this.setLength(e1);
        for(var r1 = 0; r1 < e1;)this.v[r1] = pointPool.newElement(), this.o[r1] = pointPool.newElement(), this.i[r1] = pointPool.newElement(), r1 += 1;
    }, ShapePath.prototype.setLength = function(t1) {
        for(; this._maxLength < t1;)this.doubleArrayLength();
        this._length = t1;
    }, ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(t1, e1, r1, i1, s1) {
        var a1;
        switch(this._length = Math.max(this._length, i1 + 1), this._length >= this._maxLength && this.doubleArrayLength(), r1){
            case "v":
                a1 = this.v;
                break;
            case "i":
                a1 = this.i;
                break;
            case "o":
                a1 = this.o;
                break;
            default:
                a1 = [];
        }
        (!a1[i1] || a1[i1] && !s1) && (a1[i1] = pointPool.newElement()), a1[i1][0] = t1, a1[i1][1] = e1;
    }, ShapePath.prototype.setTripleAt = function(t1, e1, r1, i1, s1, a1, n1, o1) {
        this.setXYAt(t1, e1, "v", n1, o1), this.setXYAt(r1, i1, "o", n1, o1), this.setXYAt(s1, a1, "i", n1, o1);
    }, ShapePath.prototype.reverse = function() {
        var t1 = new ShapePath;
        t1.setPathData(this.c, this._length);
        var e1 = this.v, r1 = this.o, i1 = this.i, s1 = 0;
        this.c && (t1.setTripleAt(e1[0][0], e1[0][1], i1[0][0], i1[0][1], r1[0][0], r1[0][1], 0, !1), s1 = 1);
        var a1, n1 = this._length - 1, o1 = this._length;
        for(a1 = s1; a1 < o1; a1 += 1)t1.setTripleAt(e1[n1][0], e1[n1][1], i1[n1][0], i1[n1][1], r1[n1][0], r1[n1][1], a1, !1), n1 -= 1;
        return t1;
    };
    var ShapePropertyFactory = function() {
        var s1 = -999999;
        function t1(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1, l1, p1, m1, f1 = r1.lastIndex, c1 = this.keyframes;
            if (t1 < c1[0].t - this.offsetTime) i1 = c1[0].s[0], a1 = !0, f1 = 0;
            else if (t1 >= c1[c1.length - 1].t - this.offsetTime) i1 = c1[c1.length - 1].s ? c1[c1.length - 1].s[0] : c1[c1.length - 2].e[0], a1 = !0;
            else {
                for(var d1, u1, y1 = f1, g1 = c1.length - 1, v1 = !0; v1 && (d1 = c1[y1], !((u1 = c1[y1 + 1]).t - this.offsetTime > t1));)y1 < g1 - 1 ? y1 += 1 : v1 = !1;
                if (f1 = y1, !(a1 = 1 === d1.h)) {
                    if (t1 >= u1.t - this.offsetTime) p1 = 1;
                    else if (t1 < d1.t - this.offsetTime) p1 = 0;
                    else {
                        var b1;
                        d1.__fnct ? b1 = d1.__fnct : (b1 = BezierFactory.getBezierEasing(d1.o.x, d1.o.y, d1.i.x, d1.i.y).get, d1.__fnct = b1), p1 = b1((t1 - (d1.t - this.offsetTime)) / (u1.t - this.offsetTime - (d1.t - this.offsetTime)));
                    }
                    s1 = u1.s ? u1.s[0] : d1.e[0];
                }
                i1 = d1.s[0];
            }
            for(h1 = e1._length, l1 = i1.i[0].length, r1.lastIndex = f1, n1 = 0; n1 < h1; n1 += 1)for(o1 = 0; o1 < l1; o1 += 1)m1 = a1 ? i1.i[n1][o1] : i1.i[n1][o1] + (s1.i[n1][o1] - i1.i[n1][o1]) * p1, e1.i[n1][o1] = m1, m1 = a1 ? i1.o[n1][o1] : i1.o[n1][o1] + (s1.o[n1][o1] - i1.o[n1][o1]) * p1, e1.o[n1][o1] = m1, m1 = a1 ? i1.v[n1][o1] : i1.v[n1][o1] + (s1.v[n1][o1] - i1.v[n1][o1]) * p1, e1.v[n1][o1] = m1;
        }
        function a1() {
            this.paths = this.localShapeCollection;
        }
        function e1(t1) {
            (function(t1, e1) {
                if (t1._length !== e1._length || t1.c !== e1.c) return !1;
                var r1, i1 = t1._length;
                for(r1 = 0; r1 < i1; r1 += 1)if (t1.v[r1][0] !== e1.v[r1][0] || t1.v[r1][1] !== e1.v[r1][1] || t1.o[r1][0] !== e1.o[r1][0] || t1.o[r1][1] !== e1.o[r1][1] || t1.i[r1][0] !== e1.i[r1][0] || t1.i[r1][1] !== e1.i[r1][1]) return !1;
                return !0;
            })(this.v, t1) || (this.v = shapePool.clone(t1), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
        }
        function r1() {
            if (this.elem.globalData.frameId !== this.frameId) {
                if (this.effectsSequence.length) {
                    if (this.lock) this.setVValue(this.pv);
                    else {
                        var t1, e1;
                        this.lock = !0, this._mdf = !1, t1 = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                        var r1 = this.effectsSequence.length;
                        for(e1 = 0; e1 < r1; e1 += 1)t1 = this.effectsSequence[e1](t1);
                        this.setVValue(t1), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                    }
                } else this._mdf = !1;
            }
        }
        function n1(t1, e1, r1) {
            this.propType = "shape", this.comp = t1.comp, this.container = t1, this.elem = t1, this.data = e1, this.k = !1, this.kf = !1, this._mdf = !1;
            var i1 = 3 === r1 ? e1.pt.k : e1.ks.k;
            this.v = shapePool.clone(i1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = a1, this.effectsSequence = [];
        }
        function i1(t1) {
            this.effectsSequence.push(t1), this.container.addDynamicProperty(this);
        }
        function o1(t1, e1, r1) {
            this.propType = "shape", this.comp = t1.comp, this.elem = t1, this.container = t1, this.offsetTime = t1.data.st, this.keyframes = 3 === r1 ? e1.pt.k : e1.ks.k, this.k = !0, this.kf = !0;
            var i1 = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, i1), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = s1, this.reset = a1, this._caching = {
                lastFrame: s1,
                lastIndex: 0
            }, this.effectsSequence = [
                (function() {
                    var t1 = this.comp.renderedFrame - this.offsetTime, e1 = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i1 = this._caching.lastFrame;
                    return i1 !== s1 && (i1 < e1 && t1 < e1 || r1 < i1 && r1 < t1) || (this._caching.lastIndex = i1 < t1 ? this._caching.lastIndex : 0, this.interpolateShape(t1, this.pv, this._caching)), this._caching.lastFrame = t1, this.pv;
                }).bind(this)
            ];
        }
        n1.prototype.interpolateShape = t1, n1.prototype.getValue = r1, n1.prototype.setVValue = e1, n1.prototype.addEffect = i1, o1.prototype.getValue = r1, o1.prototype.interpolateShape = t1, o1.prototype.setVValue = e1, o1.prototype.addEffect = i1;
        var h1 = function() {
            var n1 = roundCorner;
            function t1(t1, e1) {
                this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e1.d, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
            }
            return t1.prototype = {
                reset: a1,
                getValue: function() {
                    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                },
                convertEllToPath: function() {
                    var t1 = this.p.v[0], e1 = this.p.v[1], r1 = this.s.v[0] / 2, i1 = this.s.v[1] / 2, s1 = 3 !== this.d, a1 = this.v;
                    a1.v[0][0] = t1, a1.v[0][1] = e1 - i1, a1.v[1][0] = s1 ? t1 + r1 : t1 - r1, a1.v[1][1] = e1, a1.v[2][0] = t1, a1.v[2][1] = e1 + i1, a1.v[3][0] = s1 ? t1 - r1 : t1 + r1, a1.v[3][1] = e1, a1.i[0][0] = s1 ? t1 - r1 * n1 : t1 + r1 * n1, a1.i[0][1] = e1 - i1, a1.i[1][0] = s1 ? t1 + r1 : t1 - r1, a1.i[1][1] = e1 - i1 * n1, a1.i[2][0] = s1 ? t1 + r1 * n1 : t1 - r1 * n1, a1.i[2][1] = e1 + i1, a1.i[3][0] = s1 ? t1 - r1 : t1 + r1, a1.i[3][1] = e1 + i1 * n1, a1.o[0][0] = s1 ? t1 + r1 * n1 : t1 - r1 * n1, a1.o[0][1] = e1 - i1, a1.o[1][0] = s1 ? t1 + r1 : t1 - r1, a1.o[1][1] = e1 + i1 * n1, a1.o[2][0] = s1 ? t1 - r1 * n1 : t1 + r1 * n1, a1.o[2][1] = e1 + i1, a1.o[3][0] = s1 ? t1 - r1 : t1 + r1, a1.o[3][1] = e1 - i1 * n1;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], t1), t1;
        }(), l1 = function() {
            function t1(t1, e1) {
                this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t1, this.comp = t1.comp, this.data = e1, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), 1 === e1.sy ? (this.ir = PropertyFactory.getProp(t1, e1.ir, 0, 0, this), this.is = PropertyFactory.getProp(t1, e1.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t1, e1.pt, 0, 0, this), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t1, e1.or, 0, 0, this), this.os = PropertyFactory.getProp(t1, e1.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
            }
            return t1.prototype = {
                reset: a1,
                getValue: function() {
                    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                },
                convertStarToPath: function() {
                    var t1, e1, r1, i1, s1 = 2 * Math.floor(this.pt.v), a1 = 2 * Math.PI / s1, n1 = !0, o1 = this.or.v, h1 = this.ir.v, l1 = this.os.v, p1 = this.is.v, m1 = 2 * Math.PI * o1 / (2 * s1), f1 = 2 * Math.PI * h1 / (2 * s1), c1 = -Math.PI / 2;
                    c1 += this.r.v;
                    var d1 = 3 === this.data.d ? -1 : 1;
                    for(t1 = this.v._length = 0; t1 < s1; t1 += 1){
                        r1 = n1 ? l1 : p1, i1 = n1 ? m1 : f1;
                        var u1 = (e1 = n1 ? o1 : h1) * Math.cos(c1), y1 = e1 * Math.sin(c1), g1 = 0 === u1 && 0 === y1 ? 0 : y1 / Math.sqrt(u1 * u1 + y1 * y1), v1 = 0 === u1 && 0 === y1 ? 0 : -u1 / Math.sqrt(u1 * u1 + y1 * y1);
                        u1 += +this.p.v[0], y1 += +this.p.v[1], this.v.setTripleAt(u1, y1, u1 - g1 * i1 * r1 * d1, y1 - v1 * i1 * r1 * d1, u1 + g1 * i1 * r1 * d1, y1 + v1 * i1 * r1 * d1, t1, !0), n1 = !n1, c1 += a1 * d1;
                    }
                },
                convertPolygonToPath: function() {
                    var t1, e1 = Math.floor(this.pt.v), r1 = 2 * Math.PI / e1, i1 = this.or.v, s1 = this.os.v, a1 = 2 * Math.PI * i1 / (4 * e1), n1 = .5 * -Math.PI, o1 = 3 === this.data.d ? -1 : 1;
                    for(n1 += this.r.v, t1 = this.v._length = 0; t1 < e1; t1 += 1){
                        var h1 = i1 * Math.cos(n1), l1 = i1 * Math.sin(n1), p1 = 0 === h1 && 0 === l1 ? 0 : l1 / Math.sqrt(h1 * h1 + l1 * l1), m1 = 0 === h1 && 0 === l1 ? 0 : -h1 / Math.sqrt(h1 * h1 + l1 * l1);
                        h1 += +this.p.v[0], l1 += +this.p.v[1], this.v.setTripleAt(h1, l1, h1 - p1 * a1 * s1 * o1, l1 - m1 * a1 * s1 * o1, h1 + p1 * a1 * s1 * o1, l1 + m1 * a1 * s1 * o1, t1, !0), n1 += r1 * o1;
                    }
                    this.paths.length = 0, this.paths[0] = this.v;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], t1), t1;
        }(), p1 = function() {
            function t1(t1, e1) {
                this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t1, this.comp = t1.comp, this.frameId = -1, this.d = e1.d, this.initDynamicPropertyContainer(t1), this.p = PropertyFactory.getProp(t1, e1.p, 1, 0, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, 0, this), this.r = PropertyFactory.getProp(t1, e1.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
            }
            return t1.prototype = {
                convertRectToPath: function() {
                    var t1 = this.p.v[0], e1 = this.p.v[1], r1 = this.s.v[0] / 2, i1 = this.s.v[1] / 2, s1 = bmMin(r1, i1, this.r.v), a1 = s1 * (1 - roundCorner);
                    this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + a1, 0, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - a1, t1 + r1, e1 + i1 - s1, 1, !0), 0 !== s1 ? (this.v.setTripleAt(t1 + r1 - s1, e1 + i1, t1 + r1 - s1, e1 + i1, t1 + r1 - a1, e1 + i1, 2, !0), this.v.setTripleAt(t1 - r1 + s1, e1 + i1, t1 - r1 + a1, e1 + i1, t1 - r1 + s1, e1 + i1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - a1, 4, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1 + s1, 5, !0), this.v.setTripleAt(t1 - r1 + s1, e1 - i1, t1 - r1 + s1, e1 - i1, t1 - r1 + a1, e1 - i1, 6, !0), this.v.setTripleAt(t1 + r1 - s1, e1 - i1, t1 + r1 - a1, e1 - i1, t1 + r1 - s1, e1 - i1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1 + a1, e1 + i1, t1 - r1, e1 + i1, 2), this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1, e1 - i1 + a1, t1 - r1, e1 - i1, 3))) : (this.v.setTripleAt(t1 + r1, e1 - i1 + s1, t1 + r1, e1 - i1 + a1, t1 + r1, e1 - i1 + s1, 0, !0), 0 !== s1 ? (this.v.setTripleAt(t1 + r1 - s1, e1 - i1, t1 + r1 - s1, e1 - i1, t1 + r1 - a1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1 + s1, e1 - i1, t1 - r1 + a1, e1 - i1, t1 - r1 + s1, e1 - i1, 2, !0), this.v.setTripleAt(t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + s1, t1 - r1, e1 - i1 + a1, 3, !0), this.v.setTripleAt(t1 - r1, e1 + i1 - s1, t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1 - s1, 4, !0), this.v.setTripleAt(t1 - r1 + s1, e1 + i1, t1 - r1 + s1, e1 + i1, t1 - r1 + a1, e1 + i1, 5, !0), this.v.setTripleAt(t1 + r1 - s1, e1 + i1, t1 + r1 - a1, e1 + i1, t1 + r1 - s1, e1 + i1, 6, !0), this.v.setTripleAt(t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - s1, t1 + r1, e1 + i1 - a1, 7, !0)) : (this.v.setTripleAt(t1 - r1, e1 - i1, t1 - r1 + a1, e1 - i1, t1 - r1, e1 - i1, 1, !0), this.v.setTripleAt(t1 - r1, e1 + i1, t1 - r1, e1 + i1 - a1, t1 - r1, e1 + i1, 2, !0), this.v.setTripleAt(t1 + r1, e1 + i1, t1 + r1 - a1, e1 + i1, t1 + r1, e1 + i1, 3, !0)));
                },
                getValue: function() {
                    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                },
                reset: a1
            }, extendPrototype([
                DynamicPropertyContainer
            ], t1), t1;
        }();
        var m1 = {
            getShapeProp: function(t1, e1, r1) {
                var i1;
                return 3 === r1 || 4 === r1 ? i1 = (3 === r1 ? e1.pt : e1.ks).k.length ? new o1(t1, e1, r1) : new n1(t1, e1, r1) : 5 === r1 ? i1 = new p1(t1, e1) : 6 === r1 ? i1 = new h1(t1, e1) : 7 === r1 && (i1 = new l1(t1, e1)), i1.k && t1.addDynamicProperty(i1), i1;
            },
            getConstructorFunction: function() {
                return n1;
            },
            getKeyframedConstructorFunction: function() {
                return o1;
            }
        };
        return m1;
    }(), ShapeModifiers = (Yr = {}, Zr = {}, Yr.registerModifier = function(t1, e1) {
        Zr[t1] || (Zr[t1] = e1);
    }, Yr.getModifier = function(t1, e1, r1) {
        return new Zr[t1](e1, r1);
    }, Yr), Yr, Zr;
    function ShapeModifier() {}
    function TrimModifier() {}
    function RoundCornersModifier() {}
    function PuckerAndBloatModifier() {}
    function RepeaterModifier() {}
    function ShapeCollection() {
        this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    function DashProperty(t1, e1, r1, i1) {
        var s1;
        this.elem = t1, this.frameId = -1, this.dataProps = createSizedArray(e1.length), this.renderer = r1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e1.length ? e1.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i1);
        var a1, n1 = e1.length || 0;
        for(s1 = 0; s1 < n1; s1 += 1)a1 = PropertyFactory.getProp(t1, e1[s1].v, 0, 0, this), this.k = a1.k || this.k, this.dataProps[s1] = {
            n: e1[s1].n,
            p: a1
        };
        this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    function GradientProperty(t1, e1, r1) {
        this.data = e1, this.c = createTypedArray("uint8c", 4 * e1.p);
        var i1 = e1.k.k[0].s ? e1.k.k[0].s.length - 4 * e1.p : e1.k.k.length - 4 * e1.p;
        this.o = createTypedArray("float32", i1), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i1, this.initDynamicPropertyContainer(r1), this.prop = PropertyFactory.getProp(t1, e1.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t1) {
        if (!this.closed) {
            t1.sh.container.addDynamicProperty(t1.sh);
            var e1 = {
                shape: t1.sh,
                data: t1,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(e1), this.addShapeToModifier(e1), this._isAnimated && t1.setAsAnimated();
        }
    }, ShapeModifier.prototype.init = function(t1, e1) {
        this.shapes = [], this.elem = t1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier), extendPrototype([
        ShapeModifier
    ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t1, e1) {
        this.s = PropertyFactory.getProp(t1, e1.s, 0, .01, this), this.e = PropertyFactory.getProp(t1, e1.e, 0, .01, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e1.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(t1) {
        t1.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(t1, e1, r1, i1, s1) {
        var a1 = [];
        e1 <= 1 ? a1.push({
            s: t1,
            e: e1
        }) : 1 <= t1 ? a1.push({
            s: t1 - 1,
            e: e1 - 1
        }) : (a1.push({
            s: t1,
            e: 1
        }), a1.push({
            s: 0,
            e: e1 - 1
        }));
        var n1, o1, h1 = [], l1 = a1.length;
        for(n1 = 0; n1 < l1; n1 += 1){
            var p1, m1;
            if (!((o1 = a1[n1]).e * s1 < i1 || o1.s * s1 > i1 + r1)) p1 = o1.s * s1 <= i1 ? 0 : (o1.s * s1 - i1) / r1, m1 = o1.e * s1 >= i1 + r1 ? 1 : (o1.e * s1 - i1) / r1, h1.push([
                p1,
                m1
            ]);
        }
        return h1.length || h1.push([
            0,
            0
        ]), h1;
    }, TrimModifier.prototype.releasePathsData = function(t1) {
        var e1, r1 = t1.length;
        for(e1 = 0; e1 < r1; e1 += 1)segmentsLengthPool.release(t1[e1]);
        return t1.length = 0, t1;
    }, TrimModifier.prototype.processShapes = function(t1) {
        var e1, r1, i1, s1;
        if (this._mdf || t1) {
            var a1 = this.o.v % 360 / 360;
            if (a1 < 0 && (a1 += 1), e1 = 1 < this.s.v ? 1 + a1 : this.s.v < 0 ? 0 + a1 : this.s.v + a1, (r1 = 1 < this.e.v ? 1 + a1 : this.e.v < 0 ? 0 + a1 : this.e.v + a1) < e1) {
                var n1 = e1;
                e1 = r1, r1 = n1;
            }
            e1 = 1e-4 * Math.round(1e4 * e1), r1 = 1e-4 * Math.round(1e4 * r1), this.sValue = e1, this.eValue = r1;
        } else e1 = this.sValue, r1 = this.eValue;
        var o1, h1, l1, p1, m1, f1 = this.shapes.length, c1 = 0;
        if (r1 === e1) for(s1 = 0; s1 < f1; s1 += 1)this.shapes[s1].localShapeCollection.releaseShapes(), this.shapes[s1].shape._mdf = !0, this.shapes[s1].shape.paths = this.shapes[s1].localShapeCollection, this._mdf && (this.shapes[s1].pathsData.length = 0);
        else if (1 === r1 && 0 === e1 || 0 === r1 && 1 === e1) {
            if (this._mdf) for(s1 = 0; s1 < f1; s1 += 1)this.shapes[s1].pathsData.length = 0, this.shapes[s1].shape._mdf = !0;
        } else {
            var d1, u1, y1 = [];
            for(s1 = 0; s1 < f1; s1 += 1)if ((d1 = this.shapes[s1]).shape._mdf || this._mdf || t1 || 2 === this.m) {
                if (h1 = (i1 = d1.shape.paths)._length, m1 = 0, !d1.shape._mdf && d1.pathsData.length) m1 = d1.totalShapeLength;
                else {
                    for(l1 = this.releasePathsData(d1.pathsData), o1 = 0; o1 < h1; o1 += 1)p1 = bez.getSegmentsLength(i1.shapes[o1]), l1.push(p1), m1 += p1.totalLength;
                    d1.totalShapeLength = m1, d1.pathsData = l1;
                }
                c1 += m1, d1.shape._mdf = !0;
            } else d1.shape.paths = d1.localShapeCollection;
            var g1, v1 = e1, b1 = r1, P1 = 0;
            for(s1 = f1 - 1; 0 <= s1; s1 -= 1)if ((d1 = this.shapes[s1]).shape._mdf) {
                for((u1 = d1.localShapeCollection).releaseShapes(), 2 === this.m && 1 < f1 ? (g1 = this.calculateShapeEdges(e1, r1, d1.totalShapeLength, P1, c1), P1 += d1.totalShapeLength) : g1 = [
                    [
                        v1,
                        b1
                    ]
                ], h1 = g1.length, o1 = 0; o1 < h1; o1 += 1){
                    v1 = g1[o1][0], b1 = g1[o1][1], y1.length = 0, b1 <= 1 ? y1.push({
                        s: d1.totalShapeLength * v1,
                        e: d1.totalShapeLength * b1
                    }) : 1 <= v1 ? y1.push({
                        s: d1.totalShapeLength * (v1 - 1),
                        e: d1.totalShapeLength * (b1 - 1)
                    }) : (y1.push({
                        s: d1.totalShapeLength * v1,
                        e: d1.totalShapeLength
                    }), y1.push({
                        s: 0,
                        e: d1.totalShapeLength * (b1 - 1)
                    }));
                    var E1 = this.addShapes(d1, y1[0]);
                    if (y1[0].s !== y1[0].e) {
                        if (1 < y1.length) {
                            if (d1.shape.paths.shapes[d1.shape.paths._length - 1].c) {
                                var x1 = E1.pop();
                                this.addPaths(E1, u1), E1 = this.addShapes(d1, y1[1], x1);
                            } else this.addPaths(E1, u1), E1 = this.addShapes(d1, y1[1]);
                        }
                        this.addPaths(E1, u1);
                    }
                }
                d1.shape.paths = u1;
            }
        }
    }, TrimModifier.prototype.addPaths = function(t1, e1) {
        var r1, i1 = t1.length;
        for(r1 = 0; r1 < i1; r1 += 1)e1.addShape(t1[r1]);
    }, TrimModifier.prototype.addSegment = function(t1, e1, r1, i1, s1, a1, n1) {
        s1.setXYAt(e1[0], e1[1], "o", a1), s1.setXYAt(r1[0], r1[1], "i", a1 + 1), n1 && s1.setXYAt(t1[0], t1[1], "v", a1), s1.setXYAt(i1[0], i1[1], "v", a1 + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(t1, e1, r1, i1) {
        e1.setXYAt(t1[1], t1[5], "o", r1), e1.setXYAt(t1[2], t1[6], "i", r1 + 1), i1 && e1.setXYAt(t1[0], t1[4], "v", r1), e1.setXYAt(t1[3], t1[7], "v", r1 + 1);
    }, TrimModifier.prototype.addShapes = function(t1, e1, r1) {
        var i1, s1, a1, n1, o1, h1, l1, p1, m1 = t1.pathsData, f1 = t1.shape.paths.shapes, c1 = t1.shape.paths._length, d1 = 0, u1 = [], y1 = !0;
        for(p1 = r1 ? (o1 = r1._length, r1._length) : (r1 = shapePool.newElement(), o1 = 0), u1.push(r1), i1 = 0; i1 < c1; i1 += 1){
            for(h1 = m1[i1].lengths, r1.c = f1[i1].c, a1 = f1[i1].c ? h1.length : h1.length + 1, s1 = 1; s1 < a1; s1 += 1)if (d1 + (n1 = h1[s1 - 1]).addedLength < e1.s) d1 += n1.addedLength, r1.c = !1;
            else {
                if (d1 > e1.e) {
                    r1.c = !1;
                    break;
                }
                e1.s <= d1 && e1.e >= d1 + n1.addedLength ? (this.addSegment(f1[i1].v[s1 - 1], f1[i1].o[s1 - 1], f1[i1].i[s1], f1[i1].v[s1], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(f1[i1].v[s1 - 1], f1[i1].v[s1], f1[i1].o[s1 - 1], f1[i1].i[s1], (e1.s - d1) / n1.addedLength, (e1.e - d1) / n1.addedLength, h1[s1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1), d1 += n1.addedLength, o1 += 1;
            }
            if (f1[i1].c && h1.length) {
                if (n1 = h1[s1 - 1], d1 <= e1.e) {
                    var g1 = h1[s1 - 1].addedLength;
                    e1.s <= d1 && e1.e >= d1 + g1 ? (this.addSegment(f1[i1].v[s1 - 1], f1[i1].o[s1 - 1], f1[i1].i[0], f1[i1].v[0], r1, o1, y1), y1 = !1) : (l1 = bez.getNewSegment(f1[i1].v[s1 - 1], f1[i1].v[0], f1[i1].o[s1 - 1], f1[i1].i[0], (e1.s - d1) / g1, (e1.e - d1) / g1, h1[s1 - 1]), this.addSegmentFromArray(l1, r1, o1, y1), y1 = !1, r1.c = !1);
                } else r1.c = !1;
                d1 += n1.addedLength, o1 += 1;
            }
            if (r1._length && (r1.setXYAt(r1.v[p1][0], r1.v[p1][1], "i", p1), r1.setXYAt(r1.v[r1._length - 1][0], r1.v[r1._length - 1][1], "o", r1._length - 1)), d1 > e1.e) break;
            i1 < c1 - 1 && (r1 = shapePool.newElement(), y1 = !0, u1.push(r1), o1 = 0);
        }
        return u1;
    }, ShapeModifiers.registerModifier("tm", TrimModifier), extendPrototype([
        ShapeModifier
    ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t1, e1) {
        this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t1, e1.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(t1, e1) {
        var r1, i1 = shapePool.newElement();
        i1.c = t1.c;
        var s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1, u1, y1 = t1._length, g1 = 0;
        for(r1 = 0; r1 < y1; r1 += 1)s1 = t1.v[r1], n1 = t1.o[r1], a1 = t1.i[r1], s1[0] === n1[0] && s1[1] === n1[1] && s1[0] === a1[0] && s1[1] === a1[1] ? 0 !== r1 && r1 !== y1 - 1 || t1.c ? (o1 = 0 === r1 ? t1.v[y1 - 1] : t1.v[r1 - 1], l1 = (h1 = Math.sqrt(Math.pow(s1[0] - o1[0], 2) + Math.pow(s1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = d1 = s1[0] + (o1[0] - s1[0]) * l1, m1 = u1 = s1[1] - (s1[1] - o1[1]) * l1, f1 = p1 - (p1 - s1[0]) * roundCorner, c1 = m1 - (m1 - s1[1]) * roundCorner, i1.setTripleAt(p1, m1, f1, c1, d1, u1, g1), g1 += 1, o1 = r1 === y1 - 1 ? t1.v[0] : t1.v[r1 + 1], l1 = (h1 = Math.sqrt(Math.pow(s1[0] - o1[0], 2) + Math.pow(s1[1] - o1[1], 2))) ? Math.min(h1 / 2, e1) / h1 : 0, p1 = f1 = s1[0] + (o1[0] - s1[0]) * l1, m1 = c1 = s1[1] + (o1[1] - s1[1]) * l1, d1 = p1 - (p1 - s1[0]) * roundCorner, u1 = m1 - (m1 - s1[1]) * roundCorner, i1.setTripleAt(p1, m1, f1, c1, d1, u1, g1)) : i1.setTripleAt(s1[0], s1[1], n1[0], n1[1], a1[0], a1[1], g1) : i1.setTripleAt(t1.v[r1][0], t1.v[r1][1], t1.o[r1][0], t1.o[r1][1], t1.i[r1][0], t1.i[r1][1], g1), g1 += 1;
        return i1;
    }, RoundCornersModifier.prototype.processShapes = function(t1) {
        var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.rd.v;
        if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
            if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
            a1.shape.paths = a1.localShapeCollection;
        }
        this.dynamicProperties.length || (this._mdf = !1);
    }, ShapeModifiers.registerModifier("rd", RoundCornersModifier), extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t1, e1) {
        this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t1, e1.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(t1, e1) {
        var r1 = e1 / 100, i1 = [
            0,
            0
        ], s1 = t1._length, a1 = 0;
        for(a1 = 0; a1 < s1; a1 += 1)i1[0] += t1.v[a1][0], i1[1] += t1.v[a1][1];
        i1[0] /= s1, i1[1] /= s1;
        var n1, o1, h1, l1, p1, m1, f1 = shapePool.newElement();
        for(f1.c = t1.c, a1 = 0; a1 < s1; a1 += 1)n1 = t1.v[a1][0] + (i1[0] - t1.v[a1][0]) * r1, o1 = t1.v[a1][1] + (i1[1] - t1.v[a1][1]) * r1, h1 = t1.o[a1][0] + (i1[0] - t1.o[a1][0]) * -r1, l1 = t1.o[a1][1] + (i1[1] - t1.o[a1][1]) * -r1, p1 = t1.i[a1][0] + (i1[0] - t1.i[a1][0]) * -r1, m1 = t1.i[a1][1] + (i1[1] - t1.i[a1][1]) * -r1, f1.setTripleAt(n1, o1, h1, l1, p1, m1, a1);
        return f1;
    }, PuckerAndBloatModifier.prototype.processShapes = function(t1) {
        var e1, r1, i1, s1, a1, n1, o1 = this.shapes.length, h1 = this.amount.v;
        if (0 !== h1) for(r1 = 0; r1 < o1; r1 += 1){
            if (n1 = (a1 = this.shapes[r1]).localShapeCollection, a1.shape._mdf || this._mdf || t1) for(n1.releaseShapes(), a1.shape._mdf = !0, e1 = a1.shape.paths.shapes, s1 = a1.shape.paths._length, i1 = 0; i1 < s1; i1 += 1)n1.addShape(this.processPath(e1[i1], h1));
            a1.shape.paths = a1.localShapeCollection;
        }
        this.dynamicProperties.length || (this._mdf = !1);
    }, ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), extendPrototype([
        ShapeModifier
    ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t1, e1) {
        this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t1, e1.c, 0, null, this), this.o = PropertyFactory.getProp(t1, e1.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t1, e1.tr, this), this.so = PropertyFactory.getProp(t1, e1.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t1, e1.tr.eo, 0, .01, this), this.data = e1, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
    }, RepeaterModifier.prototype.applyTransforms = function(t1, e1, r1, i1, s1, a1) {
        var n1 = a1 ? -1 : 1, o1 = i1.s.v[0] + (1 - i1.s.v[0]) * (1 - s1), h1 = i1.s.v[1] + (1 - i1.s.v[1]) * (1 - s1);
        t1.translate(i1.p.v[0] * n1 * s1, i1.p.v[1] * n1 * s1, i1.p.v[2]), e1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), e1.rotate(-i1.r.v * n1 * s1), e1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]), r1.translate(-i1.a.v[0], -i1.a.v[1], i1.a.v[2]), r1.scale(a1 ? 1 / o1 : o1, a1 ? 1 / h1 : h1), r1.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
    }, RepeaterModifier.prototype.init = function(t1, e1, r1, i1) {
        for(this.elem = t1, this.arr = e1, this.pos = r1, this.elemsData = i1, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t1), this.initModifierProperties(t1, e1[r1]); 0 < r1;)r1 -= 1, this._elements.unshift(e1[r1]);
        this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(t1) {
        var e1, r1 = t1.length;
        for(e1 = 0; e1 < r1; e1 += 1)t1[e1]._processed = !1, "gr" === t1[e1].ty && this.resetElements(t1[e1].it);
    }, RepeaterModifier.prototype.cloneElements = function(t1) {
        var e1 = JSON.parse(JSON.stringify(t1));
        return this.resetElements(e1), e1;
    }, RepeaterModifier.prototype.changeGroupRender = function(t1, e1) {
        var r1, i1 = t1.length;
        for(r1 = 0; r1 < i1; r1 += 1)t1[r1]._render = e1, "gr" === t1[r1].ty && this.changeGroupRender(t1[r1].it, e1);
    }, RepeaterModifier.prototype.processShapes = function(t1) {
        var e1, r1, i1, s1, a1, n1 = !1;
        if (this._mdf || t1) {
            var o1, h1 = Math.ceil(this.c.v);
            if (this._groups.length < h1) {
                for(; this._groups.length < h1;){
                    var l1 = {
                        it: this.cloneElements(this._elements),
                        ty: "gr"
                    };
                    l1.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: "Transform",
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: "tr"
                    }), this.arr.splice(0, 0, l1), this._groups.splice(0, 0, l1), this._currentCopies += 1;
                }
                this.elem.reloadShapes(), n1 = !0;
            }
            for(i1 = a1 = 0; i1 <= this._groups.length - 1; i1 += 1){
                if (o1 = a1 < h1, this._groups[i1]._render = o1, this.changeGroupRender(this._groups[i1].it, o1), !o1) {
                    var p1 = this.elemsData[i1].it, m1 = p1[p1.length - 1];
                    0 !== m1.transform.op.v ? (m1.transform.op._mdf = !0, m1.transform.op.v = 0) : m1.transform.op._mdf = !1;
                }
                a1 += 1;
            }
            this._currentCopies = h1;
            var f1 = this.o.v, c1 = f1 % 1, d1 = 0 < f1 ? Math.floor(f1) : Math.ceil(f1), u1 = this.pMatrix.props, y1 = this.rMatrix.props, g1 = this.sMatrix.props;
            this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
            var v1, b1, P1 = 0;
            if (0 < f1) {
                for(; P1 < d1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), P1 += 1;
                c1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, c1, !1), P1 += c1);
            } else if (f1 < 0) {
                for(; d1 < P1;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), P1 -= 1;
                c1 && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -c1, !0), P1 -= c1);
            }
            for(i1 = 1 === this.data.m ? 0 : this._currentCopies - 1, s1 = 1 === this.data.m ? 1 : -1, a1 = this._currentCopies; a1;){
                if (b1 = (r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props).length, e1[e1.length - 1].transform.mProps._mdf = !0, e1[e1.length - 1].transform.op._mdf = !0, e1[e1.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i1 / (this._currentCopies - 1)), 0 !== P1) {
                    for((0 !== i1 && 1 === s1 || i1 !== this._currentCopies - 1 && -1 === s1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y1[0], y1[1], y1[2], y1[3], y1[4], y1[5], y1[6], y1[7], y1[8], y1[9], y1[10], y1[11], y1[12], y1[13], y1[14], y1[15]), this.matrix.transform(g1[0], g1[1], g1[2], g1[3], g1[4], g1[5], g1[6], g1[7], g1[8], g1[9], g1[10], g1[11], g1[12], g1[13], g1[14], g1[15]), this.matrix.transform(u1[0], u1[1], u1[2], u1[3], u1[4], u1[5], u1[6], u1[7], u1[8], u1[9], u1[10], u1[11], u1[12], u1[13], u1[14], u1[15]), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                    this.matrix.reset();
                } else for(this.matrix.reset(), v1 = 0; v1 < b1; v1 += 1)r1[v1] = this.matrix.props[v1];
                P1 += 1, a1 -= 1, i1 += s1;
            }
        } else for(a1 = this._currentCopies, i1 = 0, s1 = 1; a1;)r1 = (e1 = this.elemsData[i1].it)[e1.length - 1].transform.mProps.v.props, e1[e1.length - 1].transform.mProps._mdf = !1, e1[e1.length - 1].transform.op._mdf = !1, a1 -= 1, i1 += s1;
        return n1;
    }, RepeaterModifier.prototype.addShape = function() {}, ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeCollection.prototype.addShape = function(t1) {
        this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t1, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
        var t1;
        for(t1 = 0; t1 < this._length; t1 += 1)shapePool.release(this.shapes[t1]);
        this._length = 0;
    }, DashProperty.prototype.getValue = function(t1) {
        if ((this.elem.globalData.frameId !== this.frameId || t1) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t1, this._mdf)) {
            var e1 = 0, r1 = this.dataProps.length;
            for("svg" === this.renderer && (this.dashStr = ""), e1 = 0; e1 < r1; e1 += 1)"o" !== this.dataProps[e1].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e1].p.v : this.dashArray[e1] = this.dataProps[e1].p.v : this.dashoffset[0] = this.dataProps[e1].p.v;
        }
    }, extendPrototype([
        DynamicPropertyContainer
    ], DashProperty), GradientProperty.prototype.comparePoints = function(t1, e1) {
        for(var r1 = 0, i1 = this.o.length / 2; r1 < i1;){
            if (.01 < Math.abs(t1[4 * r1] - t1[4 * e1 + 2 * r1])) return !1;
            r1 += 1;
        }
        return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 != this.c.length / 4) return !1;
        if (this.data.k.k[0].s) for(var t1 = 0, e1 = this.data.k.k.length; t1 < e1;){
            if (!this.comparePoints(this.data.k.k[t1].s, this.data.p)) return !1;
            t1 += 1;
        }
        else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
        return !0;
    }, GradientProperty.prototype.getValue = function(t1) {
        if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t1) {
            var e1, r1, i1, s1 = 4 * this.data.p;
            for(e1 = 0; e1 < s1; e1 += 1)r1 = e1 % 4 == 0 ? 100 : 255, i1 = Math.round(this.prop.v[e1] * r1), this.c[e1] !== i1 && (this.c[e1] = i1, this._cmdf = !t1);
            if (this.o.length) for(s1 = this.prop.v.length, e1 = 4 * this.data.p; e1 < s1; e1 += 1)r1 = e1 % 2 == 0 ? 100 : 1, i1 = e1 % 2 == 0 ? Math.round(100 * this.prop.v[e1]) : this.prop.v[e1], this.o[e1 - 4 * this.data.p] !== i1 && (this.o[e1 - 4 * this.data.p] = i1, this._omdf = !t1);
            this._mdf = !t1;
        }
    }, extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    var buildShapeString = function(t1, e1, r1, i1) {
        if (0 === e1) return "";
        var s1, a1 = t1.o, n1 = t1.i, o1 = t1.v, h1 = " M" + i1.applyToPointStringified(o1[0][0], o1[0][1]);
        for(s1 = 1; s1 < e1; s1 += 1)h1 += " C" + i1.applyToPointStringified(a1[s1 - 1][0], a1[s1 - 1][1]) + " " + i1.applyToPointStringified(n1[s1][0], n1[s1][1]) + " " + i1.applyToPointStringified(o1[s1][0], o1[s1][1]);
        return r1 && e1 && (h1 += " C" + i1.applyToPointStringified(a1[s1 - 1][0], a1[s1 - 1][1]) + " " + i1.applyToPointStringified(n1[0][0], n1[0][1]) + " " + i1.applyToPointStringified(o1[0][0], o1[0][1]), h1 += "z"), h1;
    }, audioControllerFactory = function() {
        function t1(t1) {
            this.audios = [], this.audioFactory = t1, this._volume = 1, this._isMuted = !1;
        }
        return t1.prototype = {
            addAudio: function(t1) {
                this.audios.push(t1);
            },
            pause: function() {
                var t1, e1 = this.audios.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].pause();
            },
            resume: function() {
                var t1, e1 = this.audios.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].resume();
            },
            setRate: function(t1) {
                var e1, r1 = this.audios.length;
                for(e1 = 0; e1 < r1; e1 += 1)this.audios[e1].setRate(t1);
            },
            createAudio: function(t1) {
                return this.audioFactory ? this.audioFactory(t1) : Howl ? new Howl({
                    src: [
                        t1
                    ]
                }) : {
                    isPlaying: !1,
                    play: function() {
                        this.isPlaying = !0;
                    },
                    seek: function() {
                        this.isPlaying = !1;
                    },
                    playing: function() {},
                    rate: function() {},
                    setVolume: function() {}
                };
            },
            setAudioFactory: function(t1) {
                this.audioFactory = t1;
            },
            setVolume: function(t1) {
                this._volume = t1, this._updateVolume();
            },
            mute: function() {
                this._isMuted = !0, this._updateVolume();
            },
            unmute: function() {
                this._isMuted = !1, this._updateVolume();
            },
            getVolume: function() {
                return this._volume;
            },
            _updateVolume: function() {
                var t1, e1 = this.audios.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.audios[t1].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        }, function() {
            return new t1;
        };
    }(), ImagePreloader = function() {
        var s1 = function() {
            var t1 = createTag("canvas");
            t1.width = 1, t1.height = 1;
            var e1 = t1.getContext("2d");
            return e1.fillStyle = "rgba(0,0,0,0)", e1.fillRect(0, 0, 1, 1), t1;
        }();
        function t1() {
            this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
        }
        function e1() {
            this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
        }
        function a1(t1, e1, r1) {
            var i1 = "";
            if (t1.e) i1 = t1.p;
            else if (e1) {
                var s1 = t1.p;
                -1 !== s1.indexOf("images/") && (s1 = s1.split("/")[1]), i1 = e1 + s1;
            } else i1 = r1, i1 += t1.u ? t1.u : "", i1 += t1.p;
            return i1;
        }
        function r1() {
            this._imageLoaded = t1.bind(this), this._footageLoaded = e1.bind(this), this.testImageLoaded = (function(t1) {
                var e1 = 0, r1 = setInterval((function() {
                    (t1.getBBox().width || 500 < e1) && (this._imageLoaded(), clearInterval(r1)), e1 += 1;
                }).bind(this), 50);
            }).bind(this), this.createFootageData = (function(t1) {
                var e1 = {
                    assetData: t1
                }, r1 = a1(t1, this.assetsPath, this.path);
                return assetLoader.load(r1, (function(t1) {
                    e1.img = t1, this._footageLoaded();
                }).bind(this), (function() {
                    e1.img = {}, this._footageLoaded();
                }).bind(this)), e1;
            }).bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
        }
        return r1.prototype = {
            loadAssets: function(t1, e1) {
                var r1;
                this.imagesLoadedCb = e1;
                var i1 = t1.length;
                for(r1 = 0; r1 < i1; r1 += 1)t1[r1].layers || (t1[r1].t && "seq" !== t1[r1].t ? 3 === t1[r1].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t1[r1]))) : (this.totalImages += 1, this.images.push(this._createImageData(t1[r1]))));
            },
            setAssetsPath: function(t1) {
                this.assetsPath = t1 || "";
            },
            setPath: function(t1) {
                this.path = t1 || "";
            },
            loadedImages: function() {
                return this.totalImages === this.loadedAssets;
            },
            loadedFootages: function() {
                return this.totalFootages === this.loadedFootagesCount;
            },
            destroy: function() {
                this.imagesLoadedCb = null, this.images.length = 0;
            },
            getAsset: function(t1) {
                for(var e1 = 0, r1 = this.images.length; e1 < r1;){
                    if (this.images[e1].assetData === t1) return this.images[e1].img;
                    e1 += 1;
                }
                return null;
            },
            createImgData: function(t1) {
                var e1 = a1(t1, this.assetsPath, this.path), r1 = createTag("img");
                r1.crossOrigin = "anonymous", r1.addEventListener("load", this._imageLoaded, !1), r1.addEventListener("error", (function() {
                    i1.img = s1, this._imageLoaded();
                }).bind(this), !1), r1.src = e1;
                var i1 = {
                    img: r1,
                    assetData: t1
                };
                return i1;
            },
            createImageData: function(t1) {
                var e1 = a1(t1, this.assetsPath, this.path), r1 = createNS("image");
                isSafari ? this.testImageLoaded(r1) : r1.addEventListener("load", this._imageLoaded, !1), r1.addEventListener("error", (function() {
                    i1.img = s1, this._imageLoaded();
                }).bind(this), !1), r1.setAttributeNS("http://www.w3.org/1999/xlink", "href", e1), this._elementHelper.append ? this._elementHelper.append(r1) : this._elementHelper.appendChild(r1);
                var i1 = {
                    img: r1,
                    assetData: t1
                };
                return i1;
            },
            imageLoaded: t1,
            footageLoaded: e1,
            setCacheType: function(t1, e1) {
                this._createImageData = "svg" === t1 ? (this._elementHelper = e1, this.createImageData.bind(this)) : this.createImgData.bind(this);
            }
        }, r1;
    }(), featureSupport = (px = {
        maskType: !0
    }, (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (px.maskType = !1), px), px, filtersFactory = (qx = {}, qx.createFilter = function(t1, e1) {
        var r1 = createNS("filter");
        return r1.setAttribute("id", t1), !0 !== e1 && (r1.setAttribute("filterUnits", "objectBoundingBox"), r1.setAttribute("x", "0%"), r1.setAttribute("y", "0%"), r1.setAttribute("width", "100%"), r1.setAttribute("height", "100%")), r1;
    }, qx.createAlphaToLuminanceFilter = function() {
        var t1 = createNS("feColorMatrix");
        return t1.setAttribute("type", "matrix"), t1.setAttribute("color-interpolation-filters", "sRGB"), t1.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t1;
    }, qx), qx, assetLoader = function() {
        function a1(t1) {
            return t1.response && "object" == typeof t1.response ? t1.response : t1.response && "string" == typeof t1.response ? JSON.parse(t1.response) : t1.responseText ? JSON.parse(t1.responseText) : null;
        }
        return {
            load: function(t1, e1, r1) {
                var i1, s1 = new XMLHttpRequest;
                try {
                    s1.responseType = "json";
                } catch (t1) {}
                s1.onreadystatechange = function() {
                    if (4 === s1.readyState) {
                        if (200 === s1.status) i1 = a1(s1), e1(i1);
                        else try {
                            i1 = a1(s1), e1(i1);
                        } catch (t1) {
                            r1 && r1(t1);
                        }
                    }
                }, s1.open("GET", t1, !0), s1.send();
            }
        };
    }();
    function TextAnimatorProperty(t1, e1, r1) {
        this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t1, this._renderType = e1, this._elem = r1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
            alignment: {}
        }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r1);
    }
    function TextAnimatorDataProperty(t1, e1, r1) {
        var i1 = {
            propType: !1
        }, s1 = PropertyFactory.getProp, a1 = e1.a;
        this.a = {
            r: a1.r ? s1(t1, a1.r, 0, degToRads, r1) : i1,
            rx: a1.rx ? s1(t1, a1.rx, 0, degToRads, r1) : i1,
            ry: a1.ry ? s1(t1, a1.ry, 0, degToRads, r1) : i1,
            sk: a1.sk ? s1(t1, a1.sk, 0, degToRads, r1) : i1,
            sa: a1.sa ? s1(t1, a1.sa, 0, degToRads, r1) : i1,
            s: a1.s ? s1(t1, a1.s, 1, .01, r1) : i1,
            a: a1.a ? s1(t1, a1.a, 1, 0, r1) : i1,
            o: a1.o ? s1(t1, a1.o, 0, .01, r1) : i1,
            p: a1.p ? s1(t1, a1.p, 1, 0, r1) : i1,
            sw: a1.sw ? s1(t1, a1.sw, 0, 0, r1) : i1,
            sc: a1.sc ? s1(t1, a1.sc, 1, 0, r1) : i1,
            fc: a1.fc ? s1(t1, a1.fc, 1, 0, r1) : i1,
            fh: a1.fh ? s1(t1, a1.fh, 0, 0, r1) : i1,
            fs: a1.fs ? s1(t1, a1.fs, 0, .01, r1) : i1,
            fb: a1.fb ? s1(t1, a1.fb, 0, .01, r1) : i1,
            t: a1.t ? s1(t1, a1.t, 0, 0, r1) : i1
        }, this.s = TextSelectorProp.getTextSelectorProp(t1, e1.s, r1), this.s.t = e1.s.t;
    }
    function LetterProps(t1, e1, r1, i1, s1, a1) {
        this.o = t1, this.sw = e1, this.sc = r1, this.fc = i1, this.m = s1, this.p = a1, this._mdf = {
            o: !0,
            sw: !!e1,
            sc: !!r1,
            fc: !!i1,
            m: !0,
            p: !0
        };
    }
    function TextProperty(t1, e1) {
        this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e1, this.elem = t1, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: "",
            fStyle: "",
            fWeight: "",
            fc: "",
            j: "",
            justifyOffset: "",
            l: [],
            lh: 0,
            lineWidths: [],
            ls: "",
            of: "",
            s: "",
            sc: "",
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: !1,
            strokeColorAnim: !1,
            strokeWidthAnim: !1,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: !1
        }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var t1, e1, r1 = this._textData.a.length, i1 = PropertyFactory.getProp;
        for(t1 = 0; t1 < r1; t1 += 1)e1 = this._textData.a[t1], this._animatorsData[t1] = new TextAnimatorDataProperty(this._elem, e1, this);
        this._textData.p && "m" in this._textData.p ? (this._pathData = {
            f: i1(this._elem, this._textData.p.f, 0, 0, this),
            l: i1(this._elem, this._textData.p.l, 0, 0, this),
            r: this._textData.p.r,
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
        }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i1(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(t1, e1) {
        if (this.lettersChangedFlag = e1, this._mdf || this._isFirstFrame || e1 || this._hasMaskedPath && this._pathData.m._mdf) {
            this._isFirstFrame = !1;
            var r1, i1, s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1, u1, y1, g1, v1, b1, P1, E1 = this._moreOptions.alignment.v, x1 = this._animatorsData, S1 = this._textData, A1 = this.mHelper, C1 = this._renderType, _1 = this.renderedLetters.length, T1 = t1.l;
            if (this._hasMaskedPath) {
                if (P1 = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                    var k1, D1 = P1.v;
                    for(this._pathData.r && (D1 = D1.reverse()), n1 = {
                        tLength: 0,
                        segments: []
                    }, a1 = D1._length - 1, s1 = g1 = 0; s1 < a1; s1 += 1)k1 = bez.buildBezierData(D1.v[s1], D1.v[s1 + 1], [
                        D1.o[s1][0] - D1.v[s1][0],
                        D1.o[s1][1] - D1.v[s1][1]
                    ], [
                        D1.i[s1 + 1][0] - D1.v[s1 + 1][0],
                        D1.i[s1 + 1][1] - D1.v[s1 + 1][1]
                    ]), n1.tLength += k1.segmentLength, n1.segments.push(k1), g1 += k1.segmentLength;
                    s1 = a1, P1.v.c && (k1 = bez.buildBezierData(D1.v[s1], D1.v[0], [
                        D1.o[s1][0] - D1.v[s1][0],
                        D1.o[s1][1] - D1.v[s1][1]
                    ], [
                        D1.i[0][0] - D1.v[0][0],
                        D1.i[0][1] - D1.v[0][1]
                    ]), n1.tLength += k1.segmentLength, n1.segments.push(k1), g1 += k1.segmentLength), this._pathData.pi = n1;
                }
                if (n1 = this._pathData.pi, o1 = this._pathData.f.v, m1 = 1, p1 = (l1 = f1 = 0, true), u1 = n1.segments, o1 < 0 && P1.v.c) for(n1.tLength < Math.abs(o1) && (o1 = -Math.abs(o1) % n1.tLength), m1 = (d1 = u1[f1 = u1.length - 1].points).length - 1; o1 < 0;)o1 += d1[m1].partialLength, (m1 -= 1) < 0 && (m1 = (d1 = u1[f1 -= 1].points).length - 1);
                c1 = (d1 = u1[f1].points)[m1 - 1], y1 = (h1 = d1[m1]).partialLength;
            }
            a1 = T1.length, i1 = r1 = 0;
            var M1, F1, w1, I1, V1, B1 = 1.2 * t1.finalSize * .714, R1 = !0;
            w1 = x1.length;
            var L1, G1, z1, N1, O1, H1, j1, q1, W1, Y1, X1, K1, $1 = -1, Z1 = o1, J1 = f1, U1 = m1, Q1 = -1, tt1 = "", et1 = this.defaultPropsArray;
            if (2 === t1.j || 1 === t1.j) {
                var rt1 = 0, it1 = 0, st1 = 2 === t1.j ? -0.5 : -1, at1 = 0, nt1 = !0;
                for(s1 = 0; s1 < a1; s1 += 1)if (T1[s1].n) {
                    for(rt1 && (rt1 += it1); at1 < s1;)T1[at1].animatorJustifyOffset = rt1, at1 += 1;
                    nt1 = (rt1 = 0, true);
                } else {
                    for(F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).t.propType && (nt1 && 2 === t1.j && (it1 += M1.t.v * st1), (V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars)).length ? rt1 += M1.t.v * V1[0] * st1 : rt1 += M1.t.v * V1 * st1);
                    nt1 = !1;
                }
                for(rt1 && (rt1 += it1); at1 < s1;)T1[at1].animatorJustifyOffset = rt1, at1 += 1;
            }
            for(s1 = 0; s1 < a1; s1 += 1){
                if (A1.reset(), N1 = 1, T1[s1].n) r1 = 0, i1 += t1.yOffset, i1 += R1 ? 1 : 0, o1 = Z1, R1 = !1, this._hasMaskedPath && (m1 = U1, c1 = (d1 = u1[f1 = J1].points)[m1 - 1], y1 = (h1 = d1[m1]).partialLength, l1 = 0), K1 = W1 = X1 = tt1 = "", et1 = this.defaultPropsArray;
                else {
                    if (this._hasMaskedPath) {
                        if (Q1 !== T1[s1].line) {
                            switch(t1.j){
                                case 1:
                                    o1 += g1 - t1.lineWidths[T1[s1].line];
                                    break;
                                case 2:
                                    o1 += (g1 - t1.lineWidths[T1[s1].line]) / 2;
                            }
                            Q1 = T1[s1].line;
                        }
                        $1 !== T1[s1].ind && (T1[$1] && (o1 += T1[$1].extra), o1 += T1[s1].an / 2, $1 = T1[s1].ind), o1 += E1[0] * T1[s1].an * .005;
                        var ot1 = 0;
                        for(F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).p.propType && ((V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars)).length ? ot1 += M1.p.v[0] * V1[0] : ot1 += M1.p.v[0] * V1), M1.a.propType && ((V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars)).length ? ot1 += M1.a.v[0] * V1[0] : ot1 += M1.a.v[0] * V1);
                        for(p1 = !0; p1;)o1 + ot1 <= l1 + y1 || !d1 ? (v1 = (o1 + ot1 - l1) / h1.partialLength, G1 = c1.point[0] + (h1.point[0] - c1.point[0]) * v1, z1 = c1.point[1] + (h1.point[1] - c1.point[1]) * v1, A1.translate(-E1[0] * T1[s1].an * .005, -E1[1] * B1 * .01), p1 = !1) : d1 && (l1 += h1.partialLength, (m1 += 1) >= d1.length && (m1 = 0, d1 = u1[f1 += 1] ? u1[f1].points : P1.v.c ? u1[f1 = m1 = 0].points : (l1 -= h1.partialLength, null)), d1 && (c1 = h1, y1 = (h1 = d1[m1]).partialLength));
                        L1 = T1[s1].an / 2 - T1[s1].add, A1.translate(-L1, 0, 0);
                    } else L1 = T1[s1].an / 2 - T1[s1].add, A1.translate(-L1, 0, 0), A1.translate(-E1[0] * T1[s1].an * .005, -E1[1] * B1 * .01, 0);
                    for(F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).t.propType && (V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars), 0 === r1 && 0 === t1.j || (this._hasMaskedPath ? V1.length ? o1 += M1.t.v * V1[0] : o1 += M1.t.v * V1 : V1.length ? r1 += M1.t.v * V1[0] : r1 += M1.t.v * V1));
                    for(t1.strokeWidthAnim && (H1 = t1.sw || 0), t1.strokeColorAnim && (O1 = t1.sc ? [
                        t1.sc[0],
                        t1.sc[1],
                        t1.sc[2]
                    ] : [
                        0,
                        0,
                        0
                    ]), t1.fillColorAnim && t1.fc && (j1 = [
                        t1.fc[0],
                        t1.fc[1],
                        t1.fc[2]
                    ]), F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).a.propType && ((V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars)).length ? A1.translate(-M1.a.v[0] * V1[0], -M1.a.v[1] * V1[1], M1.a.v[2] * V1[2]) : A1.translate(-M1.a.v[0] * V1, -M1.a.v[1] * V1, M1.a.v[2] * V1));
                    for(F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).s.propType && ((V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars)).length ? A1.scale(1 + (M1.s.v[0] - 1) * V1[0], 1 + (M1.s.v[1] - 1) * V1[1], 1) : A1.scale(1 + (M1.s.v[0] - 1) * V1, 1 + (M1.s.v[1] - 1) * V1, 1));
                    for(F1 = 0; F1 < w1; F1 += 1){
                        if (M1 = x1[F1].a, V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars), M1.sk.propType && (V1.length ? A1.skewFromAxis(-M1.sk.v * V1[0], M1.sa.v * V1[1]) : A1.skewFromAxis(-M1.sk.v * V1, M1.sa.v * V1)), M1.r.propType && (V1.length ? A1.rotateZ(-M1.r.v * V1[2]) : A1.rotateZ(-M1.r.v * V1)), M1.ry.propType && (V1.length ? A1.rotateY(M1.ry.v * V1[1]) : A1.rotateY(M1.ry.v * V1)), M1.rx.propType && (V1.length ? A1.rotateX(M1.rx.v * V1[0]) : A1.rotateX(M1.rx.v * V1)), M1.o.propType && (V1.length ? N1 += (M1.o.v * V1[0] - N1) * V1[0] : N1 += (M1.o.v * V1 - N1) * V1), t1.strokeWidthAnim && M1.sw.propType && (V1.length ? H1 += M1.sw.v * V1[0] : H1 += M1.sw.v * V1), t1.strokeColorAnim && M1.sc.propType) for(q1 = 0; q1 < 3; q1 += 1)V1.length ? O1[q1] += (M1.sc.v[q1] - O1[q1]) * V1[0] : O1[q1] += (M1.sc.v[q1] - O1[q1]) * V1;
                        if (t1.fillColorAnim && t1.fc) {
                            if (M1.fc.propType) for(q1 = 0; q1 < 3; q1 += 1)V1.length ? j1[q1] += (M1.fc.v[q1] - j1[q1]) * V1[0] : j1[q1] += (M1.fc.v[q1] - j1[q1]) * V1;
                            M1.fh.propType && (j1 = V1.length ? addHueToRGB(j1, M1.fh.v * V1[0]) : addHueToRGB(j1, M1.fh.v * V1)), M1.fs.propType && (j1 = V1.length ? addSaturationToRGB(j1, M1.fs.v * V1[0]) : addSaturationToRGB(j1, M1.fs.v * V1)), M1.fb.propType && (j1 = V1.length ? addBrightnessToRGB(j1, M1.fb.v * V1[0]) : addBrightnessToRGB(j1, M1.fb.v * V1));
                        }
                    }
                    for(F1 = 0; F1 < w1; F1 += 1)(M1 = x1[F1].a).p.propType && (V1 = x1[F1].s.getMult(T1[s1].anIndexes[F1], S1.a[F1].s.totalChars), this._hasMaskedPath ? V1.length ? A1.translate(0, M1.p.v[1] * V1[0], -M1.p.v[2] * V1[1]) : A1.translate(0, M1.p.v[1] * V1, -M1.p.v[2] * V1) : V1.length ? A1.translate(M1.p.v[0] * V1[0], M1.p.v[1] * V1[1], -M1.p.v[2] * V1[2]) : A1.translate(M1.p.v[0] * V1, M1.p.v[1] * V1, -M1.p.v[2] * V1));
                    if (t1.strokeWidthAnim && (W1 = H1 < 0 ? 0 : H1), t1.strokeColorAnim && (Y1 = "rgb(" + Math.round(255 * O1[0]) + "," + Math.round(255 * O1[1]) + "," + Math.round(255 * O1[2]) + ")"), t1.fillColorAnim && t1.fc && (X1 = "rgb(" + Math.round(255 * j1[0]) + "," + Math.round(255 * j1[1]) + "," + Math.round(255 * j1[2]) + ")"), this._hasMaskedPath) {
                        if (A1.translate(0, -t1.ls), A1.translate(0, E1[1] * B1 * .01 + i1, 0), S1.p.p) {
                            b1 = (h1.point[1] - c1.point[1]) / (h1.point[0] - c1.point[0]);
                            var ht1 = 180 * Math.atan(b1) / Math.PI;
                            h1.point[0] < c1.point[0] && (ht1 += 180), A1.rotate(-ht1 * Math.PI / 180);
                        }
                        A1.translate(G1, z1, 0), o1 -= E1[0] * T1[s1].an * .005, T1[s1 + 1] && $1 !== T1[s1 + 1].ind && (o1 += T1[s1].an / 2, o1 += .001 * t1.tr * t1.finalSize);
                    } else {
                        switch(A1.translate(r1, i1, 0), t1.ps && A1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), t1.j){
                            case 1:
                                A1.translate(T1[s1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[T1[s1].line]), 0, 0);
                                break;
                            case 2:
                                A1.translate(T1[s1].animatorJustifyOffset + t1.justifyOffset + (t1.boxWidth - t1.lineWidths[T1[s1].line]) / 2, 0, 0);
                        }
                        A1.translate(0, -t1.ls), A1.translate(L1, 0, 0), A1.translate(E1[0] * T1[s1].an * .005, E1[1] * B1 * .01, 0), r1 += T1[s1].l + .001 * t1.tr * t1.finalSize;
                    }
                    "html" === C1 ? tt1 = A1.toCSS() : "svg" === C1 ? tt1 = A1.to2dCSS() : et1 = [
                        A1.props[0],
                        A1.props[1],
                        A1.props[2],
                        A1.props[3],
                        A1.props[4],
                        A1.props[5],
                        A1.props[6],
                        A1.props[7],
                        A1.props[8],
                        A1.props[9],
                        A1.props[10],
                        A1.props[11],
                        A1.props[12],
                        A1.props[13],
                        A1.props[14],
                        A1.props[15]
                    ], K1 = N1;
                }
                this.lettersChangedFlag = _1 <= s1 ? (I1 = new LetterProps(K1, W1, Y1, X1, tt1, et1), this.renderedLetters.push(I1), _1 += 1, !0) : (I1 = this.renderedLetters[s1]).update(K1, W1, Y1, X1, tt1, et1) || this.lettersChangedFlag;
            }
        }
    }, TextAnimatorProperty.prototype.getValue = function() {
        this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty), LetterProps.prototype.update = function(t1, e1, r1, i1, s1, a1) {
        this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1;
        var n1 = this._mdf.p = !1;
        return this.o !== t1 && (this.o = t1, n1 = this._mdf.o = !0), this.sw !== e1 && (this.sw = e1, n1 = this._mdf.sw = !0), this.sc !== r1 && (this.sc = r1, n1 = this._mdf.sc = !0), this.fc !== i1 && (this.fc = i1, n1 = this._mdf.fc = !0), this.m !== s1 && (this.m = s1, n1 = this._mdf.m = !0), !a1.length || this.p[0] === a1[0] && this.p[1] === a1[1] && this.p[4] === a1[4] && this.p[5] === a1[5] && this.p[12] === a1[12] && this.p[13] === a1[13] || (this.p = a1, n1 = this._mdf.p = !0), n1;
    }, TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ], TextProperty.prototype.copyData = function(t1, e1) {
        for(var r1 in e1)Object.prototype.hasOwnProperty.call(e1, r1) && (t1[r1] = e1[r1]);
        return t1;
    }, TextProperty.prototype.setCurrentData = function(t1) {
        t1.__complete || this.completeTextData(t1), this.currentData = t1, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
        return this.kf = 1 < this.data.d.k.length, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(t1) {
        this.effectsSequence.push(t1), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(t1) {
        if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t1) {
            this.currentData.t = this.data.d.k[this.keysIndex].s.t;
            var e1 = this.currentData, r1 = this.keysIndex;
            if (this.lock) this.setCurrentData(this.currentData);
            else {
                var i1;
                this.lock = !0, this._mdf = !1;
                var s1 = this.effectsSequence.length, a1 = t1 || this.data.d.k[this.keysIndex].s;
                for(i1 = 0; i1 < s1; i1 += 1)a1 = r1 !== this.keysIndex ? this.effectsSequence[i1](a1, a1.t) : this.effectsSequence[i1](this.currentData, a1.t);
                e1 !== a1 && this.setCurrentData(a1), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
            }
        }
    }, TextProperty.prototype.getKeyframeValue = function() {
        for(var t1 = this.data.d.k, e1 = this.elem.comp.renderedFrame, r1 = 0, i1 = t1.length; r1 <= i1 - 1 && !(r1 === i1 - 1 || t1[r1 + 1].t > e1);)r1 += 1;
        return this.keysIndex !== r1 && (this.keysIndex = r1), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(t1) {
        for(var e1, r1 = FontManager.getCombinedCharacterCodes(), i1 = [], s1 = 0, a1 = t1.length; s1 < a1;)e1 = t1.charCodeAt(s1), -1 !== r1.indexOf(e1) ? i1[i1.length - 1] += t1.charAt(s1) : 55296 <= e1 && e1 <= 56319 && 56320 <= (e1 = t1.charCodeAt(s1 + 1)) && e1 <= 57343 ? (i1.push(t1.substr(s1, 2)), s1 += 1) : i1.push(t1.charAt(s1)), s1 += 1;
        return i1;
    }, TextProperty.prototype.completeTextData = function(t1) {
        t1.__complete = !0;
        var e1, r1, i1, s1, a1, n1, o1, h1 = this.elem.globalData.fontManager, l1 = this.data, p1 = [], m1 = 0, f1 = l1.m.g, c1 = 0, d1 = 0, u1 = 0, y1 = [], g1 = 0, v1 = 0, b1 = h1.getFontByName(t1.f), P1 = 0, E1 = getFontProperties(b1);
        t1.fWeight = E1.weight, t1.fStyle = E1.style, t1.finalSize = t1.s, t1.finalText = this.buildFinalText(t1.t), r1 = t1.finalText.length, t1.finalLineHeight = t1.lh;
        var x1, S1 = t1.tr / 1e3 * t1.finalSize;
        if (t1.sz) for(var A1, C1, _1 = !0, T1 = t1.sz[0], k1 = t1.sz[1]; _1;){
            g1 = A1 = 0, r1 = (C1 = this.buildFinalText(t1.t)).length, S1 = t1.tr / 1e3 * t1.finalSize;
            var D1 = -1;
            for(e1 = 0; e1 < r1; e1 += 1)x1 = C1[e1].charCodeAt(0), i1 = !1, " " === C1[e1] ? D1 = e1 : 13 !== x1 && 3 !== x1 || (i1 = (g1 = 0, true), A1 += t1.finalLineHeight || 1.2 * t1.finalSize), T1 < g1 + (P1 = h1.chars ? (o1 = h1.getCharData(C1[e1], b1.fStyle, b1.fFamily), i1 ? 0 : o1.w * t1.finalSize / 100) : h1.measureText(C1[e1], t1.f, t1.finalSize)) && " " !== C1[e1] ? (-1 === D1 ? r1 += 1 : e1 = D1, A1 += t1.finalLineHeight || 1.2 * t1.finalSize, C1.splice(e1, D1 === e1 ? 1 : 0, "\r"), D1 = -1, g1 = 0) : (g1 += P1, g1 += S1);
            A1 += b1.ascent * t1.finalSize / 100, this.canResize && t1.finalSize > this.minimumFontSize && k1 < A1 ? (t1.finalSize -= 1, t1.finalLineHeight = t1.finalSize * t1.lh / t1.s) : (t1.finalText = C1, r1 = t1.finalText.length, _1 = !1);
        }
        g1 = -S1;
        var M1, F1 = P1 = 0;
        for(e1 = 0; e1 < r1; e1 += 1)if (i1 = !1, 13 === (x1 = (M1 = t1.finalText[e1]).charCodeAt(0)) || 3 === x1 ? (F1 = 0, y1.push(g1), v1 = v1 < g1 ? g1 : v1, g1 = -2 * S1, i1 = (s1 = "", true), u1 += 1) : s1 = M1, P1 = h1.chars ? (o1 = h1.getCharData(M1, b1.fStyle, h1.getFontByName(t1.f).fFamily), i1 ? 0 : o1.w * t1.finalSize / 100) : h1.measureText(s1, t1.f, t1.finalSize), " " === M1 ? F1 += P1 + S1 : (g1 += P1 + S1 + F1, F1 = 0), p1.push({
            l: P1,
            an: P1,
            add: c1,
            n: i1,
            anIndexes: [],
            val: s1,
            line: u1,
            animatorJustifyOffset: 0
        }), 2 == f1) {
            if (c1 += P1, "" === s1 || " " === s1 || e1 === r1 - 1) {
                for("" !== s1 && " " !== s1 || (c1 -= P1); d1 <= e1;)p1[d1].an = c1, p1[d1].ind = m1, p1[d1].extra = P1, d1 += 1;
                m1 += 1, c1 = 0;
            }
        } else if (3 == f1) {
            if (c1 += P1, "" === s1 || e1 === r1 - 1) {
                for("" === s1 && (c1 -= P1); d1 <= e1;)p1[d1].an = c1, p1[d1].ind = m1, p1[d1].extra = P1, d1 += 1;
                c1 = 0, m1 += 1;
            }
        } else p1[m1].ind = m1, p1[m1].extra = 0, m1 += 1;
        if (t1.l = p1, v1 = v1 < g1 ? g1 : v1, y1.push(g1), t1.sz) t1.boxWidth = t1.sz[0], t1.justifyOffset = 0;
        else switch(t1.boxWidth = v1, t1.j){
            case 1:
                t1.justifyOffset = -t1.boxWidth;
                break;
            case 2:
                t1.justifyOffset = -t1.boxWidth / 2;
                break;
            default:
                t1.justifyOffset = 0;
        }
        t1.lineWidths = y1;
        var w1, I1, V1, B1, R1 = l1.a;
        n1 = R1.length;
        var L1 = [];
        for(a1 = 0; a1 < n1; a1 += 1){
            for((w1 = R1[a1]).a.sc && (t1.strokeColorAnim = !0), w1.a.sw && (t1.strokeWidthAnim = !0), (w1.a.fc || w1.a.fh || w1.a.fs || w1.a.fb) && (t1.fillColorAnim = !0), B1 = 0, V1 = w1.s.b, e1 = 0; e1 < r1; e1 += 1)(I1 = p1[e1]).anIndexes[a1] = B1, (1 == V1 && "" !== I1.val || 2 == V1 && "" !== I1.val && " " !== I1.val || 3 == V1 && (I1.n || " " == I1.val || e1 == r1 - 1) || 4 == V1 && (I1.n || e1 == r1 - 1)) && (1 === w1.s.rn && L1.push(B1), B1 += 1);
            l1.a[a1].s.totalChars = B1;
            var G1, z1 = -1;
            if (1 === w1.s.rn) for(e1 = 0; e1 < r1; e1 += 1)z1 != (I1 = p1[e1]).anIndexes[a1] && (z1 = I1.anIndexes[a1], G1 = L1.splice(Math.floor(Math.random() * L1.length), 1)[0]), I1.anIndexes[a1] = G1;
        }
        t1.yOffset = t1.finalLineHeight || 1.2 * t1.finalSize, t1.ls = t1.ls || 0, t1.ascent = b1.ascent * t1.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(t1, e1) {
        e1 = void 0 === e1 ? this.keysIndex : e1;
        var r1 = this.copyData({}, this.data.d.k[e1].s);
        r1 = this.copyData(r1, t1), this.data.d.k[e1].s = r1, this.recalculate(e1), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(t1) {
        var e1 = this.data.d.k[t1].s;
        e1.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e1);
    }, TextProperty.prototype.canResizeFont = function(t1) {
        this.canResize = t1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(t1) {
        this.minimumFontSize = Math.floor(t1) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var c1 = Math.max, d1 = Math.min, u1 = Math.floor;
        function i1(t1, e1) {
            this._currentTextLength = -1, this.k = !1, this.data = e1, this.elem = t1, this.comp = t1.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t1), this.s = PropertyFactory.getProp(t1, e1.s || {
                k: 0
            }, 0, 0, this), this.e = "e" in e1 ? PropertyFactory.getProp(t1, e1.e, 0, 0, this) : {
                v: 100
            }, this.o = PropertyFactory.getProp(t1, e1.o || {
                k: 0
            }, 0, 0, this), this.xe = PropertyFactory.getProp(t1, e1.xe || {
                k: 0
            }, 0, 0, this), this.ne = PropertyFactory.getProp(t1, e1.ne || {
                k: 0
            }, 0, 0, this), this.a = PropertyFactory.getProp(t1, e1.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
        }
        return i1.prototype = {
            getMult: function(t1) {
                this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                var e1 = 0, r1 = 0, i1 = 1, s1 = 1;
                0 < this.ne.v ? e1 = this.ne.v / 100 : r1 = -this.ne.v / 100, 0 < this.xe.v ? i1 = 1 - this.xe.v / 100 : s1 = 1 + this.xe.v / 100;
                var a1 = BezierFactory.getBezierEasing(e1, r1, i1, s1).get, n1 = 0, o1 = this.finalS, h1 = this.finalE, l1 = this.data.sh;
                if (2 === l1) n1 = a1(n1 = h1 === o1 ? h1 <= t1 ? 1 : 0 : c1(0, d1(.5 / (h1 - o1) + (t1 - o1) / (h1 - o1), 1)));
                else if (3 === l1) n1 = a1(n1 = h1 === o1 ? h1 <= t1 ? 0 : 1 : 1 - c1(0, d1(.5 / (h1 - o1) + (t1 - o1) / (h1 - o1), 1)));
                else if (4 === l1) h1 === o1 ? n1 = 0 : (n1 = c1(0, d1(.5 / (h1 - o1) + (t1 - o1) / (h1 - o1), 1))) < .5 ? n1 *= 2 : n1 = 1 - 2 * (n1 - .5), n1 = a1(n1);
                else if (5 === l1) {
                    if (h1 === o1) n1 = 0;
                    else {
                        var p1 = h1 - o1, m1 = -p1 / 2 + (t1 = d1(c1(0, t1 + .5 - o1), h1 - o1)), f1 = p1 / 2;
                        n1 = Math.sqrt(1 - m1 * m1 / (f1 * f1));
                    }
                    n1 = a1(n1);
                } else n1 = 6 === l1 ? a1(n1 = h1 === o1 ? 0 : (t1 = d1(c1(0, t1 + .5 - o1), h1 - o1), (1 + Math.cos(Math.PI + 2 * Math.PI * t1 / (h1 - o1))) / 2)) : (t1 >= u1(o1) && (n1 = c1(0, d1(t1 - o1 < 0 ? d1(h1, 1) - (o1 - t1) : h1 - t1, 1))), a1(n1));
                return n1 * this.a.v;
            },
            getValue: function(t1) {
                this.iterateDynamicProperties(), this._mdf = t1 || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t1 && 2 === this.data.r && (this.e.v = this._currentTextLength);
                var e1 = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r1 = this.o.v / e1, i1 = this.s.v / e1 + r1, s1 = this.e.v / e1 + r1;
                if (s1 < i1) {
                    var a1 = i1;
                    i1 = s1, s1 = a1;
                }
                this.finalS = i1, this.finalE = s1;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], i1), {
            getTextSelectorProp: function(t1, e1, r1) {
                return new i1(t1, e1, r1);
            }
        };
    }(), poolFactory = function(t1, e1, r1) {
        var i1 = 0, s1 = t1, a1 = createSizedArray(s1);
        return {
            newElement: function() {
                return i1 ? a1[i1 -= 1] : e1();
            },
            release: function(t1) {
                i1 === s1 && (a1 = pooling.double(a1), s1 *= 2), r1 && r1(t1), a1[i1] = t1, i1 += 1;
            }
        };
    }, pooling = {
        double: function(t1) {
            return t1.concat(createSizedArray(t1.length));
        }
    }, pointPool = poolFactory(8, function() {
        return createTypedArray("float32", 2);
    }), shapePool = (xB = poolFactory(4, function() {
        return new ShapePath;
    }, function(t1) {
        var e1, r1 = t1._length;
        for(e1 = 0; e1 < r1; e1 += 1)pointPool.release(t1.v[e1]), pointPool.release(t1.i[e1]), pointPool.release(t1.o[e1]), t1.v[e1] = null, t1.i[e1] = null, t1.o[e1] = null;
        t1._length = 0, t1.c = !1;
    }), xB.clone = function(t1) {
        var e1, r1 = xB.newElement(), i1 = void 0 === t1._length ? t1.v.length : t1._length;
        for(r1.setLength(i1), r1.c = t1.c, e1 = 0; e1 < i1; e1 += 1)r1.setTripleAt(t1.v[e1][0], t1.v[e1][1], t1.o[e1][0], t1.o[e1][1], t1.i[e1][0], t1.i[e1][1], e1);
        return r1;
    }, xB), xB, shapeCollectionPool = (FB = {
        newShapeCollection: function() {
            var t1;
            t1 = GB ? IB[GB -= 1] : new ShapeCollection;
            return t1;
        },
        release: function(t1) {
            var e1, r1 = t1._length;
            for(e1 = 0; e1 < r1; e1 += 1)shapePool.release(t1.shapes[e1]);
            t1._length = 0, GB === HB && (IB = pooling.double(IB), HB *= 2);
            IB[GB] = t1, GB += 1;
        }
    }, GB = 0, HB = 4, IB = createSizedArray(HB), FB), FB, GB, HB, IB, segmentsLengthPool = poolFactory(8, function() {
        return {
            lengths: [],
            totalLength: 0
        };
    }, function(t1) {
        var e1, r1 = t1.lengths.length;
        for(e1 = 0; e1 < r1; e1 += 1)bezierLengthPool.release(t1.lengths[e1]);
        t1.lengths.length = 0;
    }), bezierLengthPool = poolFactory(8, function() {
        return {
            addedLength: 0,
            percents: createTypedArray("float32", defaultCurveSegments),
            lengths: createTypedArray("float32", defaultCurveSegments)
        };
    }), markerParser = function() {
        function a1(t1) {
            for(var e1, r1 = t1.split("\r\n"), i1 = {}, s1 = 0, a1 = 0; a1 < r1.length; a1 += 1)2 === (e1 = r1[a1].split(":")).length && (i1[e1[0]] = e1[1].trim(), s1 += 1);
            if (0 === s1) throw new Error;
            return i1;
        }
        return function(e1) {
            for(var t1 = [], r1 = 0; r1 < e1.length; r1 += 1){
                var i1 = e1[r1], s1 = {
                    time: i1.tm,
                    duration: i1.dr
                };
                try {
                    s1.payload = JSON.parse(e1[r1].cm);
                } catch (t1) {
                    try {
                        s1.payload = a1(e1[r1].cm);
                    } catch (t1) {
                        s1.payload = {
                            name: e1[r1]
                        };
                    }
                }
                t1.push(s1);
            }
            return t1;
        };
    }();
    function BaseRenderer() {}
    function SVGRenderer(t1, e1) {
        this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
        var r1 = "";
        if (e1 && e1.title) {
            var i1 = createNS("title"), s1 = createElementID();
            i1.setAttribute("id", s1), i1.textContent = e1.title, this.svgElement.appendChild(i1), r1 += s1;
        }
        if (e1 && e1.description) {
            var a1 = createNS("desc"), n1 = createElementID();
            a1.setAttribute("id", n1), a1.textContent = e1.description, this.svgElement.appendChild(a1), r1 += " " + n1;
        }
        r1 && this.svgElement.setAttribute("aria-labelledby", r1);
        var o1 = createNS("defs");
        this.svgElement.appendChild(o1);
        var h1 = createNS("g");
        this.svgElement.appendChild(h1), this.layerElement = h1, this.renderConfig = {
            preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
            progressiveLoad: e1 && e1.progressiveLoad || !1,
            hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
            viewBoxOnly: e1 && e1.viewBoxOnly || !1,
            viewBoxSize: e1 && e1.viewBoxSize || !1,
            className: e1 && e1.className || "",
            id: e1 && e1.id || "",
            focusable: e1 && e1.focusable,
            filterSize: {
                width: e1 && e1.filterSize && e1.filterSize.width || "100%",
                height: e1 && e1.filterSize && e1.filterSize.height || "100%",
                x: e1 && e1.filterSize && e1.filterSize.x || "0%",
                y: e1 && e1.filterSize && e1.filterSize.y || "0%"
            }
        }, this.globalData = {
            _mdf: !1,
            frameNum: -1,
            defs: o1,
            renderConfig: this.renderConfig
        }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    function CanvasRenderer(t1, e1) {
        this.animationItem = t1, this.renderConfig = {
            clearCanvas: !e1 || void 0 === e1.clearCanvas || e1.clearCanvas,
            context: e1 && e1.context || null,
            progressiveLoad: e1 && e1.progressiveLoad || !1,
            preserveAspectRatio: e1 && e1.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
            className: e1 && e1.className || "",
            id: e1 && e1.id || ""
        }, this.renderConfig.dpr = e1 && e1.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e1 && e1.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
            frameNum: -1,
            _mdf: !1,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas";
    }
    function HybridRenderer(t1, e1) {
        this.animationItem = t1, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
            className: e1 && e1.className || "",
            imagePreserveAspectRatio: e1 && e1.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(e1 && !1 === e1.hideOnTransparent),
            filterSize: {
                width: e1 && e1.filterSize && e1.filterSize.width || "400%",
                height: e1 && e1.filterSize && e1.filterSize.height || "400%",
                x: e1 && e1.filterSize && e1.filterSize.x || "-100%",
                y: e1 && e1.filterSize && e1.filterSize.y || "-100%"
            }
        }, this.globalData = {
            _mdf: !1,
            frameNum: -1,
            renderConfig: this.renderConfig
        }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    function MaskElement(t1, e1, r1) {
        this.data = t1, this.element = e1, this.globalData = r1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
        var i1, s1, a1 = this.globalData.defs, n1 = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(n1), this.solidPath = "";
        var o1, h1, l1, p1, m1, f1, c1 = this.masksProperties, d1 = 0, u1 = [], y1 = createElementID(), g1 = "clipPath", v1 = "clip-path";
        for(i1 = 0; i1 < n1; i1 += 1)if (("a" !== c1[i1].mode && "n" !== c1[i1].mode || c1[i1].inv || 100 !== c1[i1].o.k || c1[i1].o.x) && (v1 = g1 = "mask"), "s" !== c1[i1].mode && "i" !== c1[i1].mode || 0 !== d1 ? l1 = null : ((l1 = createNS("rect")).setAttribute("fill", "#ffffff"), l1.setAttribute("width", this.element.comp.data.w || 0), l1.setAttribute("height", this.element.comp.data.h || 0), u1.push(l1)), s1 = createNS("path"), "n" === c1[i1].mode) this.viewData[i1] = {
            op: PropertyFactory.getProp(this.element, c1[i1].o, 0, .01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, c1[i1], 3),
            elem: s1,
            lastPath: ""
        }, a1.appendChild(s1);
        else {
            var b1;
            if (d1 += 1, s1.setAttribute("fill", "s" === c1[i1].mode ? "#000000" : "#ffffff"), s1.setAttribute("clip-rule", "nonzero"), 0 !== c1[i1].x.k ? (v1 = g1 = "mask", f1 = PropertyFactory.getProp(this.element, c1[i1].x, 0, null, this.element), b1 = createElementID(), (p1 = createNS("filter")).setAttribute("id", b1), (m1 = createNS("feMorphology")).setAttribute("operator", "erode"), m1.setAttribute("in", "SourceGraphic"), m1.setAttribute("radius", "0"), p1.appendChild(m1), a1.appendChild(p1), s1.setAttribute("stroke", "s" === c1[i1].mode ? "#000000" : "#ffffff")) : f1 = m1 = null, this.storedData[i1] = {
                elem: s1,
                x: f1,
                expan: m1,
                lastPath: "",
                lastOperator: "",
                filterId: b1,
                lastRadius: 0
            }, "i" === c1[i1].mode) {
                h1 = u1.length;
                var P1 = createNS("g");
                for(o1 = 0; o1 < h1; o1 += 1)P1.appendChild(u1[o1]);
                var E1 = createNS("mask");
                E1.setAttribute("mask-type", "alpha"), E1.setAttribute("id", y1 + "_" + d1), E1.appendChild(s1), a1.appendChild(E1), P1.setAttribute("mask", "url(" + locationHref + "#" + y1 + "_" + d1 + ")"), u1.length = 0, u1.push(P1);
            } else u1.push(s1);
            c1[i1].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i1] = {
                elem: s1,
                lastPath: "",
                op: PropertyFactory.getProp(this.element, c1[i1].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, c1[i1], 3),
                invRect: l1
            }, this.viewData[i1].prop.k || this.drawPath(c1[i1], this.viewData[i1].prop.v, this.viewData[i1]);
        }
        for(this.maskElement = createNS(g1), n1 = u1.length, i1 = 0; i1 < n1; i1 += 1)this.maskElement.appendChild(u1[i1]);
        0 < d1 && (this.maskElement.setAttribute("id", y1), this.element.maskedElement.setAttribute(v1, "url(" + locationHref + "#" + y1 + ")"), a1.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    function HierarchyElement() {}
    function FrameElement() {}
    function TransformElement() {}
    function RenderableElement() {}
    function RenderableDOMElement() {}
    function ProcessedElement(t1, e1) {
        this.elem = t1, this.pos = e1;
    }
    function SVGStyleData(t1, e1) {
        this.data = t1, this.type = t1.ty, this.d = "", this.lvl = e1, this._mdf = !1, this.closed = !0 === t1.hd, this.pElem = createNS("path"), this.msElem = null;
    }
    function SVGShapeData(t1, e1, r1) {
        this.caches = [], this.styles = [], this.transformers = t1, this.lStr = "", this.sh = r1, this.lvl = e1, this._isAnimated = !!r1.k;
        for(var i1 = 0, s1 = t1.length; i1 < s1;){
            if (t1[i1].mProps.dynamicProperties.length) {
                this._isAnimated = !0;
                break;
            }
            i1 += 1;
        }
    }
    function SVGTransformData(t1, e1, r1) {
        this.transform = {
            mProps: t1,
            op: e1,
            container: r1
        }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    function SVGStrokeStyleData(t1, e1, r1) {
        this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1, this._isAnimated = !!this._isAnimated;
    }
    function SVGFillStyleData(t1, e1, r1) {
        this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.c = PropertyFactory.getProp(t1, e1.c, 1, 255, this), this.style = r1;
    }
    function SVGGradientFillStyleData(t1, e1, r1) {
        this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.initGradientData(t1, e1, r1);
    }
    function SVGGradientStrokeStyleData(t1, e1, r1) {
        this.initDynamicPropertyContainer(t1), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t1, e1.w, 0, null, this), this.d = new DashProperty(t1, e1.d || {}, "svg", this), this.initGradientData(t1, e1, r1), this._isAnimated = !!this._isAnimated;
    }
    function ShapeGroupData() {
        this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    BaseRenderer.prototype.checkLayers = function(t1) {
        var e1, r1, i1 = this.layers.length;
        for(this.completeLayers = !0, e1 = i1 - 1; 0 <= e1; e1 -= 1)this.elements[e1] || (r1 = this.layers[e1]).ip - r1.st <= t1 - this.layers[e1].st && r1.op - r1.st > t1 - this.layers[e1].st && this.buildItem(e1), this.completeLayers = !!this.elements[e1] && this.completeLayers;
        this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(t1) {
        switch(t1.ty){
            case 2:
                return this.createImage(t1);
            case 0:
                return this.createComp(t1);
            case 1:
                return this.createSolid(t1);
            case 3:
                return this.createNull(t1);
            case 4:
                return this.createShape(t1);
            case 5:
                return this.createText(t1);
            case 6:
                return this.createAudio(t1);
            case 13:
                return this.createCamera(t1);
            case 15:
                return this.createFootage(t1);
            default:
                return this.createNull(t1);
        }
    }, BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(t1) {
        return new AudioElement(t1, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(t1) {
        return new FootageElement(t1, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
        var t1, e1 = this.layers.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.buildItem(t1);
        this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(t1) {
        var e1;
        this.completeLayers = !1;
        var r1, i1 = t1.length, s1 = this.layers.length;
        for(e1 = 0; e1 < i1; e1 += 1)for(r1 = 0; r1 < s1;){
            if (this.layers[r1].id === t1[e1].id) {
                this.layers[r1] = t1[e1];
                break;
            }
            r1 += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(t1) {
        this.globalData.projectInterface = t1;
    }, BaseRenderer.prototype.initItems = function() {
        this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(t1, e1, r1) {
        for(var i1 = this.elements, s1 = this.layers, a1 = 0, n1 = s1.length; a1 < n1;)s1[a1].ind == e1 && (i1[a1] && !0 !== i1[a1] ? (r1.push(i1[a1]), i1[a1].setAsParent(), void 0 !== s1[a1].parent ? this.buildElementParenting(t1, s1[a1].parent, r1) : t1.setHierarchy(r1)) : (this.buildItem(a1), this.addPendingElement(t1))), a1 += 1;
    }, BaseRenderer.prototype.addPendingElement = function(t1) {
        this.pendingElements.push(t1);
    }, BaseRenderer.prototype.searchExtraCompositions = function(t1) {
        var e1, r1 = t1.length;
        for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
            var i1 = this.createComp(t1[e1]);
            i1.initExpressions(), this.globalData.projectInterface.registerComposition(i1);
        }
    }, BaseRenderer.prototype.setupGlobalData = function(t1, e1) {
        this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t1.chars), this.globalData.fontManager.addFonts(t1.fonts, e1), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t1.fr, this.globalData.nm = t1.nm, this.globalData.compSize = {
            w: t1.w,
            h: t1.h
        };
    }, extendPrototype([
        BaseRenderer
    ], SVGRenderer), SVGRenderer.prototype.createNull = function(t1) {
        return new NullElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.createShape = function(t1) {
        return new SVGShapeElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.createText = function(t1) {
        return new SVGTextLottieElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.createImage = function(t1) {
        return new IImageElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.createComp = function(t1) {
        return new SVGCompElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.createSolid = function(t1) {
        return new ISolidElement(t1, this.globalData, this);
    }, SVGRenderer.prototype.configAnimation = function(t1) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t1.w + " " + t1.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t1.w), this.svgElement.setAttribute("height", t1.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)"), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
        var e1 = this.globalData.defs;
        this.setupGlobalData(t1, e1), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t1;
        var r1 = createNS("clipPath"), i1 = createNS("rect");
        i1.setAttribute("width", t1.w), i1.setAttribute("height", t1.h), i1.setAttribute("x", 0), i1.setAttribute("y", 0);
        var s1 = createElementID();
        r1.setAttribute("id", s1), r1.appendChild(i1), this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#" + s1 + ")"), e1.appendChild(r1), this.layers = t1.layers, this.elements = createSizedArray(t1.layers.length);
    }, SVGRenderer.prototype.destroy = function() {
        var t1;
        this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
        var e1 = this.layers ? this.layers.length : 0;
        for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRenderer.prototype.updateContainerSize = function() {}, SVGRenderer.prototype.buildItem = function(t1) {
        var e1 = this.elements;
        if (!e1[t1] && 99 !== this.layers[t1].ty) {
            e1[t1] = !0;
            var r1 = this.createItem(this.layers[t1]);
            e1[t1] = r1, expressionsPlugin && (0 === this.layers[t1].ty && this.globalData.projectInterface.registerComposition(r1), r1.initExpressions()), this.appendElementInPos(r1, t1), this.layers[t1].tt && (this.elements[t1 - 1] && !0 !== this.elements[t1 - 1] ? r1.setMatte(e1[t1 - 1].layerId) : (this.buildItem(t1 - 1), this.addPendingElement(r1)));
        }
    }, SVGRenderer.prototype.checkPendingElements = function() {
        for(; this.pendingElements.length;){
            var t1 = this.pendingElements.pop();
            if (t1.checkParenting(), t1.data.tt) for(var e1 = 0, r1 = this.elements.length; e1 < r1;){
                if (this.elements[e1] === t1) {
                    t1.setMatte(this.elements[e1 - 1].layerId);
                    break;
                }
                e1 += 1;
            }
        }
    }, SVGRenderer.prototype.renderFrame = function(t1) {
        if (this.renderedFrame !== t1 && !this.destroyed) {
            var e1;
            null === t1 ? t1 = this.renderedFrame : this.renderedFrame = t1, this.globalData.frameNum = t1, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t1, this.globalData._mdf = !1;
            var r1 = this.layers.length;
            for(this.completeLayers || this.checkLayers(t1), e1 = r1 - 1; 0 <= e1; e1 -= 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].prepareFrame(t1 - this.layers[e1].st);
            if (this.globalData._mdf) for(e1 = 0; e1 < r1; e1 += 1)(this.completeLayers || this.elements[e1]) && this.elements[e1].renderFrame();
        }
    }, SVGRenderer.prototype.appendElementInPos = function(t1, e1) {
        var r1 = t1.getBaseElement();
        if (r1) {
            for(var i1, s1 = 0; s1 < e1;)this.elements[s1] && !0 !== this.elements[s1] && this.elements[s1].getBaseElement() && (i1 = this.elements[s1].getBaseElement()), s1 += 1;
            i1 ? this.layerElement.insertBefore(r1, i1) : this.layerElement.appendChild(r1);
        }
    }, SVGRenderer.prototype.hide = function() {
        this.layerElement.style.display = "none";
    }, SVGRenderer.prototype.show = function() {
        this.layerElement.style.display = "block";
    }, extendPrototype([
        BaseRenderer
    ], CanvasRenderer), CanvasRenderer.prototype.createShape = function(t1) {
        return new CVShapeElement(t1, this.globalData, this);
    }, CanvasRenderer.prototype.createText = function(t1) {
        return new CVTextElement(t1, this.globalData, this);
    }, CanvasRenderer.prototype.createImage = function(t1) {
        return new CVImageElement(t1, this.globalData, this);
    }, CanvasRenderer.prototype.createComp = function(t1) {
        return new CVCompElement(t1, this.globalData, this);
    }, CanvasRenderer.prototype.createSolid = function(t1) {
        return new CVSolidElement(t1, this.globalData, this);
    }, CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRenderer.prototype.ctxTransform = function(t1) {
        if (1 !== t1[0] || 0 !== t1[1] || 0 !== t1[4] || 1 !== t1[5] || 0 !== t1[12] || 0 !== t1[13]) {
            if (this.renderConfig.clearCanvas) {
                this.transformMat.cloneFromProps(t1);
                var e1 = this.contextData.cTr.props;
                this.transformMat.transform(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14], e1[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
                var r1 = this.contextData.cTr.props;
                this.canvasContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]);
            } else this.canvasContext.transform(t1[0], t1[1], t1[4], t1[5], t1[12], t1[13]);
        }
    }, CanvasRenderer.prototype.ctxOpacity = function(t1) {
        if (!this.renderConfig.clearCanvas) return this.canvasContext.globalAlpha *= t1 < 0 ? 0 : t1, void (this.globalData.currentGlobalAlpha = this.contextData.cO);
        this.contextData.cO *= t1 < 0 ? 0 : t1, this.globalData.currentGlobalAlpha !== this.contextData.cO && (this.canvasContext.globalAlpha = this.contextData.cO, this.globalData.currentGlobalAlpha = this.contextData.cO);
    }, CanvasRenderer.prototype.reset = function() {
        this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
    }, CanvasRenderer.prototype.save = function(t1) {
        if (this.renderConfig.clearCanvas) {
            t1 && this.canvasContext.save();
            var e1, r1 = this.contextData.cTr.props;
            this.contextData._length <= this.contextData.cArrPos && this.contextData.duplicate();
            var i1 = this.contextData.saved[this.contextData.cArrPos];
            for(e1 = 0; e1 < 16; e1 += 1)i1[e1] = r1[e1];
            this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
        } else this.canvasContext.save();
    }, CanvasRenderer.prototype.restore = function(t1) {
        if (this.renderConfig.clearCanvas) {
            t1 && (this.canvasContext.restore(), this.globalData.blendMode = "source-over"), this.contextData.cArrPos -= 1;
            var e1, r1 = this.contextData.saved[this.contextData.cArrPos], i1 = this.contextData.cTr.props;
            for(e1 = 0; e1 < 16; e1 += 1)i1[e1] = r1[e1];
            this.canvasContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]), r1 = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = r1, this.globalData.currentGlobalAlpha !== r1 && (this.canvasContext.globalAlpha = r1, this.globalData.currentGlobalAlpha = r1);
        } else this.canvasContext.restore();
    }, CanvasRenderer.prototype.configAnimation = function(t1) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag("canvas");
            var e1 = this.animationItem.container.style;
            e1.width = "100%", e1.height = "100%";
            var r1 = "0px 0px 0px";
            e1.transformOrigin = r1, e1.mozTransformOrigin = r1, e1.webkitTransformOrigin = r1, e1["-webkit-transform"] = r1, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.data = t1, this.layers = t1.layers, this.transformCanvas = {
            w: t1.w,
            h: t1.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        }, this.setupGlobalData(t1, document.body), this.globalData.canvasContext = this.canvasContext, (this.globalData.renderer = this).globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t1.layers.length), this.updateContainerSize();
    }, CanvasRenderer.prototype.updateContainerSize = function() {
        var t1, e1, r1, i1;
        if (this.reset(), this.animationItem.wrapper && this.animationItem.container ? (t1 = this.animationItem.wrapper.offsetWidth, e1 = this.animationItem.wrapper.offsetHeight, this.animationItem.container.setAttribute("width", t1 * this.renderConfig.dpr), this.animationItem.container.setAttribute("height", e1 * this.renderConfig.dpr)) : (t1 = this.canvasContext.canvas.width * this.renderConfig.dpr, e1 = this.canvasContext.canvas.height * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
            var s1 = this.renderConfig.preserveAspectRatio.split(" "), a1 = s1[1] || "meet", n1 = s1[0] || "xMidYMid", o1 = n1.substr(0, 4), h1 = n1.substr(4);
            r1 = t1 / e1, i1 = this.transformCanvas.w / this.transformCanvas.h, this.transformCanvas.sy = r1 < i1 && "meet" === a1 || i1 < r1 && "slice" === a1 ? (this.transformCanvas.sx = t1 / (this.transformCanvas.w / this.renderConfig.dpr), t1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = e1 / (this.transformCanvas.h / this.renderConfig.dpr), e1 / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === o1 && (i1 < r1 && "meet" === a1 || r1 < i1 && "slice" === a1) ? (t1 - this.transformCanvas.w * (e1 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === o1 && (i1 < r1 && "meet" === a1 || r1 < i1 && "slice" === a1) ? (t1 - this.transformCanvas.w * (e1 / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === h1 && (r1 < i1 && "meet" === a1 || i1 < r1 && "slice" === a1) ? (e1 - this.transformCanvas.h * (t1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === h1 && (r1 < i1 && "meet" === a1 || i1 < r1 && "slice" === a1) ? (e1 - this.transformCanvas.h * (t1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
        } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = t1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = e1 / (this.transformCanvas.h / this.renderConfig.dpr)) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0;
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRenderer.prototype.destroy = function() {
        var t1;
        for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t1 = (this.layers ? this.layers.length : 0) - 1; 0 <= t1; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
        this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRenderer.prototype.renderFrame = function(t1, e1) {
        if ((this.renderedFrame !== t1 || !0 !== this.renderConfig.clearCanvas || e1) && !this.destroyed && -1 !== t1) {
            var r1;
            this.renderedFrame = t1, this.globalData.frameNum = t1 - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e1, this.globalData.projectInterface.currentFrame = t1;
            var i1 = this.layers.length;
            for(this.completeLayers || this.checkLayers(t1), r1 = 0; r1 < i1; r1 += 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].prepareFrame(t1 - this.layers[r1].st);
            if (this.globalData._mdf) {
                for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r1 = i1 - 1; 0 <= r1; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].renderFrame();
                !0 !== this.renderConfig.clearCanvas && this.restore();
            }
        }
    }, CanvasRenderer.prototype.buildItem = function(t1) {
        var e1 = this.elements;
        if (!e1[t1] && 99 !== this.layers[t1].ty) {
            var r1 = this.createItem(this.layers[t1], this, this.globalData);
            (e1[t1] = r1).initExpressions();
        }
    }, CanvasRenderer.prototype.checkPendingElements = function() {
        for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
    }, CanvasRenderer.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
    }, CanvasRenderer.prototype.show = function() {
        this.animationItem.container.style.display = "block";
    }, extendPrototype([
        BaseRenderer
    ], HybridRenderer), HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRenderer.prototype.checkPendingElements = function() {
        for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
    }, HybridRenderer.prototype.appendElementInPos = function(t1, e1) {
        var r1 = t1.getBaseElement();
        if (r1) {
            var i1 = this.layers[e1];
            if (i1.ddd && this.supports3d) this.addTo3dContainer(r1, e1);
            else if (this.threeDElements) this.addTo3dContainer(r1, e1);
            else {
                for(var s1, a1, n1 = 0; n1 < e1;)this.elements[n1] && !0 !== this.elements[n1] && this.elements[n1].getBaseElement && (a1 = this.elements[n1], s1 = (this.layers[n1].ddd ? this.getThreeDContainerByPos(n1) : a1.getBaseElement()) || s1), n1 += 1;
                s1 ? i1.ddd && this.supports3d || this.layerElement.insertBefore(r1, s1) : i1.ddd && this.supports3d || this.layerElement.appendChild(r1);
            }
        }
    }, HybridRenderer.prototype.createShape = function(t1) {
        return this.supports3d ? new HShapeElement(t1, this.globalData, this) : new SVGShapeElement(t1, this.globalData, this);
    }, HybridRenderer.prototype.createText = function(t1) {
        return this.supports3d ? new HTextElement(t1, this.globalData, this) : new SVGTextLottieElement(t1, this.globalData, this);
    }, HybridRenderer.prototype.createCamera = function(t1) {
        return this.camera = new HCameraElement(t1, this.globalData, this), this.camera;
    }, HybridRenderer.prototype.createImage = function(t1) {
        return this.supports3d ? new HImageElement(t1, this.globalData, this) : new IImageElement(t1, this.globalData, this);
    }, HybridRenderer.prototype.createComp = function(t1) {
        return this.supports3d ? new HCompElement(t1, this.globalData, this) : new SVGCompElement(t1, this.globalData, this);
    }, HybridRenderer.prototype.createSolid = function(t1) {
        return this.supports3d ? new HSolidElement(t1, this.globalData, this) : new ISolidElement(t1, this.globalData, this);
    }, HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull, HybridRenderer.prototype.getThreeDContainerByPos = function(t1) {
        for(var e1 = 0, r1 = this.threeDElements.length; e1 < r1;){
            if (this.threeDElements[e1].startPos <= t1 && this.threeDElements[e1].endPos >= t1) return this.threeDElements[e1].perspectiveElem;
            e1 += 1;
        }
        return null;
    }, HybridRenderer.prototype.createThreeDContainer = function(t1, e1) {
        var r1, i1, s1 = createTag("div");
        styleDiv(s1);
        var a1 = createTag("div");
        if (styleDiv(a1), "3d" === e1) {
            (r1 = s1.style).width = this.globalData.compSize.w + "px", r1.height = this.globalData.compSize.h + "px";
            var n1 = "50% 50%";
            r1.webkitTransformOrigin = n1, r1.mozTransformOrigin = n1, r1.transformOrigin = n1;
            var o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            (i1 = a1.style).transform = o1, i1.webkitTransform = o1;
        }
        s1.appendChild(a1);
        var h1 = {
            container: a1,
            perspectiveElem: s1,
            startPos: t1,
            endPos: t1,
            type: e1
        };
        return this.threeDElements.push(h1), h1;
    }, HybridRenderer.prototype.build3dContainers = function() {
        var t1, e1, r1 = this.layers.length, i1 = "";
        for(t1 = 0; t1 < r1; t1 += 1)this.layers[t1].ddd && 3 !== this.layers[t1].ty ? "3d" !== i1 && (i1 = "3d", e1 = this.createThreeDContainer(t1, "3d")) : "2d" !== i1 && (i1 = "2d", e1 = this.createThreeDContainer(t1, "2d")), e1.endPos = Math.max(e1.endPos, t1);
        for(t1 = (r1 = this.threeDElements.length) - 1; 0 <= t1; t1 -= 1)this.resizerElem.appendChild(this.threeDElements[t1].perspectiveElem);
    }, HybridRenderer.prototype.addTo3dContainer = function(t1, e1) {
        for(var r1 = 0, i1 = this.threeDElements.length; r1 < i1;){
            if (e1 <= this.threeDElements[r1].endPos) {
                for(var s1, a1 = this.threeDElements[r1].startPos; a1 < e1;)this.elements[a1] && this.elements[a1].getBaseElement && (s1 = this.elements[a1].getBaseElement()), a1 += 1;
                s1 ? this.threeDElements[r1].container.insertBefore(t1, s1) : this.threeDElements[r1].container.appendChild(t1);
                break;
            }
            r1 += 1;
        }
    }, HybridRenderer.prototype.configAnimation = function(t1) {
        var e1 = createTag("div"), r1 = this.animationItem.wrapper, i1 = e1.style;
        i1.width = t1.w + "px", i1.height = t1.h + "px", styleDiv(this.resizerElem = e1), i1.transformStyle = "flat", i1.mozTransformStyle = "flat", i1.webkitTransformStyle = "flat", this.renderConfig.className && e1.setAttribute("class", this.renderConfig.className), r1.appendChild(e1), i1.overflow = "hidden";
        var s1 = createNS("svg");
        s1.setAttribute("width", "1"), s1.setAttribute("height", "1"), styleDiv(s1), this.resizerElem.appendChild(s1);
        var a1 = createNS("defs");
        s1.appendChild(a1), this.data = t1, this.setupGlobalData(t1, s1), this.globalData.defs = a1, this.layers = t1.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRenderer.prototype.destroy = function() {
        var t1;
        this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
        var e1 = this.layers ? this.layers.length : 0;
        for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1].destroy();
        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRenderer.prototype.updateContainerSize = function() {
        var t1, e1, r1, i1, s1 = this.animationItem.wrapper.offsetWidth, a1 = this.animationItem.wrapper.offsetHeight;
        i1 = s1 / a1 < this.globalData.compSize.w / this.globalData.compSize.h ? (t1 = s1 / this.globalData.compSize.w, e1 = s1 / this.globalData.compSize.w, r1 = 0, (a1 - this.globalData.compSize.h * (s1 / this.globalData.compSize.w)) / 2) : (t1 = a1 / this.globalData.compSize.h, e1 = a1 / this.globalData.compSize.h, r1 = (s1 - this.globalData.compSize.w * (a1 / this.globalData.compSize.h)) / 2, 0);
        var n1 = this.resizerElem.style;
        n1.webkitTransform = "matrix3d(" + t1 + ",0,0,0,0," + e1 + ",0,0,0,0,1,0," + r1 + "," + i1 + ",0,1)", n1.transform = n1.webkitTransform;
    }, HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRenderer.prototype.hide = function() {
        this.resizerElem.style.display = "none";
    }, HybridRenderer.prototype.show = function() {
        this.resizerElem.style.display = "block";
    }, HybridRenderer.prototype.initItems = function() {
        if (this.buildAllItems(), this.camera) this.camera.setup();
        else {
            var t1, e1 = this.globalData.compSize.w, r1 = this.globalData.compSize.h, i1 = this.threeDElements.length;
            for(t1 = 0; t1 < i1; t1 += 1){
                var s1 = this.threeDElements[t1].perspectiveElem.style;
                s1.webkitPerspective = Math.sqrt(Math.pow(e1, 2) + Math.pow(r1, 2)) + "px", s1.perspective = s1.webkitPerspective;
            }
        }
    }, HybridRenderer.prototype.searchExtraCompositions = function(t1) {
        var e1, r1 = t1.length, i1 = createTag("div");
        for(e1 = 0; e1 < r1; e1 += 1)if (t1[e1].xt) {
            var s1 = this.createComp(t1[e1], i1, this.globalData.comp, null);
            s1.initExpressions(), this.globalData.projectInterface.registerComposition(s1);
        }
    }, MaskElement.prototype.getMaskProperty = function(t1) {
        return this.viewData[t1].prop;
    }, MaskElement.prototype.renderFrame = function(t1) {
        var e1, r1 = this.element.finalTransform.mat, i1 = this.masksProperties.length;
        for(e1 = 0; e1 < i1; e1 += 1)if ((this.viewData[e1].prop._mdf || t1) && this.drawPath(this.masksProperties[e1], this.viewData[e1].prop.v, this.viewData[e1]), (this.viewData[e1].op._mdf || t1) && this.viewData[e1].elem.setAttribute("fill-opacity", this.viewData[e1].op.v), "n" !== this.masksProperties[e1].mode && (this.viewData[e1].invRect && (this.element.finalTransform.mProp._mdf || t1) && this.viewData[e1].invRect.setAttribute("transform", r1.getInverseMatrix().to2dCSS()), this.storedData[e1].x && (this.storedData[e1].x._mdf || t1))) {
            var s1 = this.storedData[e1].expan;
            this.storedData[e1].x.v < 0 ? ("erode" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "erode", this.storedData[e1].elem.setAttribute("filter", "url(" + locationHref + "#" + this.storedData[e1].filterId + ")")), s1.setAttribute("radius", -this.storedData[e1].x.v)) : ("dilate" !== this.storedData[e1].lastOperator && (this.storedData[e1].lastOperator = "dilate", this.storedData[e1].elem.setAttribute("filter", null)), this.storedData[e1].elem.setAttribute("stroke-width", 2 * this.storedData[e1].x.v));
        }
    }, MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
        var t1 = "M0,0 ";
        return t1 += " h" + this.globalData.compSize.w, t1 += " v" + this.globalData.compSize.h, t1 += " h-" + this.globalData.compSize.w, t1 += " v-" + this.globalData.compSize.h + " ";
    }, MaskElement.prototype.drawPath = function(t1, e1, r1) {
        var i1, s1, a1 = " M" + e1.v[0][0] + "," + e1.v[0][1];
        for(s1 = e1._length, i1 = 1; i1 < s1; i1 += 1)a1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[i1][0] + "," + e1.i[i1][1] + " " + e1.v[i1][0] + "," + e1.v[i1][1];
        if (e1.c && 1 < s1 && (a1 += " C" + e1.o[i1 - 1][0] + "," + e1.o[i1 - 1][1] + " " + e1.i[0][0] + "," + e1.i[0][1] + " " + e1.v[0][0] + "," + e1.v[0][1]), r1.lastPath !== a1) {
            var n1 = "";
            r1.elem && (e1.c && (n1 = t1.inv ? this.solidPath + a1 : a1), r1.elem.setAttribute("d", n1)), r1.lastPath = a1;
        }
    }, MaskElement.prototype.destroy = function() {
        this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    }, HierarchyElement.prototype = {
        initHierarchy: function() {
            this.hierarchy = [], this._isParent = !1, this.checkParenting();
        },
        setHierarchy: function(t1) {
            this.hierarchy = t1;
        },
        setAsParent: function() {
            this._isParent = !0;
        },
        checkParenting: function() {
            void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
        }
    }, FrameElement.prototype = {
        initFrame: function() {
            this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
        },
        prepareProperties: function(t1, e1) {
            var r1, i1 = this.dynamicProperties.length;
            for(r1 = 0; r1 < i1; r1 += 1)(e1 || this._isParent && "transform" === this.dynamicProperties[r1].propType) && (this.dynamicProperties[r1].getValue(), this.dynamicProperties[r1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
        },
        addDynamicProperty: function(t1) {
            -1 === this.dynamicProperties.indexOf(t1) && this.dynamicProperties.push(t1);
        }
    }, TransformElement.prototype = {
        initTransform: function() {
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: !1,
                _opMdf: !1,
                mat: new Matrix
            }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
        },
        renderTransform: function() {
            if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                var t1, e1 = this.finalTransform.mat, r1 = 0, i1 = this.hierarchy.length;
                if (!this.finalTransform._matMdf) for(; r1 < i1;){
                    if (this.hierarchy[r1].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = !0;
                        break;
                    }
                    r1 += 1;
                }
                if (this.finalTransform._matMdf) for(t1 = this.finalTransform.mProp.v.props, e1.cloneFromProps(t1), r1 = 0; r1 < i1; r1 += 1)t1 = this.hierarchy[r1].finalTransform.mProp.v.props, e1.transform(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
            }
        },
        globalToLocal: function(t1) {
            var e1 = [];
            e1.push(this.finalTransform);
            for(var r1, i1 = !0, s1 = this.comp; i1;)s1.finalTransform ? (s1.data.hasMask && e1.splice(0, 0, s1.finalTransform), s1 = s1.comp) : i1 = !1;
            var a1, n1 = e1.length;
            for(r1 = 0; r1 < n1; r1 += 1)a1 = e1[r1].mat.applyToPointArray(0, 0, 0), t1 = [
                t1[0] - a1[0],
                t1[1] - a1[1],
                0
            ];
            return t1;
        },
        mHelper: new Matrix
    }, RenderableElement.prototype = {
        initRenderable: function() {
            this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
        },
        addRenderableComponent: function(t1) {
            -1 === this.renderableComponents.indexOf(t1) && this.renderableComponents.push(t1);
        },
        removeRenderableComponent: function(t1) {
            -1 !== this.renderableComponents.indexOf(t1) && this.renderableComponents.splice(this.renderableComponents.indexOf(t1), 1);
        },
        prepareRenderableFrame: function(t1) {
            this.checkLayerLimits(t1);
        },
        checkTransparency: function() {
            this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
        },
        checkLayerLimits: function(t1) {
            this.data.ip - this.data.st <= t1 && this.data.op - this.data.st > t1 ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
        },
        renderRenderable: function() {
            var t1, e1 = this.renderableComponents.length;
            for(t1 = 0; t1 < e1; t1 += 1)this.renderableComponents[t1].renderFrame(this._isFirstFrame);
        },
        sourceRectAtTime: function() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function() {
            return 5 === this.data.ty ? {
                w: this.data.textData.width,
                h: this.data.textData.height
            } : {
                w: this.data.width,
                h: this.data.height
            };
        }
    }, extendPrototype([
        RenderableElement,
        createProxyFunction({
            initElement: function(t1, e1, r1) {
                this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
            },
            hide: function() {
                this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
            },
            show: function() {
                this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            renderInnerContent: function() {},
            prepareFrame: function(t1) {
                this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.checkTransparency();
            },
            destroy: function() {
                this.innerElem = null, this.destroyBaseElement();
            }
        })
    ], RenderableDOMElement), SVGStyleData.prototype.reset = function() {
        this.d = "", this._mdf = !1;
    }, SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = !0;
    }, extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData), extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData), SVGGradientFillStyleData.prototype.initGradientData = function(t1, e1, r1) {
        this.o = PropertyFactory.getProp(t1, e1.o, 0, .01, this), this.s = PropertyFactory.getProp(t1, e1.s, 1, null, this), this.e = PropertyFactory.getProp(t1, e1.e, 1, null, this), this.h = PropertyFactory.getProp(t1, e1.h || {
            k: 0
        }, 0, .01, this), this.a = PropertyFactory.getProp(t1, e1.a || {
            k: 0
        }, 0, degToRads, this), this.g = new GradientProperty(t1, e1.g, this), this.style = r1, this.stops = [], this.setGradientData(r1.pElem, e1), this.setGradientOpacity(e1, r1), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(t1, e1) {
        var r1 = createElementID(), i1 = createNS(1 === e1.t ? "linearGradient" : "radialGradient");
        i1.setAttribute("id", r1), i1.setAttribute("spreadMethod", "pad"), i1.setAttribute("gradientUnits", "userSpaceOnUse");
        var s1, a1, n1, o1 = [];
        for(n1 = 4 * e1.g.p, a1 = 0; a1 < n1; a1 += 4)s1 = createNS("stop"), i1.appendChild(s1), o1.push(s1);
        t1.setAttribute("gf" === e1.ty ? "fill" : "stroke", "url(" + locationHref + "#" + r1 + ")"), this.gf = i1, this.cst = o1;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t1, e1) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var r1, i1, s1, a1 = createNS("mask"), n1 = createNS("path");
            a1.appendChild(n1);
            var o1 = createElementID(), h1 = createElementID();
            a1.setAttribute("id", h1);
            var l1 = createNS(1 === t1.t ? "linearGradient" : "radialGradient");
            l1.setAttribute("id", o1), l1.setAttribute("spreadMethod", "pad"), l1.setAttribute("gradientUnits", "userSpaceOnUse"), s1 = t1.g.k.k[0].s ? t1.g.k.k[0].s.length : t1.g.k.k.length;
            var p1 = this.stops;
            for(i1 = 4 * t1.g.p; i1 < s1; i1 += 2)(r1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l1.appendChild(r1), p1.push(r1);
            n1.setAttribute("gf" === t1.ty ? "fill" : "stroke", "url(" + locationHref + "#" + o1 + ")"), "gs" === t1.ty && (n1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), n1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), 1 === t1.lj && n1.setAttribute("stroke-miterlimit", t1.ml)), this.of = l1, this.ms = a1, this.ost = p1, this.maskId = h1, e1.msElem = n1;
        }
    }, extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData), extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    var SVGElementsRenderer = function() {
        var y1 = new Matrix, g1 = new Matrix;
        function e1(t1, e1, r1) {
            (r1 || e1.transform.op._mdf) && e1.transform.container.setAttribute("opacity", e1.transform.op.v), (r1 || e1.transform.mProps._mdf) && e1.transform.container.setAttribute("transform", e1.transform.mProps.v.to2dCSS());
        }
        function r1(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1 = e1.styles.length, u1 = e1.lvl;
            for(h1 = 0; h1 < d1; h1 += 1){
                if (n1 = e1.sh._mdf || r1, e1.styles[h1].lvl < u1) {
                    for(p1 = g1.reset(), f1 = u1 - e1.styles[h1].lvl, c1 = e1.transformers.length - 1; !n1 && 0 < f1;)n1 = e1.transformers[c1].mProps._mdf || n1, f1 -= 1, c1 -= 1;
                    if (n1) for(f1 = u1 - e1.styles[h1].lvl, c1 = e1.transformers.length - 1; 0 < f1;)m1 = e1.transformers[c1].mProps.v.props, p1.transform(m1[0], m1[1], m1[2], m1[3], m1[4], m1[5], m1[6], m1[7], m1[8], m1[9], m1[10], m1[11], m1[12], m1[13], m1[14], m1[15]), f1 -= 1, c1 -= 1;
                } else p1 = y1;
                if (s1 = (l1 = e1.sh.paths)._length, n1) {
                    for(a1 = "", i1 = 0; i1 < s1; i1 += 1)(o1 = l1.shapes[i1]) && o1._length && (a1 += buildShapeString(o1, o1._length, o1.c, p1));
                    e1.caches[h1] = a1;
                } else a1 = e1.caches[h1];
                e1.styles[h1].d += !0 === t1.hd ? "" : a1, e1.styles[h1]._mdf = n1 || e1.styles[h1]._mdf;
            }
        }
        function i1(t1, e1, r1) {
            var i1 = e1.style;
            (e1.c._mdf || r1) && i1.pElem.setAttribute("fill", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("fill-opacity", e1.o.v);
        }
        function s1(t1, e1, r1) {
            a1(t1, e1, r1), n1(t1, e1, r1);
        }
        function a1(t1, e1, r1) {
            var i1, s1, a1, n1, o1, h1 = e1.gf, l1 = e1.g._hasOpacity, p1 = e1.s.v, m1 = e1.e.v;
            if (e1.o._mdf || r1) {
                var f1 = "gf" === t1.ty ? "fill-opacity" : "stroke-opacity";
                e1.style.pElem.setAttribute(f1, e1.o.v);
            }
            if (e1.s._mdf || r1) {
                var c1 = 1 === t1.t ? "x1" : "cx", d1 = "x1" === c1 ? "y1" : "cy";
                h1.setAttribute(c1, p1[0]), h1.setAttribute(d1, p1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute(c1, p1[0]), e1.of.setAttribute(d1, p1[1]));
            }
            if (e1.g._cmdf || r1) {
                i1 = e1.cst;
                var u1 = e1.g.c;
                for(a1 = i1.length, s1 = 0; s1 < a1; s1 += 1)(n1 = i1[s1]).setAttribute("offset", u1[4 * s1] + "%"), n1.setAttribute("stop-color", "rgb(" + u1[4 * s1 + 1] + "," + u1[4 * s1 + 2] + "," + u1[4 * s1 + 3] + ")");
            }
            if (l1 && (e1.g._omdf || r1)) {
                var y1 = e1.g.o;
                for(a1 = (i1 = e1.g._collapsable ? e1.cst : e1.ost).length, s1 = 0; s1 < a1; s1 += 1)n1 = i1[s1], e1.g._collapsable || n1.setAttribute("offset", y1[2 * s1] + "%"), n1.setAttribute("stop-opacity", y1[2 * s1 + 1]);
            }
            if (1 === t1.t) (e1.e._mdf || r1) && (h1.setAttribute("x2", m1[0]), h1.setAttribute("y2", m1[1]), l1 && !e1.g._collapsable && (e1.of.setAttribute("x2", m1[0]), e1.of.setAttribute("y2", m1[1])));
            else if ((e1.s._mdf || e1.e._mdf || r1) && (o1 = Math.sqrt(Math.pow(p1[0] - m1[0], 2) + Math.pow(p1[1] - m1[1], 2)), h1.setAttribute("r", o1), l1 && !e1.g._collapsable && e1.of.setAttribute("r", o1)), e1.e._mdf || e1.h._mdf || e1.a._mdf || r1) {
                o1 || (o1 = Math.sqrt(Math.pow(p1[0] - m1[0], 2) + Math.pow(p1[1] - m1[1], 2)));
                var g1 = Math.atan2(m1[1] - p1[1], m1[0] - p1[0]), v1 = e1.h.v;
                1 <= v1 ? v1 = .99 : v1 <= -1 && (v1 = -0.99);
                var b1 = o1 * v1, P1 = Math.cos(g1 + e1.a.v) * b1 + p1[0], E1 = Math.sin(g1 + e1.a.v) * b1 + p1[1];
                h1.setAttribute("fx", P1), h1.setAttribute("fy", E1), l1 && !e1.g._collapsable && (e1.of.setAttribute("fx", P1), e1.of.setAttribute("fy", E1));
            }
        }
        function n1(t1, e1, r1) {
            var i1 = e1.style, s1 = e1.d;
            s1 && (s1._mdf || r1) && s1.dashStr && (i1.pElem.setAttribute("stroke-dasharray", s1.dashStr), i1.pElem.setAttribute("stroke-dashoffset", s1.dashoffset[0])), e1.c && (e1.c._mdf || r1) && i1.pElem.setAttribute("stroke", "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1) && i1.pElem.setAttribute("stroke-opacity", e1.o.v), (e1.w._mdf || r1) && (i1.pElem.setAttribute("stroke-width", e1.w.v), i1.msElem && i1.msElem.setAttribute("stroke-width", e1.w.v));
        }
        return {
            createRenderFunction: function(t1) {
                switch(t1.ty){
                    case "fl":
                        return i1;
                    case "gf":
                        return a1;
                    case "gs":
                        return s1;
                    case "st":
                        return n1;
                    case "sh":
                    case "el":
                    case "rc":
                    case "sr":
                        return r1;
                    case "tr":
                        return e1;
                    default:
                        return null;
                }
            }
        };
    }();
    function ShapeTransformManager() {
        this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    function CVShapeData(t1, e1, r1, i1) {
        this.styledShapes = [], this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var s1, a1 = 4;
        "rc" === e1.ty ? a1 = 5 : "el" === e1.ty ? a1 = 6 : "sr" === e1.ty && (a1 = 7), this.sh = ShapePropertyFactory.getShapeProp(t1, e1, a1, t1);
        var n1, o1 = r1.length;
        for(s1 = 0; s1 < o1; s1 += 1)r1[s1].closed || (n1 = {
            transforms: i1.addTransformSequence(r1[s1].transforms),
            trNodes: []
        }, this.styledShapes.push(n1), r1[s1].elements.push(n1));
    }
    function BaseElement() {}
    function NullElement(t1, e1, r1) {
        this.initFrame(), this.initBaseData(t1, e1, r1), this.initFrame(), this.initTransform(t1, e1, r1), this.initHierarchy();
    }
    function SVGBaseElement() {}
    function IShapeElement() {}
    function ITextElement() {}
    function ICompElement() {}
    function IImageElement(t1, e1, r1) {
        this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1), this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    function ISolidElement(t1, e1, r1) {
        this.initElement(t1, e1, r1);
    }
    function AudioElement(t1, e1, r1) {
        this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.initBaseData(t1, e1, r1), this._isPlaying = !1, this._canPlay = !1;
        var i1 = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(i1), this._currentTime = 0, this.globalData.audioController.addAudio(this), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
            _placeholder: !0
        };
    }
    function FootageElement(t1, e1, r1) {
        this.initFrame(), this.initRenderable(), this.assetData = e1.getAssetData(t1.refId), this.footageData = e1.imageLoader.getAsset(this.assetData), this.initBaseData(t1, e1, r1);
    }
    function SVGCompElement(t1, e1, r1) {
        this.layers = t1.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
            _placeholder: !0
        };
    }
    function SVGTextLottieElement(t1, e1, r1) {
        this.textSpans = [], this.renderType = "svg", this.initElement(t1, e1, r1);
    }
    function SVGShapeElement(t1, e1, r1) {
        this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t1, e1, r1), this.prevViewData = [];
    }
    function SVGTintFilter(t1, e1) {
        this.filterManager = e1;
        var r1 = createNS("feColorMatrix");
        if (r1.setAttribute("type", "matrix"), r1.setAttribute("color-interpolation-filters", "linearRGB"), r1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), r1.setAttribute("result", "f1"), t1.appendChild(r1), (r1 = createNS("feColorMatrix")).setAttribute("type", "matrix"), r1.setAttribute("color-interpolation-filters", "sRGB"), r1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), r1.setAttribute("result", "f2"), t1.appendChild(r1), this.matrixFilter = r1, 100 !== e1.effectElements[2].p.v || e1.effectElements[2].p.k) {
            var i1, s1 = createNS("feMerge");
            t1.appendChild(s1), (i1 = createNS("feMergeNode")).setAttribute("in", "SourceGraphic"), s1.appendChild(i1), (i1 = createNS("feMergeNode")).setAttribute("in", "f2"), s1.appendChild(i1);
        }
    }
    function SVGFillFilter(t1, e1) {
        this.filterManager = e1;
        var r1 = createNS("feColorMatrix");
        r1.setAttribute("type", "matrix"), r1.setAttribute("color-interpolation-filters", "sRGB"), r1.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), t1.appendChild(r1), this.matrixFilter = r1;
    }
    function SVGGaussianBlurEffect(t1, e1) {
        t1.setAttribute("x", "-100%"), t1.setAttribute("y", "-100%"), t1.setAttribute("width", "300%"), t1.setAttribute("height", "300%"), this.filterManager = e1;
        var r1 = createNS("feGaussianBlur");
        t1.appendChild(r1), this.feGaussianBlur = r1;
    }
    function SVGStrokeEffect(t1, e1) {
        this.initialized = !1, this.filterManager = e1, this.elem = t1, this.paths = [];
    }
    function SVGTritoneFilter(t1, e1) {
        this.filterManager = e1;
        var r1 = createNS("feColorMatrix");
        r1.setAttribute("type", "matrix"), r1.setAttribute("color-interpolation-filters", "linearRGB"), r1.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), r1.setAttribute("result", "f1"), t1.appendChild(r1);
        var i1 = createNS("feComponentTransfer");
        i1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(i1), this.matrixFilter = i1;
        var s1 = createNS("feFuncR");
        s1.setAttribute("type", "table"), i1.appendChild(s1), this.feFuncR = s1;
        var a1 = createNS("feFuncG");
        a1.setAttribute("type", "table"), i1.appendChild(a1), this.feFuncG = a1;
        var n1 = createNS("feFuncB");
        n1.setAttribute("type", "table"), i1.appendChild(n1), this.feFuncB = n1;
    }
    function SVGProLevelsFilter(t1, e1) {
        this.filterManager = e1;
        var r1 = this.filterManager.effectElements, i1 = createNS("feComponentTransfer");
        (r1[10].p.k || 0 !== r1[10].p.v || r1[11].p.k || 1 !== r1[11].p.v || r1[12].p.k || 1 !== r1[12].p.v || r1[13].p.k || 0 !== r1[13].p.v || r1[14].p.k || 1 !== r1[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", i1)), (r1[17].p.k || 0 !== r1[17].p.v || r1[18].p.k || 1 !== r1[18].p.v || r1[19].p.k || 1 !== r1[19].p.v || r1[20].p.k || 0 !== r1[20].p.v || r1[21].p.k || 1 !== r1[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", i1)), (r1[24].p.k || 0 !== r1[24].p.v || r1[25].p.k || 1 !== r1[25].p.v || r1[26].p.k || 1 !== r1[26].p.v || r1[27].p.k || 0 !== r1[27].p.v || r1[28].p.k || 1 !== r1[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", i1)), (r1[31].p.k || 0 !== r1[31].p.v || r1[32].p.k || 1 !== r1[32].p.v || r1[33].p.k || 1 !== r1[33].p.v || r1[34].p.k || 0 !== r1[34].p.v || r1[35].p.k || 1 !== r1[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", i1)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (i1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(i1), i1 = createNS("feComponentTransfer")), (r1[3].p.k || 0 !== r1[3].p.v || r1[4].p.k || 1 !== r1[4].p.v || r1[5].p.k || 1 !== r1[5].p.v || r1[6].p.k || 0 !== r1[6].p.v || r1[7].p.k || 1 !== r1[7].p.v) && (i1.setAttribute("color-interpolation-filters", "sRGB"), t1.appendChild(i1), this.feFuncRComposed = this.createFeFunc("feFuncR", i1), this.feFuncGComposed = this.createFeFunc("feFuncG", i1), this.feFuncBComposed = this.createFeFunc("feFuncB", i1));
    }
    function SVGDropShadowEffect(t1, e1) {
        var r1 = e1.container.globalData.renderConfig.filterSize;
        t1.setAttribute("x", r1.x), t1.setAttribute("y", r1.y), t1.setAttribute("width", r1.width), t1.setAttribute("height", r1.height), this.filterManager = e1;
        var i1 = createNS("feGaussianBlur");
        i1.setAttribute("in", "SourceAlpha"), i1.setAttribute("result", "drop_shadow_1"), i1.setAttribute("stdDeviation", "0"), this.feGaussianBlur = i1, t1.appendChild(i1);
        var s1 = createNS("feOffset");
        s1.setAttribute("dx", "25"), s1.setAttribute("dy", "0"), s1.setAttribute("in", "drop_shadow_1"), s1.setAttribute("result", "drop_shadow_2"), this.feOffset = s1, t1.appendChild(s1);
        var a1 = createNS("feFlood");
        a1.setAttribute("flood-color", "#00ff00"), a1.setAttribute("flood-opacity", "1"), a1.setAttribute("result", "drop_shadow_3"), this.feFlood = a1, t1.appendChild(a1);
        var n1 = createNS("feComposite");
        n1.setAttribute("in", "drop_shadow_3"), n1.setAttribute("in2", "drop_shadow_2"), n1.setAttribute("operator", "in"), n1.setAttribute("result", "drop_shadow_4"), t1.appendChild(n1);
        var o1, h1 = createNS("feMerge");
        t1.appendChild(h1), o1 = createNS("feMergeNode"), h1.appendChild(o1), (o1 = createNS("feMergeNode")).setAttribute("in", "SourceGraphic"), this.feMergeNode = o1, this.feMerge = h1, this.originalNodeAdded = !1, h1.appendChild(o1);
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function(t1) {
            var e1, r1 = t1.length, i1 = "_";
            for(e1 = 0; e1 < r1; e1 += 1)i1 += t1[e1].transform.key + "_";
            var s1 = this.sequences[i1];
            return s1 || (s1 = {
                transforms: [].concat(t1),
                finalTransform: new Matrix,
                _mdf: !1
            }, this.sequences[i1] = s1, this.sequenceList.push(s1)), s1;
        },
        processSequence: function(t1, e1) {
            for(var r1, i1 = 0, s1 = t1.transforms.length, a1 = e1; i1 < s1 && !e1;){
                if (t1.transforms[i1].transform.mProps._mdf) {
                    a1 = !0;
                    break;
                }
                i1 += 1;
            }
            if (a1) for(t1.finalTransform.reset(), i1 = s1 - 1; 0 <= i1; i1 -= 1)r1 = t1.transforms[i1].transform.mProps.v.props, t1.finalTransform.transform(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5], r1[6], r1[7], r1[8], r1[9], r1[10], r1[11], r1[12], r1[13], r1[14], r1[15]);
            t1._mdf = a1;
        },
        processSequences: function(t1) {
            var e1, r1 = this.sequenceList.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.processSequence(this.sequenceList[e1], t1);
        },
        getNewKey: function() {
            return this.transform_key_count += 1, "_" + this.transform_key_count;
        }
    }, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, BaseElement.prototype = {
        checkMasks: function() {
            if (!this.data.hasMask) return !1;
            for(var t1 = 0, e1 = this.data.masksProperties.length; t1 < e1;){
                if ("n" !== this.data.masksProperties[t1].mode && !1 !== this.data.masksProperties[t1].cl) return !0;
                t1 += 1;
            }
            return !1;
        },
        initExpressions: function() {
            this.layerInterface = LayerExpressionInterface(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
            var t1 = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(t1), 0 === this.data.ty || this.data.xt ? this.compInterface = CompExpressionInterface(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = TextExpressionInterface(this), this.layerInterface.text = this.layerInterface.textInterface);
        },
        setBlendMode: function() {
            var t1 = getBlendMode(this.data.bm);
            (this.baseElement || this.layerElement).style["mix-blend-mode"] = t1;
        },
        initBaseData: function(t1, e1, r1) {
            this.globalData = e1, this.comp = r1, this.data = t1, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function() {
            return this.type;
        },
        sourceRectAtTime: function() {}
    }, NullElement.prototype.prepareFrame = function(t1) {
        this.prepareProperties(t1, !0);
    }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
        return null;
    }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement), SVGBaseElement.prototype = {
        initRendererElement: function() {
            this.layerElement = createNS("g");
        },
        createContainerElements: function() {
            this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
            var t1, e1, r1, i1 = null;
            if (this.data.td) {
                if (3 == this.data.td || 1 == this.data.td) {
                    var s1 = createNS("mask");
                    s1.setAttribute("id", this.layerId), s1.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"), s1.appendChild(this.layerElement), i1 = s1, this.globalData.defs.appendChild(s1), featureSupport.maskType || 1 != this.data.td || (s1.setAttribute("mask-type", "luminance"), t1 = createElementID(), e1 = filtersFactory.createFilter(t1), this.globalData.defs.appendChild(e1), e1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (r1 = createNS("g")).appendChild(this.layerElement), i1 = r1, s1.appendChild(r1), r1.setAttribute("filter", "url(" + locationHref + "#" + t1 + ")"));
                } else if (2 == this.data.td) {
                    var a1 = createNS("mask");
                    a1.setAttribute("id", this.layerId), a1.setAttribute("mask-type", "alpha");
                    var n1 = createNS("g");
                    a1.appendChild(n1), t1 = createElementID(), e1 = filtersFactory.createFilter(t1);
                    var o1 = createNS("feComponentTransfer");
                    o1.setAttribute("in", "SourceGraphic"), e1.appendChild(o1);
                    var h1 = createNS("feFuncA");
                    h1.setAttribute("type", "table"), h1.setAttribute("tableValues", "1.0 0.0"), o1.appendChild(h1), this.globalData.defs.appendChild(e1);
                    var l1 = createNS("rect");
                    l1.setAttribute("width", this.comp.data.w), l1.setAttribute("height", this.comp.data.h), l1.setAttribute("x", "0"), l1.setAttribute("y", "0"), l1.setAttribute("fill", "#ffffff"), l1.setAttribute("opacity", "0"), n1.setAttribute("filter", "url(" + locationHref + "#" + t1 + ")"), n1.appendChild(l1), n1.appendChild(this.layerElement), i1 = n1, featureSupport.maskType || (a1.setAttribute("mask-type", "luminance"), e1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), r1 = createNS("g"), n1.appendChild(l1), r1.appendChild(this.layerElement), i1 = r1, n1.appendChild(r1)), this.globalData.defs.appendChild(a1);
                }
            } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), i1 = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
            if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                var p1 = createNS("clipPath"), m1 = createNS("path");
                m1.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                var f1 = createElementID();
                if (p1.setAttribute("id", f1), p1.appendChild(m1), this.globalData.defs.appendChild(p1), this.checkMasks()) {
                    var c1 = createNS("g");
                    c1.setAttribute("clip-path", "url(" + locationHref + "#" + f1 + ")"), c1.appendChild(this.layerElement), this.transformedElement = c1, i1 ? i1.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#" + f1 + ")");
            }
            0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function() {
            this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
        },
        destroyBaseElement: function() {
            this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
        },
        getBaseElement: function() {
            return this.data.hd ? null : this.baseElement;
        },
        createRenderableComponents: function() {
            this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
        },
        setMatte: function(t1) {
            this.matteElement && this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + t1 + ")");
        }
    }, IShapeElement.prototype = {
        addShapeToModifiers: function(t1) {
            var e1, r1 = this.shapeModifiers.length;
            for(e1 = 0; e1 < r1; e1 += 1)this.shapeModifiers[e1].addShape(t1);
        },
        isShapeInAnimatedModifiers: function(t1) {
            for(var e1 = this.shapeModifiers.length; 0 < e1;)if (this.shapeModifiers[0].isAnimatedWithShape(t1)) return !0;
            return !1;
        },
        renderModifiers: function() {
            if (this.shapeModifiers.length) {
                var t1, e1 = this.shapes.length;
                for(t1 = 0; t1 < e1; t1 += 1)this.shapes[t1].sh.reset();
                for(t1 = (e1 = this.shapeModifiers.length) - 1; 0 <= t1 && !this.shapeModifiers[t1].processShapes(this._isFirstFrame); t1 -= 1);
            }
        },
        searchProcessedElement: function(t1) {
            for(var e1 = this.processedElements, r1 = 0, i1 = e1.length; r1 < i1;){
                if (e1[r1].elem === t1) return e1[r1].pos;
                r1 += 1;
            }
            return 0;
        },
        addProcessedElement: function(t1, e1) {
            for(var r1 = this.processedElements, i1 = r1.length; i1;)if (r1[i1 -= 1].elem === t1) return void (r1[i1].pos = e1);
            r1.push(new ProcessedElement(t1, e1));
        },
        prepareFrame: function(t1) {
            this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange);
        }
    }, ITextElement.prototype.initElement = function(t1, e1, r1) {
        this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t1, e1, r1), this.textProperty = new TextProperty(this, t1.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t1.t, this.renderType, this), this.initTransform(t1, e1, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(t1) {
        this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    }, ITextElement.prototype.createPathShape = function(t1, e1) {
        var r1, i1, s1 = e1.length, a1 = "";
        for(r1 = 0; r1 < s1; r1 += 1)i1 = e1[r1].ks.k, a1 += buildShapeString(i1, i1.i.length, !0, t1);
        return a1;
    }, ITextElement.prototype.updateDocumentData = function(t1, e1) {
        this.textProperty.updateDocumentData(t1, e1);
    }, ITextElement.prototype.canResizeFont = function(t1) {
        this.textProperty.canResizeFont(t1);
    }, ITextElement.prototype.setMinimumFontSize = function(t1) {
        this.textProperty.setMinimumFontSize(t1);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t1, e1, r1, i1, s1) {
        switch(t1.ps && e1.translate(t1.ps[0], t1.ps[1] + t1.ascent, 0), e1.translate(0, -t1.ls, 0), t1.j){
            case 1:
                e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]), 0, 0);
                break;
            case 2:
                e1.translate(t1.justifyOffset + (t1.boxWidth - t1.lineWidths[r1]) / 2, 0, 0);
        }
        e1.translate(i1, s1, 0);
    }, ITextElement.prototype.buildColor = function(t1) {
        return "rgb(" + Math.round(255 * t1[0]) + "," + Math.round(255 * t1[1]) + "," + Math.round(255 * t1[2]) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement), ICompElement.prototype.initElement = function(t1, e1, r1) {
        this.initFrame(), this.initBaseData(t1, e1, r1), this.initTransform(t1, e1, r1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e1.progressiveLoad || this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(t1) {
        if (this._mdf = !1, this.prepareRenderableFrame(t1), this.prepareProperties(t1, this.isInRange), this.isInRange || this.data.xt) {
            if (this.tm._placeholder) this.renderedFrame = t1 / this.data.sr;
            else {
                var e1 = this.tm.v;
                e1 === this.data.op && (e1 = this.data.op - 1), this.renderedFrame = e1;
            }
            var r1, i1 = this.elements.length;
            for(this.completeLayers || this.checkLayers(this.renderedFrame), r1 = i1 - 1; 0 <= r1; r1 -= 1)(this.completeLayers || this.elements[r1]) && (this.elements[r1].prepareFrame(this.renderedFrame - this.layers[r1].st), this.elements[r1]._mdf && (this._mdf = !0));
        }
    }, ICompElement.prototype.renderInnerContent = function() {
        var t1, e1 = this.layers.length;
        for(t1 = 0; t1 < e1; t1 += 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
    }, ICompElement.prototype.setElements = function(t1) {
        this.elements = t1;
    }, ICompElement.prototype.getElements = function() {
        return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
        var t1, e1 = this.layers.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.elements[t1] && this.elements[t1].destroy();
    }, ICompElement.prototype.destroy = function() {
        this.destroyElements(), this.destroyBaseElement();
    }, extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement), IImageElement.prototype.createContent = function() {
        var t1 = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    }, extendPrototype([
        IImageElement
    ], ISolidElement), ISolidElement.prototype.createContent = function() {
        var t1 = createNS("rect");
        t1.setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t1);
    }, AudioElement.prototype.prepareFrame = function(t1) {
        if (this.prepareRenderableFrame(t1, !0), this.prepareProperties(t1, !0), this.tm._placeholder) this._currentTime = t1 / this.data.sr;
        else {
            var e1 = this.tm.v;
            this._currentTime = e1;
        }
    }, extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement), AudioElement.prototype.renderFrame = function() {
        this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || .1 < Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek())) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
        this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
        this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
        this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(t1) {
        this.audio.rate(t1);
    }, AudioElement.prototype.volume = function(t1) {
        this.audio.volume(t1);
    }, AudioElement.prototype.getBaseElement = function() {
        return null;
    }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement), FootageElement.prototype.getBaseElement = function() {
        return null;
    }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
        this.layerInterface = FootageInterface(this);
    }, FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    }, extendPrototype([
        SVGRenderer,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement), extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
        this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(t1) {
        for(var e1 = 0, r1 = t1.length, i1 = [], s1 = ""; e1 < r1;)t1[e1] === String.fromCharCode(13) || t1[e1] === String.fromCharCode(3) ? (i1.push(s1), s1 = "") : s1 += t1[e1], e1 += 1;
        return i1.push(s1), i1;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
        var t1, e1, r1 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(r1 ? r1.l.length : 0), r1.fc ? this.layerElement.setAttribute("fill", this.buildColor(r1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r1.sc)), this.layerElement.setAttribute("stroke-width", r1.sw)), this.layerElement.setAttribute("font-size", r1.finalSize);
        var i1 = this.globalData.fontManager.getFontByName(r1.f);
        if (i1.fClass) this.layerElement.setAttribute("class", i1.fClass);
        else {
            this.layerElement.setAttribute("font-family", i1.fFamily);
            var s1 = r1.fWeight, a1 = r1.fStyle;
            this.layerElement.setAttribute("font-style", a1), this.layerElement.setAttribute("font-weight", s1);
        }
        this.layerElement.setAttribute("aria-label", r1.t);
        var n1, o1 = r1.l || [], h1 = !!this.globalData.fontManager.chars;
        e1 = o1.length;
        var l1, p1 = this.mHelper, m1 = "", f1 = this.data.singleShape, c1 = 0, d1 = 0, u1 = !0, y1 = .001 * r1.tr * r1.finalSize;
        if (!f1 || h1 || r1.sz) {
            var g1, v1, b1 = this.textSpans.length;
            for(t1 = 0; t1 < e1; t1 += 1)h1 && f1 && 0 !== t1 || (n1 = t1 < b1 ? this.textSpans[t1] : createNS(h1 ? "path" : "text"), b1 <= t1 && (n1.setAttribute("stroke-linecap", "butt"), n1.setAttribute("stroke-linejoin", "round"), n1.setAttribute("stroke-miterlimit", "4"), this.textSpans[t1] = n1, this.layerElement.appendChild(n1)), n1.style.display = "inherit"), p1.reset(), p1.scale(r1.finalSize / 100, r1.finalSize / 100), f1 && (o1[t1].n && (c1 = -y1, d1 += r1.yOffset, d1 += u1 ? 1 : 0, u1 = !1), this.applyTextPropertiesToMatrix(r1, p1, o1[t1].line, c1, d1), c1 += o1[t1].l || 0, c1 += y1), h1 ? (l1 = (g1 = (v1 = this.globalData.fontManager.getCharData(r1.finalText[t1], i1.fStyle, this.globalData.fontManager.getFontByName(r1.f).fFamily)) && v1.data || {}).shapes ? g1.shapes[0].it : [], f1 ? m1 += this.createPathShape(p1, l1) : n1.setAttribute("d", this.createPathShape(p1, l1))) : (f1 && n1.setAttribute("transform", "translate(" + p1.props[12] + "," + p1.props[13] + ")"), n1.textContent = o1[t1].val, n1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"));
            f1 && n1 && n1.setAttribute("d", m1);
        } else {
            var P1 = this.textContainer, E1 = "start";
            switch(r1.j){
                case 1:
                    E1 = "end";
                    break;
                case 2:
                    E1 = "middle";
                    break;
                default:
                    E1 = "start";
            }
            P1.setAttribute("text-anchor", E1), P1.setAttribute("letter-spacing", y1);
            var x1 = this.buildTextContents(r1.finalText);
            for(e1 = x1.length, d1 = r1.ps ? r1.ps[1] + r1.ascent : 0, t1 = 0; t1 < e1; t1 += 1)(n1 = this.textSpans[t1] || createNS("tspan")).textContent = x1[t1], n1.setAttribute("x", 0), n1.setAttribute("y", d1), n1.style.display = "inherit", P1.appendChild(n1), this.textSpans[t1] = n1, d1 += r1.finalLineHeight;
            this.layerElement.appendChild(P1);
        }
        for(; t1 < this.textSpans.length;)this.textSpans[t1].style.display = "none", t1 += 1;
        this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
            this._sizeChanged = !1;
            var t1 = this.layerElement.getBBox();
            this.bbox = {
                top: t1.y,
                left: t1.x,
                width: t1.width,
                height: t1.height
            };
        }
        return this.bbox;
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
        if (!this.data.singleShape && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
            var t1, e1;
            this._sizeChanged = !0;
            var r1, i1, s1 = this.textAnimator.renderedLetters, a1 = this.textProperty.currentData.l;
            for(e1 = a1.length, t1 = 0; t1 < e1; t1 += 1)a1[t1].n || (r1 = s1[t1], i1 = this.textSpans[t1], r1._mdf.m && i1.setAttribute("transform", r1.m), r1._mdf.o && i1.setAttribute("opacity", r1.o), r1._mdf.sw && i1.setAttribute("stroke-width", r1.sw), r1._mdf.sc && i1.setAttribute("stroke", r1.sc), r1._mdf.fc && i1.setAttribute("fill", r1.fc));
        }
    }, extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
        var t1, e1, r1, i1, s1 = this.shapes.length, a1 = this.stylesList.length, n1 = [], o1 = !1;
        for(r1 = 0; r1 < a1; r1 += 1){
            for(i1 = this.stylesList[r1], o1 = !1, t1 = n1.length = 0; t1 < s1; t1 += 1)-1 !== (e1 = this.shapes[t1]).styles.indexOf(i1) && (n1.push(e1), o1 = e1._isAnimated || o1);
            1 < n1.length && o1 && this.setShapesAsAnimated(n1);
        }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(t1) {
        var e1, r1 = t1.length;
        for(e1 = 0; e1 < r1; e1 += 1)t1[e1].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(t1, e1) {
        var r1, i1 = new SVGStyleData(t1, e1), s1 = i1.pElem;
        if ("st" === t1.ty) r1 = new SVGStrokeStyleData(this, t1, i1);
        else if ("fl" === t1.ty) r1 = new SVGFillStyleData(this, t1, i1);
        else if ("gf" === t1.ty || "gs" === t1.ty) r1 = new ("gf" === t1.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t1, i1), this.globalData.defs.appendChild(r1.gf), r1.maskId && (this.globalData.defs.appendChild(r1.ms), this.globalData.defs.appendChild(r1.of), s1.setAttribute("mask", "url(" + locationHref + "#" + r1.maskId + ")"));
        return "st" !== t1.ty && "gs" !== t1.ty || (s1.setAttribute("stroke-linecap", lineCapEnum[t1.lc || 2]), s1.setAttribute("stroke-linejoin", lineJoinEnum[t1.lj || 2]), s1.setAttribute("fill-opacity", "0"), 1 === t1.lj && s1.setAttribute("stroke-miterlimit", t1.ml)), 2 === t1.r && s1.setAttribute("fill-rule", "evenodd"), t1.ln && s1.setAttribute("id", t1.ln), t1.cl && s1.setAttribute("class", t1.cl), t1.bm && (s1.style["mix-blend-mode"] = getBlendMode(t1.bm)), this.stylesList.push(i1), this.addToAnimatedContents(t1, r1), r1;
    }, SVGShapeElement.prototype.createGroupElement = function(t1) {
        var e1 = new ShapeGroupData;
        return t1.ln && e1.gr.setAttribute("id", t1.ln), t1.cl && e1.gr.setAttribute("class", t1.cl), t1.bm && (e1.gr.style["mix-blend-mode"] = getBlendMode(t1.bm)), e1;
    }, SVGShapeElement.prototype.createTransformElement = function(t1, e1) {
        var r1 = TransformPropertyFactory.getTransformProperty(this, t1, this), i1 = new SVGTransformData(r1, r1.o, e1);
        return this.addToAnimatedContents(t1, i1), i1;
    }, SVGShapeElement.prototype.createShapeElement = function(t1, e1, r1) {
        var i1 = 4;
        "rc" === t1.ty ? i1 = 5 : "el" === t1.ty ? i1 = 6 : "sr" === t1.ty && (i1 = 7);
        var s1 = new SVGShapeData(e1, r1, ShapePropertyFactory.getShapeProp(this, t1, i1, this));
        return this.shapes.push(s1), this.addShapeToModifiers(s1), this.addToAnimatedContents(t1, s1), s1;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(t1, e1) {
        for(var r1 = 0, i1 = this.animatedContents.length; r1 < i1;){
            if (this.animatedContents[r1].element === e1) return;
            r1 += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(t1),
            element: e1,
            data: t1
        });
    }, SVGShapeElement.prototype.setElementStyles = function(t1) {
        var e1, r1 = t1.styles, i1 = this.stylesList.length;
        for(e1 = 0; e1 < i1; e1 += 1)this.stylesList[e1].closed || r1.push(this.stylesList[e1]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
        var t1;
        this._isFirstFrame = !0;
        var e1 = this.itemsData.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
        for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
        this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, s1, a1, n1) {
        var o1, h1, l1, p1, m1, f1, c1 = [].concat(a1), d1 = t1.length - 1, u1 = [], y1 = [];
        for(o1 = d1; 0 <= o1; o1 -= 1){
            if ((f1 = this.searchProcessedElement(t1[o1])) ? e1[o1] = r1[f1 - 1] : t1[o1]._render = n1, "fl" === t1[o1].ty || "st" === t1[o1].ty || "gf" === t1[o1].ty || "gs" === t1[o1].ty) f1 ? e1[o1].style.closed = !1 : e1[o1] = this.createStyleElement(t1[o1], s1), t1[o1]._render && i1.appendChild(e1[o1].style.pElem), u1.push(e1[o1].style);
            else if ("gr" === t1[o1].ty) {
                if (f1) for(l1 = e1[o1].it.length, h1 = 0; h1 < l1; h1 += 1)e1[o1].prevViewData[h1] = e1[o1].it[h1];
                else e1[o1] = this.createGroupElement(t1[o1]);
                this.searchShapes(t1[o1].it, e1[o1].it, e1[o1].prevViewData, e1[o1].gr, s1 + 1, c1, n1), t1[o1]._render && i1.appendChild(e1[o1].gr);
            } else "tr" === t1[o1].ty ? (f1 || (e1[o1] = this.createTransformElement(t1[o1], i1)), p1 = e1[o1].transform, c1.push(p1)) : "sh" === t1[o1].ty || "rc" === t1[o1].ty || "el" === t1[o1].ty || "sr" === t1[o1].ty ? (f1 || (e1[o1] = this.createShapeElement(t1[o1], c1, s1)), this.setElementStyles(e1[o1])) : "tm" === t1[o1].ty || "rd" === t1[o1].ty || "ms" === t1[o1].ty || "pb" === t1[o1].ty ? (f1 ? (m1 = e1[o1]).closed = !1 : ((m1 = ShapeModifiers.getModifier(t1[o1].ty)).init(this, t1[o1]), e1[o1] = m1, this.shapeModifiers.push(m1)), y1.push(m1)) : "rp" === t1[o1].ty && (f1 ? (m1 = e1[o1]).closed = !0 : (m1 = ShapeModifiers.getModifier(t1[o1].ty), (e1[o1] = m1).init(this, t1, o1, e1), this.shapeModifiers.push(m1), n1 = !1), y1.push(m1));
            this.addProcessedElement(t1[o1], o1 + 1);
        }
        for(d1 = u1.length, o1 = 0; o1 < d1; o1 += 1)u1[o1].closed = !0;
        for(d1 = y1.length, o1 = 0; o1 < d1; o1 += 1)y1[o1].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
        var t1;
        this.renderModifiers();
        var e1 = this.stylesList.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].reset();
        for(this.renderShape(), t1 = 0; t1 < e1; t1 += 1)(this.stylesList[t1]._mdf || this._isFirstFrame) && (this.stylesList[t1].msElem && (this.stylesList[t1].msElem.setAttribute("d", this.stylesList[t1].d), this.stylesList[t1].d = "M0 0" + this.stylesList[t1].d), this.stylesList[t1].pElem.setAttribute("d", this.stylesList[t1].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
        var t1, e1, r1 = this.animatedContents.length;
        for(t1 = 0; t1 < r1; t1 += 1)e1 = this.animatedContents[t1], (this._isFirstFrame || e1.element._isAnimated) && !0 !== e1.data && e1.fn(e1.data, e1.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    }, SVGTintFilter.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v / 100;
            this.matrixFilter.setAttribute("values", r1[0] - e1[0] + " 0 0 0 " + e1[0] + " " + (r1[1] - e1[1]) + " 0 0 0 " + e1[1] + " " + (r1[2] - e1[2]) + " 0 0 0 " + e1[2] + " 0 0 0 " + i1 + " 0");
        }
    }, SVGFillFilter.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            var e1 = this.filterManager.effectElements[2].p.v, r1 = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute("values", "0 0 0 0 " + e1[0] + " 0 0 0 0 " + e1[1] + " 0 0 0 0 " + e1[2] + " 0 0 0 " + r1 + " 0");
        }
    }, SVGGaussianBlurEffect.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            var e1 = .3 * this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = 3 == r1 ? 0 : e1, s1 = 2 == r1 ? 0 : e1;
            this.feGaussianBlur.setAttribute("stdDeviation", i1 + " " + s1);
            var a1 = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
            this.feGaussianBlur.setAttribute("edgeMode", a1);
        }
    }, SVGStrokeEffect.prototype.initialize = function() {
        var t1, e1, r1, i1, s1 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        for(1 === this.filterManager.effectElements[1].p.v ? (i1 = this.elem.maskManager.masksProperties.length, r1 = 0) : i1 = (r1 = this.filterManager.effectElements[0].p.v - 1) + 1, (e1 = createNS("g")).setAttribute("fill", "none"), e1.setAttribute("stroke-linecap", "round"), e1.setAttribute("stroke-dashoffset", 1); r1 < i1; r1 += 1)t1 = createNS("path"), e1.appendChild(t1), this.paths.push({
            p: t1,
            m: r1
        });
        if (3 === this.filterManager.effectElements[10].p.v) {
            var a1 = createNS("mask"), n1 = createElementID();
            a1.setAttribute("id", n1), a1.setAttribute("mask-type", "alpha"), a1.appendChild(e1), this.elem.globalData.defs.appendChild(a1);
            var o1 = createNS("g");
            for(o1.setAttribute("mask", "url(" + locationHref + "#" + n1 + ")"); s1[0];)o1.appendChild(s1[0]);
            this.elem.layerElement.appendChild(o1), this.masker = a1, e1.setAttribute("stroke", "#fff");
        } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
            if (2 === this.filterManager.effectElements[10].p.v) for(s1 = this.elem.layerElement.children || this.elem.layerElement.childNodes; s1.length;)this.elem.layerElement.removeChild(s1[0]);
            this.elem.layerElement.appendChild(e1), this.elem.layerElement.removeAttribute("mask"), e1.setAttribute("stroke", "#fff");
        }
        this.initialized = !0, this.pathMasker = e1;
    }, SVGStrokeEffect.prototype.renderFrame = function(t1) {
        var e1;
        this.initialized || this.initialize();
        var r1, i1, s1 = this.paths.length;
        for(e1 = 0; e1 < s1; e1 += 1)if (-1 !== this.paths[e1].m && (r1 = this.elem.maskManager.viewData[this.paths[e1].m], i1 = this.paths[e1].p, (t1 || this.filterManager._mdf || r1.prop._mdf) && i1.setAttribute("d", r1.lastPath), t1 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r1.prop._mdf)) {
            var a1;
            if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                var n1 = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o1 = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h1 = i1.getTotalLength();
                a1 = "0 0 0 " + h1 * n1 + " ";
                var l1, p1 = h1 * (o1 - n1), m1 = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, f1 = Math.floor(p1 / m1);
                for(l1 = 0; l1 < f1; l1 += 1)a1 += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                a1 += "0 " + 10 * h1 + " 0 0";
            } else a1 = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
            i1.setAttribute("stroke-dasharray", a1);
        }
        if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t1 || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t1 || this.filterManager.effectElements[3].p._mdf)) {
            var c1 = this.filterManager.effectElements[3].p.v;
            this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * c1[0]) + "," + bmFloor(255 * c1[1]) + "," + bmFloor(255 * c1[2]) + ")");
        }
    }, SVGTritoneFilter.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            var e1 = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i1 = this.filterManager.effectElements[2].p.v, s1 = i1[0] + " " + r1[0] + " " + e1[0], a1 = i1[1] + " " + r1[1] + " " + e1[1], n1 = i1[2] + " " + r1[2] + " " + e1[2];
            this.feFuncR.setAttribute("tableValues", s1), this.feFuncG.setAttribute("tableValues", a1), this.feFuncB.setAttribute("tableValues", n1);
        }
    }, SVGProLevelsFilter.prototype.createFeFunc = function(t1, e1) {
        var r1 = createNS(t1);
        return r1.setAttribute("type", "table"), e1.appendChild(r1), r1;
    }, SVGProLevelsFilter.prototype.getTableValue = function(t1, e1, r1, i1, s1) {
        for(var a1, n1, o1 = 0, h1 = Math.min(t1, e1), l1 = Math.max(t1, e1), p1 = Array.call(null, {
            length: 256
        }), m1 = 0, f1 = s1 - i1, c1 = e1 - t1; o1 <= 256;)n1 = (a1 = o1 / 256) <= h1 ? c1 < 0 ? s1 : i1 : l1 <= a1 ? c1 < 0 ? i1 : s1 : i1 + f1 * Math.pow((a1 - t1) / c1, 1 / r1), p1[m1] = n1, m1 += 1, o1 += 256 / 255;
        return p1.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            var e1, r1 = this.filterManager.effectElements;
            this.feFuncRComposed && (t1 || r1[3].p._mdf || r1[4].p._mdf || r1[5].p._mdf || r1[6].p._mdf || r1[7].p._mdf) && (e1 = this.getTableValue(r1[3].p.v, r1[4].p.v, r1[5].p.v, r1[6].p.v, r1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e1), this.feFuncGComposed.setAttribute("tableValues", e1), this.feFuncBComposed.setAttribute("tableValues", e1)), this.feFuncR && (t1 || r1[10].p._mdf || r1[11].p._mdf || r1[12].p._mdf || r1[13].p._mdf || r1[14].p._mdf) && (e1 = this.getTableValue(r1[10].p.v, r1[11].p.v, r1[12].p.v, r1[13].p.v, r1[14].p.v), this.feFuncR.setAttribute("tableValues", e1)), this.feFuncG && (t1 || r1[17].p._mdf || r1[18].p._mdf || r1[19].p._mdf || r1[20].p._mdf || r1[21].p._mdf) && (e1 = this.getTableValue(r1[17].p.v, r1[18].p.v, r1[19].p.v, r1[20].p.v, r1[21].p.v), this.feFuncG.setAttribute("tableValues", e1)), this.feFuncB && (t1 || r1[24].p._mdf || r1[25].p._mdf || r1[26].p._mdf || r1[27].p._mdf || r1[28].p._mdf) && (e1 = this.getTableValue(r1[24].p.v, r1[25].p.v, r1[26].p.v, r1[27].p.v, r1[28].p.v), this.feFuncB.setAttribute("tableValues", e1)), this.feFuncA && (t1 || r1[31].p._mdf || r1[32].p._mdf || r1[33].p._mdf || r1[34].p._mdf || r1[35].p._mdf) && (e1 = this.getTableValue(r1[31].p.v, r1[32].p.v, r1[33].p.v, r1[34].p.v, r1[35].p.v), this.feFuncA.setAttribute("tableValues", e1));
        }
    }, SVGDropShadowEffect.prototype.renderFrame = function(t1) {
        if (t1 || this.filterManager._mdf) {
            if ((t1 || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t1 || this.filterManager.effectElements[0].p._mdf) {
                var e1 = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e1[0]), Math.round(255 * e1[1]), Math.round(255 * e1[2])));
            }
            if ((t1 || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t1 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var r1 = this.filterManager.effectElements[3].p.v, i1 = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s1 = r1 * Math.cos(i1), a1 = r1 * Math.sin(i1);
                this.feOffset.setAttribute("dx", s1), this.feOffset.setAttribute("dy", a1);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t1, e1, r1) {
        this.initialized = !1, this.filterManager = e1, this.filterElem = t1, (this.elem = r1).matteElement = createNS("g"), r1.matteElement.appendChild(r1.layerElement), r1.matteElement.appendChild(r1.transformedElement), r1.baseElement = r1.matteElement;
    }
    function SVGEffects(t1) {
        var e1, r1, i1 = t1.data.ef ? t1.data.ef.length : 0, s1 = createElementID(), a1 = filtersFactory.createFilter(s1, !0), n1 = 0;
        for(this.filters = [], e1 = 0; e1 < i1; e1 += 1)r1 = null, 20 === t1.data.ef[e1].ty ? (n1 += 1, r1 = new SVGTintFilter(a1, t1.effectsManager.effectElements[e1])) : 21 === t1.data.ef[e1].ty ? (n1 += 1, r1 = new SVGFillFilter(a1, t1.effectsManager.effectElements[e1])) : 22 === t1.data.ef[e1].ty ? r1 = new SVGStrokeEffect(t1, t1.effectsManager.effectElements[e1]) : 23 === t1.data.ef[e1].ty ? (n1 += 1, r1 = new SVGTritoneFilter(a1, t1.effectsManager.effectElements[e1])) : 24 === t1.data.ef[e1].ty ? (n1 += 1, r1 = new SVGProLevelsFilter(a1, t1.effectsManager.effectElements[e1])) : 25 === t1.data.ef[e1].ty ? (n1 += 1, r1 = new SVGDropShadowEffect(a1, t1.effectsManager.effectElements[e1])) : 28 === t1.data.ef[e1].ty ? r1 = new SVGMatte3Effect(a1, t1.effectsManager.effectElements[e1], t1) : 29 === t1.data.ef[e1].ty && (n1 += 1, r1 = new SVGGaussianBlurEffect(a1, t1.effectsManager.effectElements[e1])), r1 && this.filters.push(r1);
        n1 && (t1.globalData.defs.appendChild(a1), t1.layerElement.setAttribute("filter", "url(" + locationHref + "#" + s1 + ")")), this.filters.length && t1.addRenderableComponent(this);
    }
    function CVContextData() {
        var t1;
        this.saved = [], this.cArrPos = 0, this.cTr = new Matrix, this.cO = 1;
        for(this.savedOp = createTypedArray("float32", 15), t1 = 0; t1 < 15; t1 += 1)this.saved[t1] = createTypedArray("float32", 16);
        this._length = 15;
    }
    function CVBaseElement() {}
    function CVImageElement(t1, e1, r1) {
        this.assetData = e1.getAssetData(t1.refId), this.img = e1.imageLoader.getAsset(this.assetData), this.initElement(t1, e1, r1);
    }
    function CVCompElement(t1, e1, r1) {
        this.completeLayers = !1, this.layers = t1.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
            _placeholder: !0
        };
    }
    function CVMaskElement(t1, e1) {
        var r1;
        this.data = t1, this.element = e1, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
        var i1 = this.masksProperties.length, s1 = !1;
        for(r1 = 0; r1 < i1; r1 += 1)"n" !== this.masksProperties[r1].mode && (s1 = !0), this.viewData[r1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r1], 3);
        (this.hasMasks = s1) && this.element.addRenderableComponent(this);
    }
    function CVShapeElement(t1, e1, r1) {
        this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t1, e1, r1);
    }
    function CVSolidElement(t1, e1, r1) {
        this.initElement(t1, e1, r1);
    }
    function CVTextElement(t1, e1, r1) {
        this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
            fill: "rgba(0,0,0,0)",
            stroke: "rgba(0,0,0,0)",
            sWidth: 0,
            fValue: ""
        }, this.initElement(t1, e1, r1);
    }
    function CVEffects() {}
    function HBaseElement() {}
    function HSolidElement(t1, e1, r1) {
        this.initElement(t1, e1, r1);
    }
    function HCompElement(t1, e1, r1) {
        this.layers = t1.layers, this.supports3d = !t1.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t1, e1, r1), this.tm = t1.tm ? PropertyFactory.getProp(this, t1.tm, 0, e1.frameRate, this) : {
            _placeholder: !0
        };
    }
    function HShapeElement(t1, e1, r1) {
        this.shapes = [], this.shapesData = t1.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t1, e1, r1), this.prevViewData = [], this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    function HTextElement(t1, e1, r1) {
        this.textSpans = [], this.textPaths = [], this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        }, this.renderType = "svg", this.isMasked = !1, this.initElement(t1, e1, r1);
    }
    function HImageElement(t1, e1, r1) {
        this.assetData = e1.getAssetData(t1.refId), this.initElement(t1, e1, r1);
    }
    function HCameraElement(t1, e1, r1) {
        this.initFrame(), this.initBaseData(t1, e1, r1), this.initHierarchy();
        var i1 = PropertyFactory.getProp;
        if (this.pe = i1(this, t1.pe, 0, 0, this), t1.ks.p.s ? (this.px = i1(this, t1.ks.p.x, 1, 0, this), this.py = i1(this, t1.ks.p.y, 1, 0, this), this.pz = i1(this, t1.ks.p.z, 1, 0, this)) : this.p = i1(this, t1.ks.p, 1, 0, this), t1.ks.a && (this.a = i1(this, t1.ks.a, 1, 0, this)), t1.ks.or.k.length && t1.ks.or.k[0].to) {
            var s1, a1 = t1.ks.or.k.length;
            for(s1 = 0; s1 < a1; s1 += 1)t1.ks.or.k[s1].to = null, t1.ks.or.k[s1].ti = null;
        }
        this.or = i1(this, t1.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i1(this, t1.ks.rx, 0, degToRads, this), this.ry = i1(this, t1.ks.ry, 0, degToRads, this), this.rz = i1(this, t1.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
            mProp: this
        };
    }
    function HEffects() {}
    SVGMatte3Effect.prototype.findSymbol = function(t1) {
        for(var e1 = 0, r1 = _svgMatteSymbols.length; e1 < r1;){
            if (_svgMatteSymbols[e1] === t1) return _svgMatteSymbols[e1];
            e1 += 1;
        }
        return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(t1, e1) {
        var r1 = t1.layerElement.parentNode;
        if (r1) {
            for(var i1, s1 = r1.children, a1 = 0, n1 = s1.length; a1 < n1 && s1[a1] !== t1.layerElement;)a1 += 1;
            a1 <= n1 - 2 && (i1 = s1[a1 + 1]);
            var o1 = createNS("use");
            o1.setAttribute("href", "#" + e1), i1 ? r1.insertBefore(o1, i1) : r1.appendChild(o1);
        }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(t1, e1) {
        if (!this.findSymbol(e1)) {
            var r1 = createElementID(), i1 = createNS("mask");
            i1.setAttribute("id", e1.layerId), i1.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e1);
            var s1 = t1.globalData.defs;
            s1.appendChild(i1);
            var a1 = createNS("symbol");
            a1.setAttribute("id", r1), this.replaceInParent(e1, r1), a1.appendChild(e1.layerElement), s1.appendChild(a1);
            var n1 = createNS("use");
            n1.setAttribute("href", "#" + r1), i1.appendChild(n1), e1.data.hd = !1, e1.show();
        }
        t1.setMatte(e1.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
        for(var t1 = this.filterManager.effectElements[0].p.v, e1 = this.elem.comp.elements, r1 = 0, i1 = e1.length; r1 < i1;)e1[r1] && e1[r1].data.ind === t1 && this.setElementAsMask(this.elem, e1[r1]), r1 += 1;
        this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
        this.initialized || this.initialize();
    }, SVGEffects.prototype.renderFrame = function(t1) {
        var e1, r1 = this.filters.length;
        for(e1 = 0; e1 < r1; e1 += 1)this.filters[e1].renderFrame(t1);
    }, CVContextData.prototype.duplicate = function() {
        var t1 = 2 * this._length, e1 = this.savedOp;
        this.savedOp = createTypedArray("float32", t1), this.savedOp.set(e1);
        var r1 = 0;
        for(r1 = this._length; r1 < t1; r1 += 1)this.saved[r1] = createTypedArray("float32", 16);
        this._length = t1;
    }, CVContextData.prototype.reset = function() {
        this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
    }, CVBaseElement.prototype = {
        createElements: function() {},
        initRendererElement: function() {},
        createContainerElements: function() {
            this.canvasContext = this.globalData.canvasContext, this.renderableEffectsManager = new CVEffects(this);
        },
        createContent: function() {},
        setBlendMode: function() {
            var t1 = this.globalData;
            if (t1.blendMode !== this.data.bm) {
                t1.blendMode = this.data.bm;
                var e1 = getBlendMode(this.data.bm);
                t1.canvasContext.globalCompositeOperation = e1;
            }
        },
        createRenderableComponents: function() {
            this.maskManager = new CVMaskElement(this.data, this);
        },
        hideElement: function() {
            this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
        },
        showElement: function() {
            this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
        },
        renderFrame: function() {
            if (!this.hidden && !this.data.hd) {
                this.renderTransform(), this.renderRenderable(), this.setBlendMode();
                var t1 = 0 === this.data.ty;
                this.globalData.renderer.save(t1), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(t1), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
            }
        },
        destroy: function() {
            this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
        },
        mHelper: new Matrix
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var t1 = createTag("canvas");
            t1.width = this.assetData.w, t1.height = this.assetData.h;
            var e1, r1, i1 = t1.getContext("2d"), s1 = this.img.width, a1 = this.img.height, n1 = s1 / a1, o1 = this.assetData.w / this.assetData.h, h1 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            o1 < n1 && "xMidYMid slice" === h1 || n1 < o1 && "xMidYMid slice" !== h1 ? e1 = (r1 = a1) * o1 : r1 = (e1 = s1) / o1, i1.drawImage(this.img, (s1 - e1) / 2, (a1 - r1) / 2, e1, r1, 0, 0, this.assetData.w, this.assetData.h), this.img = t1;
        }
    }, CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
        this.img = null;
    }, extendPrototype([
        CanvasRenderer,
        ICompElement,
        CVBaseElement
    ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
        var t1, e1 = this.canvasContext;
        for(e1.beginPath(), e1.moveTo(0, 0), e1.lineTo(this.data.w, 0), e1.lineTo(this.data.w, this.data.h), e1.lineTo(0, this.data.h), e1.lineTo(0, 0), e1.clip(), t1 = this.layers.length - 1; 0 <= t1; t1 -= 1)(this.completeLayers || this.elements[t1]) && this.elements[t1].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
        var t1;
        for(t1 = this.layers.length - 1; 0 <= t1; t1 -= 1)this.elements[t1] && this.elements[t1].destroy();
        this.layers = null, this.elements = null;
    }, CVMaskElement.prototype.renderFrame = function() {
        if (this.hasMasks) {
            var t1, e1, r1, i1, s1 = this.element.finalTransform.mat, a1 = this.element.canvasContext, n1 = this.masksProperties.length;
            for(a1.beginPath(), t1 = 0; t1 < n1; t1 += 1)if ("n" !== this.masksProperties[t1].mode) {
                var o1;
                this.masksProperties[t1].inv && (a1.moveTo(0, 0), a1.lineTo(this.element.globalData.compSize.w, 0), a1.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), a1.lineTo(0, this.element.globalData.compSize.h), a1.lineTo(0, 0)), i1 = this.viewData[t1].v, e1 = s1.applyToPointArray(i1.v[0][0], i1.v[0][1], 0), a1.moveTo(e1[0], e1[1]);
                var h1 = i1._length;
                for(o1 = 1; o1 < h1; o1 += 1)r1 = s1.applyToTriplePoints(i1.o[o1 - 1], i1.i[o1], i1.v[o1]), a1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                r1 = s1.applyToTriplePoints(i1.o[o1 - 1], i1.i[0], i1.v[0]), a1.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
            }
            this.element.globalData.renderer.save(!0), a1.clip();
        }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
        this.element = null;
    }, extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(t1, e1) {
        var r1 = {
            data: t1,
            type: t1.ty,
            preTransforms: this.transformsManager.addTransformSequence(e1),
            transforms: [],
            elements: [],
            closed: !0 === t1.hd
        }, i1 = {};
        if ("fl" === t1.ty || "st" === t1.ty ? (i1.c = PropertyFactory.getProp(this, t1.c, 1, 255, this), i1.c.k || (r1.co = "rgb(" + bmFloor(i1.c.v[0]) + "," + bmFloor(i1.c.v[1]) + "," + bmFloor(i1.c.v[2]) + ")")) : "gf" !== t1.ty && "gs" !== t1.ty || (i1.s = PropertyFactory.getProp(this, t1.s, 1, null, this), i1.e = PropertyFactory.getProp(this, t1.e, 1, null, this), i1.h = PropertyFactory.getProp(this, t1.h || {
            k: 0
        }, 0, .01, this), i1.a = PropertyFactory.getProp(this, t1.a || {
            k: 0
        }, 0, degToRads, this), i1.g = new GradientProperty(this, t1.g, this)), i1.o = PropertyFactory.getProp(this, t1.o, 0, .01, this), "st" === t1.ty || "gs" === t1.ty) {
            if (r1.lc = lineCapEnum[t1.lc || 2], r1.lj = lineJoinEnum[t1.lj || 2], 1 == t1.lj && (r1.ml = t1.ml), i1.w = PropertyFactory.getProp(this, t1.w, 0, null, this), i1.w.k || (r1.wi = i1.w.v), t1.d) {
                var s1 = new DashProperty(this, t1.d, "canvas", this);
                i1.d = s1, i1.d.k || (r1.da = i1.d.dashArray, r1.do = i1.d.dashoffset[0]);
            }
        } else r1.r = 2 === t1.r ? "evenodd" : "nonzero";
        return this.stylesList.push(r1), i1.style = r1, i1;
    }, CVShapeElement.prototype.createGroupElement = function() {
        return {
            it: [],
            prevViewData: []
        };
    }, CVShapeElement.prototype.createTransformElement = function(t1) {
        return {
            transform: {
                opacity: 1,
                _opMdf: !1,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, t1.o, 0, .01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, t1, this)
            }
        };
    }, CVShapeElement.prototype.createShapeElement = function(t1) {
        var e1 = new CVShapeData(this, t1, this.stylesList, this.transformsManager);
        return this.shapes.push(e1), this.addShapeToModifiers(e1), e1;
    }, CVShapeElement.prototype.reloadShapes = function() {
        var t1;
        this._isFirstFrame = !0;
        var e1 = this.itemsData.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.prevViewData[t1] = this.itemsData[t1];
        for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e1 = this.dynamicProperties.length, t1 = 0; t1 < e1; t1 += 1)this.dynamicProperties[t1].getValue();
        this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(t1) {
        var e1, r1 = this.stylesList.length;
        for(e1 = 0; e1 < r1; e1 += 1)this.stylesList[e1].closed || this.stylesList[e1].transforms.push(t1);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var t1, e1 = this.stylesList.length;
        for(t1 = 0; t1 < e1; t1 += 1)this.stylesList[t1].closed || this.stylesList[t1].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(t1) {
        var e1, r1 = t1.length;
        for(e1 = 0; e1 < r1; e1 += 1)t1[e1].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(t1, e1, r1, i1, s1) {
        var a1, n1, o1, h1, l1, p1, m1 = t1.length - 1, f1 = [], c1 = [], d1 = [].concat(s1);
        for(a1 = m1; 0 <= a1; a1 -= 1){
            if ((h1 = this.searchProcessedElement(t1[a1])) ? e1[a1] = r1[h1 - 1] : t1[a1]._shouldRender = i1, "fl" === t1[a1].ty || "st" === t1[a1].ty || "gf" === t1[a1].ty || "gs" === t1[a1].ty) h1 ? e1[a1].style.closed = !1 : e1[a1] = this.createStyleElement(t1[a1], d1), f1.push(e1[a1].style);
            else if ("gr" === t1[a1].ty) {
                if (h1) for(o1 = e1[a1].it.length, n1 = 0; n1 < o1; n1 += 1)e1[a1].prevViewData[n1] = e1[a1].it[n1];
                else e1[a1] = this.createGroupElement(t1[a1]);
                this.searchShapes(t1[a1].it, e1[a1].it, e1[a1].prevViewData, i1, d1);
            } else "tr" === t1[a1].ty ? (h1 || (p1 = this.createTransformElement(t1[a1]), e1[a1] = p1), d1.push(e1[a1]), this.addTransformToStyleList(e1[a1])) : "sh" === t1[a1].ty || "rc" === t1[a1].ty || "el" === t1[a1].ty || "sr" === t1[a1].ty ? h1 || (e1[a1] = this.createShapeElement(t1[a1])) : "tm" === t1[a1].ty || "rd" === t1[a1].ty || "pb" === t1[a1].ty ? (h1 ? (l1 = e1[a1]).closed = !1 : ((l1 = ShapeModifiers.getModifier(t1[a1].ty)).init(this, t1[a1]), e1[a1] = l1, this.shapeModifiers.push(l1)), c1.push(l1)) : "rp" === t1[a1].ty && (h1 ? (l1 = e1[a1]).closed = !0 : (l1 = ShapeModifiers.getModifier(t1[a1].ty), (e1[a1] = l1).init(this, t1, a1, e1), this.shapeModifiers.push(l1), i1 = !1), c1.push(l1));
            this.addProcessedElement(t1[a1], a1 + 1);
        }
        for(this.removeTransformFromStyleList(), this.closeStyles(f1), m1 = c1.length, a1 = 0; a1 < m1; a1 += 1)c1[a1].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(t1, e1) {
        (t1._opMdf || e1.op._mdf || this._isFirstFrame) && (e1.opacity = t1.opacity, e1.opacity *= e1.op.v, e1._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
        var t1, e1, r1, i1, s1, a1, n1, o1, h1, l1 = this.stylesList.length, p1 = this.globalData.renderer, m1 = this.globalData.canvasContext;
        for(t1 = 0; t1 < l1; t1 += 1)if (("st" !== (o1 = (h1 = this.stylesList[t1]).type) && "gs" !== o1 || 0 !== h1.wi) && h1.data._shouldRender && 0 !== h1.coOp && 0 !== this.globalData.currentGlobalAlpha) {
            for(p1.save(), a1 = h1.elements, "st" === o1 || "gs" === o1 ? (m1.strokeStyle = "st" === o1 ? h1.co : h1.grd, m1.lineWidth = h1.wi, m1.lineCap = h1.lc, m1.lineJoin = h1.lj, m1.miterLimit = h1.ml || 0) : m1.fillStyle = "fl" === o1 ? h1.co : h1.grd, p1.ctxOpacity(h1.coOp), "st" !== o1 && "gs" !== o1 && m1.beginPath(), p1.ctxTransform(h1.preTransforms.finalTransform.props), r1 = a1.length, e1 = 0; e1 < r1; e1 += 1){
                for("st" !== o1 && "gs" !== o1 || (m1.beginPath(), h1.da && (m1.setLineDash(h1.da), m1.lineDashOffset = h1.do)), s1 = (n1 = a1[e1].trNodes).length, i1 = 0; i1 < s1; i1 += 1)"m" === n1[i1].t ? m1.moveTo(n1[i1].p[0], n1[i1].p[1]) : "c" === n1[i1].t ? m1.bezierCurveTo(n1[i1].pts[0], n1[i1].pts[1], n1[i1].pts[2], n1[i1].pts[3], n1[i1].pts[4], n1[i1].pts[5]) : m1.closePath();
                "st" !== o1 && "gs" !== o1 || (m1.stroke(), h1.da && m1.setLineDash(this.dashResetter));
            }
            "st" !== o1 && "gs" !== o1 && m1.fill(h1.r), p1.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(t1, e1, r1, i1) {
        var s1, a1;
        for(a1 = t1, s1 = e1.length - 1; 0 <= s1; s1 -= 1)"tr" === e1[s1].ty ? (a1 = r1[s1].transform, this.renderShapeTransform(t1, a1)) : "sh" === e1[s1].ty || "el" === e1[s1].ty || "rc" === e1[s1].ty || "sr" === e1[s1].ty ? this.renderPath(e1[s1], r1[s1]) : "fl" === e1[s1].ty ? this.renderFill(e1[s1], r1[s1], a1) : "st" === e1[s1].ty ? this.renderStroke(e1[s1], r1[s1], a1) : "gf" === e1[s1].ty || "gs" === e1[s1].ty ? this.renderGradientFill(e1[s1], r1[s1], a1) : "gr" === e1[s1].ty ? this.renderShape(a1, e1[s1].it, r1[s1].it) : e1[s1].ty;
        i1 && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(t1, e1) {
        if (this._isFirstFrame || e1._mdf || t1.transforms._mdf) {
            var r1, i1, s1, a1 = t1.trNodes, n1 = e1.paths, o1 = n1._length;
            a1.length = 0;
            var h1 = t1.transforms.finalTransform;
            for(s1 = 0; s1 < o1; s1 += 1){
                var l1 = n1.shapes[s1];
                if (l1 && l1.v) {
                    for(i1 = l1._length, r1 = 1; r1 < i1; r1 += 1)1 === r1 && a1.push({
                        t: "m",
                        p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                    }), a1.push({
                        t: "c",
                        pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[r1], l1.v[r1])
                    });
                    1 === i1 && a1.push({
                        t: "m",
                        p: h1.applyToPointArray(l1.v[0][0], l1.v[0][1], 0)
                    }), l1.c && i1 && (a1.push({
                        t: "c",
                        pts: h1.applyToTriplePoints(l1.o[r1 - 1], l1.i[0], l1.v[0])
                    }), a1.push({
                        t: "z"
                    }));
                }
            }
            t1.trNodes = a1;
        }
    }, CVShapeElement.prototype.renderPath = function(t1, e1) {
        if (!0 !== t1.hd && t1._shouldRender) {
            var r1, i1 = e1.styledShapes.length;
            for(r1 = 0; r1 < i1; r1 += 1)this.renderStyledShape(e1.styledShapes[r1], e1.sh);
        }
    }, CVShapeElement.prototype.renderFill = function(t1, e1, r1) {
        var i1 = e1.style;
        (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(t1, e1, r1) {
        var i1, s1 = e1.style;
        if (!s1.grd || e1.g._mdf || e1.s._mdf || e1.e._mdf || 1 !== t1.t && (e1.h._mdf || e1.a._mdf)) {
            var a1, n1 = this.globalData.canvasContext, o1 = e1.s.v, h1 = e1.e.v;
            if (1 === t1.t) i1 = n1.createLinearGradient(o1[0], o1[1], h1[0], h1[1]);
            else {
                var l1 = Math.sqrt(Math.pow(o1[0] - h1[0], 2) + Math.pow(o1[1] - h1[1], 2)), p1 = Math.atan2(h1[1] - o1[1], h1[0] - o1[0]), m1 = e1.h.v;
                1 <= m1 ? m1 = .99 : m1 <= -1 && (m1 = -0.99);
                var f1 = l1 * m1, c1 = Math.cos(p1 + e1.a.v) * f1 + o1[0], d1 = Math.sin(p1 + e1.a.v) * f1 + o1[1];
                i1 = n1.createRadialGradient(c1, d1, 0, o1[0], o1[1], l1);
            }
            var u1 = t1.g.p, y1 = e1.g.c, g1 = 1;
            for(a1 = 0; a1 < u1; a1 += 1)e1.g._hasOpacity && e1.g._collapsable && (g1 = e1.g.o[2 * a1 + 1]), i1.addColorStop(y1[4 * a1] / 100, "rgba(" + y1[4 * a1 + 1] + "," + y1[4 * a1 + 2] + "," + y1[4 * a1 + 3] + "," + g1 + ")");
            s1.grd = i1;
        }
        s1.coOp = e1.o.v * r1.opacity;
    }, CVShapeElement.prototype.renderStroke = function(t1, e1, r1) {
        var i1 = e1.style, s1 = e1.d;
        s1 && (s1._mdf || this._isFirstFrame) && (i1.da = s1.dashArray, i1.do = s1.dashoffset[0]), (e1.c._mdf || this._isFirstFrame) && (i1.co = "rgb(" + bmFloor(e1.c.v[0]) + "," + bmFloor(e1.c.v[1]) + "," + bmFloor(e1.c.v[2]) + ")"), (e1.o._mdf || r1._opMdf || this._isFirstFrame) && (i1.coOp = e1.o.v * r1.opacity), (e1.w._mdf || this._isFirstFrame) && (i1.wi = e1.w.v);
    }, CVShapeElement.prototype.destroy = function() {
        this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    }, extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
        var t1 = this.canvasContext;
        t1.fillStyle = this.data.sc, t1.fillRect(0, 0, this.data.sw, this.data.sh);
    }, extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
        var t1 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
        var e1 = !1;
        t1.fc ? (e1 = !0, this.values.fill = this.buildColor(t1.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e1;
        var r1 = !1;
        t1.sc && (r1 = !0, this.values.stroke = this.buildColor(t1.sc), this.values.sWidth = t1.sw);
        var i1, s1, a1, n1, o1, h1, l1, p1, m1, f1, c1, d1, u1 = this.globalData.fontManager.getFontByName(t1.f), y1 = t1.l, g1 = this.mHelper;
        this.stroke = r1, this.values.fValue = t1.finalSize + "px " + this.globalData.fontManager.getFontByName(t1.f).fFamily, s1 = t1.finalText.length;
        var v1 = this.data.singleShape, b1 = .001 * t1.tr * t1.finalSize, P1 = 0, E1 = 0, x1 = !0, S1 = 0;
        for(i1 = 0; i1 < s1; i1 += 1){
            for(n1 = (a1 = this.globalData.fontManager.getCharData(t1.finalText[i1], u1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily)) && a1.data || {}, g1.reset(), v1 && y1[i1].n && (P1 = -b1, E1 += t1.yOffset, E1 += x1 ? 1 : 0, x1 = !1), m1 = (l1 = n1.shapes ? n1.shapes[0].it : []).length, g1.scale(t1.finalSize / 100, t1.finalSize / 100), v1 && this.applyTextPropertiesToMatrix(t1, g1, y1[i1].line, P1, E1), c1 = createSizedArray(m1), p1 = 0; p1 < m1; p1 += 1){
                for(h1 = l1[p1].ks.k.i.length, f1 = l1[p1].ks.k, d1 = [], o1 = 1; o1 < h1; o1 += 1)1 === o1 && d1.push(g1.applyToX(f1.v[0][0], f1.v[0][1], 0), g1.applyToY(f1.v[0][0], f1.v[0][1], 0)), d1.push(g1.applyToX(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToY(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToX(f1.i[o1][0], f1.i[o1][1], 0), g1.applyToY(f1.i[o1][0], f1.i[o1][1], 0), g1.applyToX(f1.v[o1][0], f1.v[o1][1], 0), g1.applyToY(f1.v[o1][0], f1.v[o1][1], 0));
                d1.push(g1.applyToX(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToY(f1.o[o1 - 1][0], f1.o[o1 - 1][1], 0), g1.applyToX(f1.i[0][0], f1.i[0][1], 0), g1.applyToY(f1.i[0][0], f1.i[0][1], 0), g1.applyToX(f1.v[0][0], f1.v[0][1], 0), g1.applyToY(f1.v[0][0], f1.v[0][1], 0)), c1[p1] = d1;
            }
            v1 && (P1 += y1[i1].l, P1 += b1), this.textSpans[S1] ? this.textSpans[S1].elem = c1 : this.textSpans[S1] = {
                elem: c1
            }, S1 += 1;
        }
    }, CVTextElement.prototype.renderInnerContent = function() {
        var t1, e1, r1, i1, s1, a1, n1 = this.canvasContext;
        n1.font = this.values.fValue, n1.lineCap = "butt", n1.lineJoin = "miter", n1.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var o1, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
        e1 = l1.length;
        var p1, m1, f1 = null, c1 = null, d1 = null;
        for(t1 = 0; t1 < e1; t1 += 1)if (!l1[t1].n) {
            if ((o1 = h1[t1]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(o1.p), this.globalData.renderer.ctxOpacity(o1.o)), this.fill) {
                for(o1 && o1.fc ? f1 !== o1.fc && (f1 = o1.fc, n1.fillStyle = o1.fc) : f1 !== this.values.fill && (f1 = this.values.fill, n1.fillStyle = this.values.fill), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(a1 = (m1 = p1[r1]).length, this.globalData.canvasContext.moveTo(m1[0], m1[1]), s1 = 2; s1 < a1; s1 += 6)this.globalData.canvasContext.bezierCurveTo(m1[s1], m1[s1 + 1], m1[s1 + 2], m1[s1 + 3], m1[s1 + 4], m1[s1 + 5]);
                this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
            }
            if (this.stroke) {
                for(o1 && o1.sw ? d1 !== o1.sw && (d1 = o1.sw, n1.lineWidth = o1.sw) : d1 !== this.values.sWidth && (d1 = this.values.sWidth, n1.lineWidth = this.values.sWidth), o1 && o1.sc ? c1 !== o1.sc && (c1 = o1.sc, n1.strokeStyle = o1.sc) : c1 !== this.values.stroke && (c1 = this.values.stroke, n1.strokeStyle = this.values.stroke), i1 = (p1 = this.textSpans[t1].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i1; r1 += 1)for(a1 = (m1 = p1[r1]).length, this.globalData.canvasContext.moveTo(m1[0], m1[1]), s1 = 2; s1 < a1; s1 += 6)this.globalData.canvasContext.bezierCurveTo(m1[s1], m1[s1 + 1], m1[s1 + 2], m1[s1 + 3], m1[s1 + 4], m1[s1 + 5]);
                this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
            }
            o1 && this.globalData.renderer.restore();
        }
    }, CVEffects.prototype.renderFrame = function() {}, HBaseElement.prototype = {
        checkBlendMode: function() {},
        initRendererElement: function() {
            this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
        },
        createContainerElements: function() {
            this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function() {
            var t1 = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var e1 = this.finalTransform.mat.toCSS();
                t1.transform = e1, t1.webkitTransform = e1;
            }
            this.finalTransform._opMdf && (t1.opacity = this.finalTransform.mProp.o.v);
        },
        renderFrame: function() {
            this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        destroy: function() {
            this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
        },
        createRenderableComponents: function() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function() {},
        setMatte: function() {}
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting, extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement), HSolidElement.prototype.createContent = function() {
        var t1;
        this.data.hasMask ? ((t1 = createNS("rect")).setAttribute("width", this.data.sw), t1.setAttribute("height", this.data.sh), t1.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t1 = createTag("div")).style.width = this.data.sw + "px", t1.style.height = this.data.sh + "px", t1.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t1);
    }, extendPrototype([
        HybridRenderer,
        ICompElement,
        HBaseElement
    ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(t1, e1) {
        for(var r1, i1 = 0; i1 < e1;)this.elements[i1] && this.elements[i1].getBaseElement && (r1 = this.elements[i1].getBaseElement()), i1 += 1;
        r1 ? this.layerElement.insertBefore(t1, r1) : this.layerElement.appendChild(t1);
    }, extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
        var t1;
        if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t1 = this.svgElement;
        else {
            t1 = createNS("svg");
            var e1 = this.comp.data ? this.comp.data : this.globalData.compSize;
            t1.setAttribute("width", e1.w), t1.setAttribute("height", e1.h), t1.appendChild(this.shapesContainer), this.layerElement.appendChild(t1);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t1;
    }, HShapeElement.prototype.getTransformedPoint = function(t1, e1) {
        var r1, i1 = t1.length;
        for(r1 = 0; r1 < i1; r1 += 1)e1 = t1[r1].mProps.v.applyToPointArray(e1[0], e1[1], 0);
        return e1;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(t1, e1) {
        var r1, i1, s1, a1, n1, o1 = t1.sh.v, h1 = t1.transformers, l1 = o1._length;
        if (!(l1 <= 1)) {
            for(r1 = 0; r1 < l1 - 1; r1 += 1)i1 = this.getTransformedPoint(h1, o1.v[r1]), s1 = this.getTransformedPoint(h1, o1.o[r1]), a1 = this.getTransformedPoint(h1, o1.i[r1 + 1]), n1 = this.getTransformedPoint(h1, o1.v[r1 + 1]), this.checkBounds(i1, s1, a1, n1, e1);
            o1.c && (i1 = this.getTransformedPoint(h1, o1.v[r1]), s1 = this.getTransformedPoint(h1, o1.o[r1]), a1 = this.getTransformedPoint(h1, o1.i[0]), n1 = this.getTransformedPoint(h1, o1.v[0]), this.checkBounds(i1, s1, a1, n1, e1));
        }
    }, HShapeElement.prototype.checkBounds = function(t1, e1, r1, i1, s1) {
        this.getBoundsOfCurve(t1, e1, r1, i1);
        var a1 = this.shapeBoundingBox;
        s1.x = bmMin(a1.left, s1.x), s1.xMax = bmMax(a1.right, s1.xMax), s1.y = bmMin(a1.top, s1.y), s1.yMax = bmMax(a1.bottom, s1.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(t1, e1, r1, i1) {
        for(var s1, a1, n1, o1, h1, l1, p1, m1 = [
            [
                t1[0],
                i1[0]
            ],
            [
                t1[1],
                i1[1]
            ]
        ], f1 = 0; f1 < 2; ++f1)a1 = 6 * t1[f1] - 12 * e1[f1] + 6 * r1[f1], s1 = -3 * t1[f1] + 9 * e1[f1] - 9 * r1[f1] + 3 * i1[f1], n1 = 3 * e1[f1] - 3 * t1[f1], a1 |= 0, n1 |= 0, 0 === (s1 |= 0) && 0 === a1 || (0 === s1 ? 0 < (o1 = -n1 / a1) && o1 < 1 && m1[f1].push(this.calculateF(o1, t1, e1, r1, i1, f1)) : 0 <= (h1 = a1 * a1 - 4 * n1 * s1) && (0 < (l1 = (-a1 + bmSqrt(h1)) / (2 * s1)) && l1 < 1 && m1[f1].push(this.calculateF(l1, t1, e1, r1, i1, f1)), 0 < (p1 = (-a1 - bmSqrt(h1)) / (2 * s1)) && p1 < 1 && m1[f1].push(this.calculateF(p1, t1, e1, r1, i1, f1))));
        this.shapeBoundingBox.left = bmMin.apply(null, m1[0]), this.shapeBoundingBox.top = bmMin.apply(null, m1[1]), this.shapeBoundingBox.right = bmMax.apply(null, m1[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, m1[1]);
    }, HShapeElement.prototype.calculateF = function(t1, e1, r1, i1, s1, a1) {
        return bmPow(1 - t1, 3) * e1[a1] + 3 * bmPow(1 - t1, 2) * t1 * r1[a1] + 3 * (1 - t1) * bmPow(t1, 2) * i1[a1] + bmPow(t1, 3) * s1[a1];
    }, HShapeElement.prototype.calculateBoundingBox = function(t1, e1) {
        var r1, i1 = t1.length;
        for(r1 = 0; r1 < i1; r1 += 1)t1[r1] && t1[r1].sh ? this.calculateShapeBoundingBox(t1[r1], e1) : t1[r1] && t1[r1].it && this.calculateBoundingBox(t1[r1].it, e1);
    }, HShapeElement.prototype.currentBoxContains = function(t1) {
        return this.currentBBox.x <= t1.x && this.currentBBox.y <= t1.y && this.currentBBox.width + this.currentBBox.x >= t1.x + t1.width && this.currentBBox.height + this.currentBBox.y >= t1.y + t1.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
        if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
            var t1 = this.tempBoundingBox, e1 = 999999;
            if (t1.x = e1, t1.xMax = -e1, t1.y = e1, t1.yMax = -e1, this.calculateBoundingBox(this.itemsData, t1), t1.width = t1.xMax < t1.x ? 0 : t1.xMax - t1.x, t1.height = t1.yMax < t1.y ? 0 : t1.yMax - t1.y, this.currentBoxContains(t1)) return;
            var r1 = !1;
            if (this.currentBBox.w !== t1.width && (this.currentBBox.w = t1.width, this.shapeCont.setAttribute("width", t1.width), r1 = !0), this.currentBBox.h !== t1.height && (this.currentBBox.h = t1.height, this.shapeCont.setAttribute("height", t1.height), r1 = !0), r1 || this.currentBBox.x !== t1.x || this.currentBBox.y !== t1.y) {
                this.currentBBox.w = t1.width, this.currentBBox.h = t1.height, this.currentBBox.x = t1.x, this.currentBBox.y = t1.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                var i1 = this.shapeCont.style, s1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                i1.transform = s1, i1.webkitTransform = s1;
            }
        }
    }, extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement), HTextElement.prototype.createContent = function() {
        if (this.isMasked = this.checkMasks(), this.isMasked) {
            this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
            var t1 = createNS("g");
            this.maskedElement.appendChild(t1), this.innerElem = t1;
        } else this.renderType = "html", this.innerElem = this.layerElement;
        this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
        var t1 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t1.l ? t1.l.length : 0);
        var e1 = this.innerElem.style, r1 = t1.fc ? this.buildColor(t1.fc) : "rgba(0,0,0,0)";
        e1.fill = r1, e1.color = r1, t1.sc && (e1.stroke = this.buildColor(t1.sc), e1.strokeWidth = t1.sw + "px");
        var i1, s1, a1 = this.globalData.fontManager.getFontByName(t1.f);
        if (!this.globalData.fontManager.chars) {
            if (e1.fontSize = t1.finalSize + "px", e1.lineHeight = t1.finalSize + "px", a1.fClass) this.innerElem.className = a1.fClass;
            else {
                e1.fontFamily = a1.fFamily;
                var n1 = t1.fWeight, o1 = t1.fStyle;
                e1.fontStyle = o1, e1.fontWeight = n1;
            }
        }
        var h1, l1, p1, m1 = t1.l;
        s1 = m1.length;
        var f1, c1 = this.mHelper, d1 = "", u1 = 0;
        for(i1 = 0; i1 < s1; i1 += 1){
            if (this.globalData.fontManager.chars ? (this.textPaths[u1] ? h1 = this.textPaths[u1] : ((h1 = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h1.setAttribute("stroke-linejoin", lineJoinEnum[2]), h1.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u1] ? p1 = (l1 = this.textSpans[u1]).children[0] : ((l1 = createTag("div")).style.lineHeight = 0, (p1 = createNS("svg")).appendChild(h1), styleDiv(l1)))) : this.isMasked ? h1 = this.textPaths[u1] ? this.textPaths[u1] : createNS("text") : this.textSpans[u1] ? (l1 = this.textSpans[u1], h1 = this.textPaths[u1]) : (styleDiv(l1 = createTag("span")), styleDiv(h1 = createTag("span")), l1.appendChild(h1)), this.globalData.fontManager.chars) {
                var y1, g1 = this.globalData.fontManager.getCharData(t1.finalText[i1], a1.fStyle, this.globalData.fontManager.getFontByName(t1.f).fFamily);
                if (y1 = g1 ? g1.data : null, c1.reset(), y1 && y1.shapes && (f1 = y1.shapes[0].it, c1.scale(t1.finalSize / 100, t1.finalSize / 100), d1 = this.createPathShape(c1, f1), h1.setAttribute("d", d1)), this.isMasked) this.innerElem.appendChild(h1);
                else {
                    if (this.innerElem.appendChild(l1), y1 && y1.shapes) {
                        document.body.appendChild(p1);
                        var v1 = p1.getBBox();
                        p1.setAttribute("width", v1.width + 2), p1.setAttribute("height", v1.height + 2), p1.setAttribute("viewBox", v1.x - 1 + " " + (v1.y - 1) + " " + (v1.width + 2) + " " + (v1.height + 2));
                        var b1 = p1.style, P1 = "translate(" + (v1.x - 1) + "px," + (v1.y - 1) + "px)";
                        b1.transform = P1, b1.webkitTransform = P1, m1[i1].yOffset = v1.y - 1;
                    } else p1.setAttribute("width", 1), p1.setAttribute("height", 1);
                    l1.appendChild(p1);
                }
            } else if (h1.textContent = m1[i1].val, h1.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h1);
            else {
                this.innerElem.appendChild(l1);
                var E1 = h1.style, x1 = "translate3d(0," + -t1.finalSize / 1.2 + "px,0)";
                E1.transform = x1, E1.webkitTransform = x1;
            }
            this.isMasked ? this.textSpans[u1] = h1 : this.textSpans[u1] = l1, this.textSpans[u1].style.display = "block", this.textPaths[u1] = h1, u1 += 1;
        }
        for(; u1 < this.textSpans.length;)this.textSpans[u1].style.display = "none", u1 += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
        var t1;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t1 = this.svgElement.style;
                var e1 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                t1.transform = e1, t1.webkitTransform = e1;
            }
        }
        if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
            var r1, i1, s1, a1, n1, o1 = 0, h1 = this.textAnimator.renderedLetters, l1 = this.textProperty.currentData.l;
            for(i1 = l1.length, r1 = 0; r1 < i1; r1 += 1)l1[r1].n ? o1 += 1 : (a1 = this.textSpans[r1], n1 = this.textPaths[r1], s1 = h1[o1], o1 += 1, s1._mdf.m && (this.isMasked ? a1.setAttribute("transform", s1.m) : (a1.style.webkitTransform = s1.m, a1.style.transform = s1.m)), a1.style.opacity = s1.o, s1.sw && s1._mdf.sw && n1.setAttribute("stroke-width", s1.sw), s1.sc && s1._mdf.sc && n1.setAttribute("stroke", s1.sc), s1.fc && s1._mdf.fc && (n1.setAttribute("fill", s1.fc), n1.style.color = s1.fc));
            if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                var p1 = this.innerElem.getBBox();
                this.currentBBox.w !== p1.width && (this.currentBBox.w = p1.width, this.svgElement.setAttribute("width", p1.width)), this.currentBBox.h !== p1.height && (this.currentBBox.h = p1.height, this.svgElement.setAttribute("height", p1.height));
                if (this.currentBBox.w !== p1.width + 2 || this.currentBBox.h !== p1.height + 2 || this.currentBBox.x !== p1.x - 1 || this.currentBBox.y !== p1.y - 1) {
                    this.currentBBox.w = p1.width + 2, this.currentBBox.h = p1.height + 2, this.currentBBox.x = p1.x - 1, this.currentBBox.y = p1.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t1 = this.svgElement.style;
                    var m1 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    t1.transform = m1, t1.webkitTransform = m1;
                }
            }
        }
    }, extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement), HImageElement.prototype.createContent = function() {
        var t1 = this.globalData.getAssetsPath(this.assetData), e1 = new Image;
        this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t1), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e1), e1.crossOrigin = "anonymous", e1.src = t1, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    }, extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement), HCameraElement.prototype.setup = function() {
        var t1, e1, r1, i1, s1 = this.comp.threeDElements.length;
        for(t1 = 0; t1 < s1; t1 += 1)if ("3d" === (e1 = this.comp.threeDElements[t1]).type) {
            r1 = e1.perspectiveElem.style, i1 = e1.container.style;
            var a1 = this.pe.v + "px", n1 = "0px 0px 0px", o1 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            r1.perspective = a1, r1.webkitPerspective = a1, i1.transformOrigin = n1, i1.mozTransformOrigin = n1, i1.webkitTransformOrigin = n1, r1.transform = o1, r1.webkitTransform = o1;
        }
    }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
        var t1, e1, r1 = this._isFirstFrame;
        if (this.hierarchy) for(e1 = this.hierarchy.length, t1 = 0; t1 < e1; t1 += 1)r1 = this.hierarchy[t1].finalTransform.mProp._mdf || r1;
        if (r1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            if (this.mat.reset(), this.hierarchy) for(t1 = e1 = this.hierarchy.length - 1; 0 <= t1; t1 -= 1){
                var i1 = this.hierarchy[t1].finalTransform.mProp;
                this.mat.translate(-i1.p.v[0], -i1.p.v[1], i1.p.v[2]), this.mat.rotateX(-i1.or.v[0]).rotateY(-i1.or.v[1]).rotateZ(i1.or.v[2]), this.mat.rotateX(-i1.rx.v).rotateY(-i1.ry.v).rotateZ(i1.rz.v), this.mat.scale(1 / i1.s.v[0], 1 / i1.s.v[1], 1 / i1.s.v[2]), this.mat.translate(i1.a.v[0], i1.a.v[1], i1.a.v[2]);
            }
            if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                var s1;
                s1 = this.p ? [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ] : [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var a1 = Math.sqrt(Math.pow(s1[0], 2) + Math.pow(s1[1], 2) + Math.pow(s1[2], 2)), n1 = [
                    s1[0] / a1,
                    s1[1] / a1,
                    s1[2] / a1
                ], o1 = Math.sqrt(n1[2] * n1[2] + n1[0] * n1[0]), h1 = Math.atan2(n1[1], o1), l1 = Math.atan2(n1[0], -n1[2]);
                this.mat.rotateY(l1).rotateX(-h1);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
            var p1 = !this._prevMat.equals(this.mat);
            if ((p1 || this.pe._mdf) && this.comp.threeDElements) {
                var m1, f1, c1;
                for(e1 = this.comp.threeDElements.length, t1 = 0; t1 < e1; t1 += 1)if ("3d" === (m1 = this.comp.threeDElements[t1]).type) {
                    if (p1) {
                        var d1 = this.mat.toCSS();
                        (c1 = m1.container.style).transform = d1, c1.webkitTransform = d1;
                    }
                    this.pe._mdf && ((f1 = m1.perspectiveElem.style).perspective = this.pe.v + "px", f1.webkitPerspective = this.pe.v + "px");
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(t1) {
        this.prepareProperties(t1, !0);
    }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
        return null;
    }, HEffects.prototype.renderFrame = function() {};
    var animationManager = function() {
        var t1 = {}, s1 = [], i1 = 0, a1 = 0, n1 = 0, o1 = !0, h1 = !1;
        function r1(t1) {
            for(var e1 = 0, r1 = t1.target; e1 < a1;)s1[e1].animation === r1 && (s1.splice(e1, 1), e1 -= 1, a1 -= 1, r1.isPaused || m1()), e1 += 1;
        }
        function l1(t1, e1) {
            if (!t1) return null;
            for(var r1 = 0; r1 < a1;){
                if (s1[r1].elem === t1 && null !== s1[r1].elem) return s1[r1].animation;
                r1 += 1;
            }
            var i1 = new AnimationItem;
            return f1(i1, t1), i1.setData(t1, e1), i1;
        }
        function p1() {
            n1 += 1, d1();
        }
        function m1() {
            n1 -= 1;
        }
        function f1(t1, e1) {
            t1.addEventListener("destroy", r1), t1.addEventListener("_active", p1), t1.addEventListener("_idle", m1), s1.push({
                elem: e1,
                animation: t1
            }), a1 += 1;
        }
        function c1(t1) {
            var e1, r1 = t1 - i1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.advanceTime(r1);
            i1 = t1, n1 && !h1 ? window.requestAnimationFrame(c1) : o1 = !0;
        }
        function e1(t1) {
            i1 = t1, window.requestAnimationFrame(c1);
        }
        function d1() {
            !h1 && n1 && o1 && (window.requestAnimationFrame(e1), o1 = !1);
        }
        return t1.registerAnimation = l1, t1.loadAnimation = function(t1) {
            var e1 = new AnimationItem;
            return f1(e1, null), e1.setParams(t1), e1;
        }, t1.setSpeed = function(t1, e1) {
            var r1;
            for(r1 = 0; r1 < a1; r1 += 1)s1[r1].animation.setSpeed(t1, e1);
        }, t1.setDirection = function(t1, e1) {
            var r1;
            for(r1 = 0; r1 < a1; r1 += 1)s1[r1].animation.setDirection(t1, e1);
        }, t1.play = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.play(t1);
        }, t1.pause = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.pause(t1);
        }, t1.stop = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.stop(t1);
        }, t1.togglePause = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.togglePause(t1);
        }, t1.searchAnimations = function(t1, e1, r1) {
            var i1, s1 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), a1 = s1.length;
            for(i1 = 0; i1 < a1; i1 += 1)r1 && s1[i1].setAttribute("data-bm-type", r1), l1(s1[i1], t1);
            if (e1 && 0 === a1) {
                r1 || (r1 = "svg");
                var n1 = document.getElementsByTagName("body")[0];
                n1.innerText = "";
                var o1 = createTag("div");
                o1.style.width = "100%", o1.style.height = "100%", o1.setAttribute("data-bm-type", r1), n1.appendChild(o1), l1(o1, t1);
            }
        }, t1.resize = function() {
            var t1;
            for(t1 = 0; t1 < a1; t1 += 1)s1[t1].animation.resize();
        }, t1.goToAndStop = function(t1, e1, r1) {
            var i1;
            for(i1 = 0; i1 < a1; i1 += 1)s1[i1].animation.goToAndStop(t1, e1, r1);
        }, t1.destroy = function(t1) {
            var e1;
            for(e1 = a1 - 1; 0 <= e1; e1 -= 1)s1[e1].animation.destroy(t1);
        }, t1.freeze = function() {
            h1 = !0;
        }, t1.unfreeze = function() {
            h1 = !1, d1();
        }, t1.setVolume = function(t1, e1) {
            var r1;
            for(r1 = 0; r1 < a1; r1 += 1)s1[r1].animation.setVolume(t1, e1);
        }, t1.mute = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.mute(t1);
        }, t1.unmute = function(t1) {
            var e1;
            for(e1 = 0; e1 < a1; e1 += 1)s1[e1].animation.unmute(t1);
        }, t1.getRegisteredAnimations = function() {
            var t1, e1 = s1.length, r1 = [];
            for(t1 = 0; t1 < e1; t1 += 1)r1.push(s1[t1].animation);
            return r1;
        }, t1;
    }(), AnimationItem = function() {
        this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = subframeEnabled, this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [];
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem), AnimationItem.prototype.setParams = function(t1) {
        (t1.wrapper || t1.container) && (this.wrapper = t1.wrapper || t1.container);
        var e1 = "svg";
        switch(t1.animType ? e1 = t1.animType : t1.renderer && (e1 = t1.renderer), e1){
            case "canvas":
                this.renderer = new CanvasRenderer(this, t1.rendererSettings);
                break;
            case "svg":
                this.renderer = new SVGRenderer(this, t1.rendererSettings);
                break;
            default:
                this.renderer = new HybridRenderer(this, t1.rendererSettings);
        }
        this.imagePreloader.setCacheType(e1, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e1, "" === t1.loop || null === t1.loop || void 0 === t1.loop || !0 === t1.loop ? this.loop = !0 : !1 === t1.loop ? this.loop = !1 : this.loop = parseInt(t1.loop, 10), this.autoplay = !("autoplay" in t1) || t1.autoplay, this.name = t1.name ? t1.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t1, "autoloadSegments") || t1.autoloadSegments, this.assetsPath = t1.assetsPath, this.initialSegment = t1.initialSegment, t1.audioFactory && this.audioController.setAudioFactory(t1.audioFactory), t1.animationData ? this.configAnimation(t1.animationData) : t1.path && (-1 !== t1.path.lastIndexOf("\\") ? this.path = t1.path.substr(0, t1.path.lastIndexOf("\\") + 1) : this.path = t1.path.substr(0, t1.path.lastIndexOf("/") + 1), this.fileName = t1.path.substr(t1.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), assetLoader.load(t1.path, this.configAnimation.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this)));
    }, AnimationItem.prototype.setData = function(t1, e1) {
        e1 && "object" != typeof e1 && (e1 = JSON.parse(e1));
        var r1 = {
            wrapper: t1,
            animationData: e1
        }, i1 = t1.attributes;
        r1.path = i1.getNamedItem("data-animation-path") ? i1.getNamedItem("data-animation-path").value : i1.getNamedItem("data-bm-path") ? i1.getNamedItem("data-bm-path").value : i1.getNamedItem("bm-path") ? i1.getNamedItem("bm-path").value : "", r1.animType = i1.getNamedItem("data-anim-type") ? i1.getNamedItem("data-anim-type").value : i1.getNamedItem("data-bm-type") ? i1.getNamedItem("data-bm-type").value : i1.getNamedItem("bm-type") ? i1.getNamedItem("bm-type").value : i1.getNamedItem("data-bm-renderer") ? i1.getNamedItem("data-bm-renderer").value : i1.getNamedItem("bm-renderer") ? i1.getNamedItem("bm-renderer").value : "canvas";
        var s1 = i1.getNamedItem("data-anim-loop") ? i1.getNamedItem("data-anim-loop").value : i1.getNamedItem("data-bm-loop") ? i1.getNamedItem("data-bm-loop").value : i1.getNamedItem("bm-loop") ? i1.getNamedItem("bm-loop").value : "";
        "false" === s1 ? r1.loop = !1 : "true" === s1 ? r1.loop = !0 : "" !== s1 && (r1.loop = parseInt(s1, 10));
        var a1 = i1.getNamedItem("data-anim-autoplay") ? i1.getNamedItem("data-anim-autoplay").value : i1.getNamedItem("data-bm-autoplay") ? i1.getNamedItem("data-bm-autoplay").value : !i1.getNamedItem("bm-autoplay") || i1.getNamedItem("bm-autoplay").value;
        r1.autoplay = "false" !== a1, r1.name = i1.getNamedItem("data-name") ? i1.getNamedItem("data-name").value : i1.getNamedItem("data-bm-name") ? i1.getNamedItem("data-bm-name").value : i1.getNamedItem("bm-name") ? i1.getNamedItem("bm-name").value : "", "false" === (i1.getNamedItem("data-anim-prerender") ? i1.getNamedItem("data-anim-prerender").value : i1.getNamedItem("data-bm-prerender") ? i1.getNamedItem("data-bm-prerender").value : i1.getNamedItem("bm-prerender") ? i1.getNamedItem("bm-prerender").value : "") && (r1.prerender = !1), this.setParams(r1);
    }, AnimationItem.prototype.includeLayers = function(t1) {
        t1.op > this.animationData.op && (this.animationData.op = t1.op, this.totalFrames = Math.floor(t1.op - this.animationData.ip));
        var e1, r1, i1 = this.animationData.layers, s1 = i1.length, a1 = t1.layers, n1 = a1.length;
        for(r1 = 0; r1 < n1; r1 += 1)for(e1 = 0; e1 < s1;){
            if (i1[e1].id === a1[r1].id) {
                i1[e1] = a1[r1];
                break;
            }
            e1 += 1;
        }
        if ((t1.chars || t1.fonts) && (this.renderer.globalData.fontManager.addChars(t1.chars), this.renderer.globalData.fontManager.addFonts(t1.fonts, this.renderer.globalData.defs)), t1.assets) for(s1 = t1.assets.length, e1 = 0; e1 < s1; e1 += 1)this.animationData.assets.push(t1.assets[e1]);
        this.animationData.__complete = !1, dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.includeLayers(t1.layers), expressionsPlugin && expressionsPlugin.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
        var t1 = this.animationData.segments;
        if (!t1 || 0 === t1.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
        var e1 = t1.shift();
        this.timeCompleted = e1.time * this.frameRate;
        var r1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1, assetLoader.load(r1, this.includeLayers.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
        this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(t1) {
        if (this.renderer) try {
            this.animationData = t1, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t1), t1.assets || (t1.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t1.assets), this.markers = markerParser(t1.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t1) {
            this.triggerConfigError(t1);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
        this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
        !this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages() && (this.isLoaded = !0, dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), expressionsPlugin && expressionsPlugin.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
            this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play());
    }, AnimationItem.prototype.resize = function() {
        this.renderer.updateContainerSize();
    }, AnimationItem.prototype.setSubframe = function(t1) {
        this.isSubframeEnabled = !!t1;
    }, AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame();
    }, AnimationItem.prototype.renderFrame = function() {
        if (!1 !== this.isLoaded && this.renderer) try {
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (t1) {
            this.triggerRenderFrameError(t1);
        }
    }, AnimationItem.prototype.play = function(t1) {
        t1 && this.name !== t1 || !0 === this.isPaused && (this.isPaused = !1, this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(t1) {
        t1 && this.name !== t1 || !1 === this.isPaused && (this.isPaused = !0, this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(t1) {
        t1 && this.name !== t1 || (!0 === this.isPaused ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(t1) {
        t1 && this.name !== t1 || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(t1) {
        for(var e1, r1 = 0; r1 < this.markers.length; r1 += 1)if ((e1 = this.markers[r1]).payload && e1.payload.name === t1) return e1;
        return null;
    }, AnimationItem.prototype.goToAndStop = function(t1, e1, r1) {
        if (!r1 || this.name === r1) {
            var i1 = Number(t1);
            if (isNaN(i1)) {
                var s1 = this.getMarkerData(t1);
                s1 && this.goToAndStop(s1.time, !0);
            } else e1 ? this.setCurrentRawFrameValue(t1) : this.setCurrentRawFrameValue(t1 * this.frameModifier);
            this.pause();
        }
    }, AnimationItem.prototype.goToAndPlay = function(t1, e1, r1) {
        if (!r1 || this.name === r1) {
            var i1 = Number(t1);
            if (isNaN(i1)) {
                var s1 = this.getMarkerData(t1);
                s1 && (s1.duration ? this.playSegments([
                    s1.time,
                    s1.time + s1.duration
                ], !0) : this.goToAndStop(s1.time, !0));
            } else this.goToAndStop(i1, e1, r1);
            this.play();
        }
    }, AnimationItem.prototype.advanceTime = function(t1) {
        if (!0 !== this.isPaused && !1 !== this.isLoaded) {
            var e1 = this.currentRawFrame + t1 * this.frameModifier, r1 = !1;
            e1 >= this.totalFrames - 1 && 0 < this.frameModifier ? this.loop && this.playCount !== this.loop ? e1 >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e1 % this.totalFrames) || (this.setCurrentRawFrameValue(e1 % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e1) : this.checkSegments(e1 > this.totalFrames ? e1 % this.totalFrames : 0) || (r1 = !0, e1 = this.totalFrames - 1) : e1 < 0 ? this.checkSegments(e1 % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r1 = !0, e1 = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e1 % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e1), r1 && (this.setCurrentRawFrameValue(e1), this.pause(), this.trigger("complete"));
        }
    }, AnimationItem.prototype.adjustSegment = function(t1, e1) {
        this.playCount = 0, t1[1] < t1[0] ? (0 < this.frameModifier && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t1[0] - t1[1], this.timeCompleted = this.totalFrames, this.firstFrame = t1[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e1)) : t1[1] > t1[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t1[1] - t1[0], this.timeCompleted = this.totalFrames, this.firstFrame = t1[0], this.setCurrentRawFrameValue(.001 + e1)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(t1, e1) {
        var r1 = -1;
        this.isPaused && (this.currentRawFrame + this.firstFrame < t1 ? r1 = t1 : this.currentRawFrame + this.firstFrame > e1 && (r1 = e1 - t1)), this.firstFrame = t1, this.totalFrames = e1 - t1, this.timeCompleted = this.totalFrames, -1 !== r1 && this.goToAndStop(r1, !0);
    }, AnimationItem.prototype.playSegments = function(t1, e1) {
        if (e1 && (this.segments.length = 0), "object" == typeof t1[0]) {
            var r1, i1 = t1.length;
            for(r1 = 0; r1 < i1; r1 += 1)this.segments.push(t1[r1]);
        } else this.segments.push(t1);
        this.segments.length && e1 && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(t1) {
        this.segments.length = 0, this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]), t1 && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(t1) {
        return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t1), !0);
    }, AnimationItem.prototype.destroy = function(t1) {
        t1 && this.name !== t1 || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(t1) {
        this.currentRawFrame = t1, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(t1) {
        this.playSpeed = t1, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(t1) {
        this.playDirection = t1 < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setVolume = function(t1, e1) {
        e1 && this.name !== e1 || this.audioController.setVolume(t1);
    }, AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(t1) {
        t1 && this.name !== t1 || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(t1) {
        t1 && this.name !== t1 || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
        return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(t1) {
        var e1 = "";
        if (t1.e) e1 = t1.p;
        else if (this.assetsPath) {
            var r1 = t1.p;
            -1 !== r1.indexOf("images/") && (r1 = r1.split("/")[1]), e1 = this.assetsPath + r1;
        } else e1 = this.path, e1 += t1.u ? t1.u : "", e1 += t1.p;
        return e1;
    }, AnimationItem.prototype.getAssetData = function(t1) {
        for(var e1 = 0, r1 = this.assets.length; e1 < r1;){
            if (t1 === this.assets[e1].id) return this.assets[e1];
            e1 += 1;
        }
        return null;
    }, AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
        this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(t1) {
        return t1 ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.trigger = function(t1) {
        if (this._cbs && this._cbs[t1]) switch(t1){
            case "enterFrame":
                this.triggerEvent(t1, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case "loopComplete":
                this.triggerEvent(t1, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult));
                break;
            case "complete":
                this.triggerEvent(t1, new BMCompleteEvent(t1, this.frameMult));
                break;
            case "segmentStart":
                this.triggerEvent(t1, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames));
                break;
            case "destroy":
                this.triggerEvent(t1, new BMDestroyEvent(t1, this));
                break;
            default:
                this.triggerEvent(t1);
        }
        "enterFrame" === t1 && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t1, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t1 && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t1, this.loop, this.playCount, this.frameMult)), "complete" === t1 && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t1, this.frameMult)), "segmentStart" === t1 && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t1, this.firstFrame, this.totalFrames)), "destroy" === t1 && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t1, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(t1) {
        var e1 = new BMRenderFrameErrorEvent(t1, this.currentFrame);
        this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
    }, AnimationItem.prototype.triggerConfigError = function(t1) {
        var e1 = new BMConfigErrorEvent(t1, this.currentFrame);
        this.triggerEvent("error", e1), this.onError && this.onError.call(this, e1);
    };
    var Expressions = (tY = {}, tY.initExpressions = function(t1) {
        var e1 = 0, r1 = [];
        function i1() {
            var t1, e1 = r1.length;
            for(t1 = 0; t1 < e1; t1 += 1)r1[t1].release();
            r1.length = 0;
        }
        t1.renderer.compInterface = CompExpressionInterface(t1.renderer), t1.renderer.globalData.projectInterface.registerComposition(t1.renderer), t1.renderer.globalData.pushExpression = function() {
            e1 += 1;
        }, t1.renderer.globalData.popExpression = function() {
            0 == (e1 -= 1) && i1();
        }, t1.renderer.globalData.registerExpressionProperty = function(t1) {
            -1 === r1.indexOf(t1) && r1.push(t1);
        };
    }, tY), tY;
    expressionsPlugin = Expressions;
    var ExpressionManager = function() {
        var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null;
        function $bm_isInstanceOfArray(t1) {
            return t1.constructor === Array || t1.constructor === Float32Array;
        }
        function isNumerable(t1, e1) {
            return "number" === t1 || "boolean" === t1 || "string" === t1 || e1 instanceof Number;
        }
        function $bm_neg(t1) {
            var e1 = typeof t1;
            if ("number" === e1 || "boolean" === e1 || t1 instanceof Number) return -t1;
            if ($bm_isInstanceOfArray(t1)) {
                var r1, i1 = t1.length, s1 = [];
                for(r1 = 0; r1 < i1; r1 += 1)s1[r1] = -t1[r1];
                return s1;
            }
            return t1.propType ? t1.v : -t1;
        }
        var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
        function sum(t1, e1) {
            var r1 = typeof t1, i1 = typeof e1;
            if ("string" === r1 || "string" === i1) return t1 + e1;
            if (isNumerable(r1, t1) && isNumerable(i1, e1)) return t1 + e1;
            if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] += e1, t1;
            if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 + e1[0], e1;
            if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                for(var s1 = 0, a1 = t1.length, n1 = e1.length, o1 = []; s1 < a1 || s1 < n1;)("number" == typeof t1[s1] || t1[s1] instanceof Number) && ("number" == typeof e1[s1] || e1[s1] instanceof Number) ? o1[s1] = t1[s1] + e1[s1] : o1[s1] = void 0 === e1[s1] ? t1[s1] : t1[s1] || e1[s1], s1 += 1;
                return o1;
            }
            return 0;
        }
        var add = sum;
        function sub(t1, e1) {
            var r1 = typeof t1, i1 = typeof e1;
            if (isNumerable(r1, t1) && isNumerable(i1, e1)) return "string" === r1 && (t1 = parseInt(t1, 10)), "string" === i1 && (e1 = parseInt(e1, 10)), t1 - e1;
            if ($bm_isInstanceOfArray(t1) && isNumerable(i1, e1)) return (t1 = t1.slice(0))[0] -= e1, t1;
            if (isNumerable(r1, t1) && $bm_isInstanceOfArray(e1)) return (e1 = e1.slice(0))[0] = t1 - e1[0], e1;
            if ($bm_isInstanceOfArray(t1) && $bm_isInstanceOfArray(e1)) {
                for(var s1 = 0, a1 = t1.length, n1 = e1.length, o1 = []; s1 < a1 || s1 < n1;)("number" == typeof t1[s1] || t1[s1] instanceof Number) && ("number" == typeof e1[s1] || e1[s1] instanceof Number) ? o1[s1] = t1[s1] - e1[s1] : o1[s1] = void 0 === e1[s1] ? t1[s1] : t1[s1] || e1[s1], s1 += 1;
                return o1;
            }
            return 0;
        }
        function mul(t1, e1) {
            var r1, i1, s1, a1 = typeof t1, n1 = typeof e1;
            if (isNumerable(a1, t1) && isNumerable(n1, e1)) return t1 * e1;
            if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                for(s1 = t1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1[i1] * e1;
                return r1;
            }
            if (isNumerable(a1, t1) && $bm_isInstanceOfArray(e1)) {
                for(s1 = e1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1 * e1[i1];
                return r1;
            }
            return 0;
        }
        function div(t1, e1) {
            var r1, i1, s1, a1 = typeof t1, n1 = typeof e1;
            if (isNumerable(a1, t1) && isNumerable(n1, e1)) return t1 / e1;
            if ($bm_isInstanceOfArray(t1) && isNumerable(n1, e1)) {
                for(s1 = t1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1[i1] / e1;
                return r1;
            }
            if (isNumerable(a1, t1) && $bm_isInstanceOfArray(e1)) {
                for(s1 = e1.length, r1 = createTypedArray("float32", s1), i1 = 0; i1 < s1; i1 += 1)r1[i1] = t1 / e1[i1];
                return r1;
            }
            return 0;
        }
        function mod(t1, e1) {
            return "string" == typeof t1 && (t1 = parseInt(t1, 10)), "string" == typeof e1 && (e1 = parseInt(e1, 10)), t1 % e1;
        }
        var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
        function clamp(t1, e1, r1) {
            if (r1 < e1) {
                var i1 = r1;
                r1 = e1, e1 = i1;
            }
            return Math.min(Math.max(t1, e1), r1);
        }
        function radiansToDegrees(t1) {
            return t1 / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(t1) {
            return t1 * degToRads;
        }
        var degrees_to_radians = radiansToDegrees, helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(t1, e1) {
            if ("number" == typeof t1 || t1 instanceof Number) return e1 = e1 || 0, Math.abs(t1 - e1);
            var r1;
            e1 || (e1 = helperLengthArray);
            var i1 = Math.min(t1.length, e1.length), s1 = 0;
            for(r1 = 0; r1 < i1; r1 += 1)s1 += Math.pow(e1[r1] - t1[r1], 2);
            return Math.sqrt(s1);
        }
        function normalize(t1) {
            return div(t1, length(t1));
        }
        function rgbToHsl(t1) {
            var e1, r1, i1 = t1[0], s1 = t1[1], a1 = t1[2], n1 = Math.max(i1, s1, a1), o1 = Math.min(i1, s1, a1), h1 = (n1 + o1) / 2;
            if (n1 === o1) r1 = e1 = 0;
            else {
                var l1 = n1 - o1;
                switch(r1 = .5 < h1 ? l1 / (2 - n1 - o1) : l1 / (n1 + o1), n1){
                    case i1:
                        e1 = (s1 - a1) / l1 + (s1 < a1 ? 6 : 0);
                        break;
                    case s1:
                        e1 = (a1 - i1) / l1 + 2;
                        break;
                    case a1:
                        e1 = (i1 - s1) / l1 + 4;
                }
                e1 /= 6;
            }
            return [
                e1,
                r1,
                h1,
                t1[3]
            ];
        }
        function hue2rgb(t1, e1, r1) {
            return r1 < 0 && (r1 += 1), 1 < r1 && (r1 -= 1), r1 < 1 / 6 ? t1 + 6 * (e1 - t1) * r1 : r1 < .5 ? e1 : r1 < 2 / 3 ? t1 + (e1 - t1) * (2 / 3 - r1) * 6 : t1;
        }
        function hslToRgb(t1) {
            var e1, r1, i1, s1 = t1[0], a1 = t1[1], n1 = t1[2];
            if (0 === a1) r1 = i1 = e1 = n1;
            else {
                var o1 = n1 < .5 ? n1 * (1 + a1) : n1 + a1 - n1 * a1, h1 = 2 * n1 - o1;
                e1 = hue2rgb(h1, o1, s1 + 1 / 3), r1 = hue2rgb(h1, o1, s1), i1 = hue2rgb(h1, o1, s1 - 1 / 3);
            }
            return [
                e1,
                r1,
                i1,
                t1[3]
            ];
        }
        function linear(t1, e1, r1, i1, s1) {
            if (void 0 !== i1 && void 0 !== s1 || (i1 = e1, s1 = r1, e1 = 0, r1 = 1), r1 < e1) {
                var a1 = r1;
                r1 = e1, e1 = a1;
            }
            if (t1 <= e1) return i1;
            if (r1 <= t1) return s1;
            var n1, o1 = r1 === e1 ? 0 : (t1 - e1) / (r1 - e1);
            if (!i1.length) return i1 + (s1 - i1) * o1;
            var h1 = i1.length, l1 = createTypedArray("float32", h1);
            for(n1 = 0; n1 < h1; n1 += 1)l1[n1] = i1[n1] + (s1[n1] - i1[n1]) * o1;
            return l1;
        }
        function random(t1, e1) {
            if (void 0 === e1 && (void 0 === t1 ? (t1 = 0, e1 = 1) : (e1 = t1, t1 = void 0)), e1.length) {
                var r1, i1 = e1.length;
                t1 || (t1 = createTypedArray("float32", i1));
                var s1 = createTypedArray("float32", i1), a1 = BMMath.random();
                for(r1 = 0; r1 < i1; r1 += 1)s1[r1] = t1[r1] + a1 * (e1[r1] - t1[r1]);
                return s1;
            }
            return void 0 === t1 && (t1 = 0), t1 + BMMath.random() * (e1 - t1);
        }
        function createPath(t1, e1, r1, i1) {
            var s1, a1 = t1.length, n1 = shapePool.newElement();
            n1.setPathData(!!i1, a1);
            var o1, h1, l1 = [
                0,
                0
            ];
            for(s1 = 0; s1 < a1; s1 += 1)o1 = e1 && e1[s1] ? e1[s1] : l1, h1 = r1 && r1[s1] ? r1[s1] : l1, n1.setTripleAt(t1[s1][0], t1[s1][1], h1[0] + t1[s1][0], h1[1] + t1[s1][1], o1[0] + t1[s1][0], o1[1] + t1[s1][1], s1, !0);
            return n1;
        }
        function initiateExpression(elem, data, property) {
            var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                get: function() {
                    return thisProperty.v;
                }
            }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t1, e1) {
                var r1, i1, s1 = this.pv.length ? this.pv.length : 1, a1 = createTypedArray("float32", s1);
                var n1 = Math.floor(5 * time);
                for(i1 = r1 = 0; r1 < n1;){
                    for(i1 = 0; i1 < s1; i1 += 1)a1[i1] += -e1 + 2 * e1 * BMMath.random();
                    r1 += 1;
                }
                var o1 = 5 * time, h1 = o1 - Math.floor(o1), l1 = createTypedArray("float32", s1);
                if (1 < s1) {
                    for(i1 = 0; i1 < s1; i1 += 1)l1[i1] = this.pv[i1] + a1[i1] + (-e1 + 2 * e1 * BMMath.random()) * h1;
                    return l1;
                }
                return this.pv + a1[0] + (-e1 + 2 * e1 * BMMath.random()) * h1;
            }).bind(this);
            function loopInDuration(t1, e1) {
                return loopIn(t1, e1, !0);
            }
            function loopOutDuration(t1, e1) {
                return loopOut(t1, e1, !0);
            }
            thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
            function lookAt(t1, e1) {
                var r1 = [
                    e1[0] - t1[0],
                    e1[1] - t1[1],
                    e1[2] - t1[2]
                ], i1 = Math.atan2(r1[0], Math.sqrt(r1[1] * r1[1] + r1[2] * r1[2])) / degToRads;
                return [
                    -Math.atan2(r1[1], r1[2]) / degToRads,
                    i1,
                    0
                ];
            }
            function easeOut(t1, e1, r1, i1, s1) {
                return applyEase(easeOutBez, t1, e1, r1, i1, s1);
            }
            function easeIn(t1, e1, r1, i1, s1) {
                return applyEase(easeInBez, t1, e1, r1, i1, s1);
            }
            function ease(t1, e1, r1, i1, s1) {
                return applyEase(easeInOutBez, t1, e1, r1, i1, s1);
            }
            function applyEase(t1, e1, r1, i1, s1, a1) {
                void 0 === s1 ? (s1 = r1, a1 = i1) : e1 = (e1 - r1) / (i1 - r1), 1 < e1 ? e1 = 1 : e1 < 0 && (e1 = 0);
                var n1 = t1(e1);
                if ($bm_isInstanceOfArray(s1)) {
                    var o1, h1 = s1.length, l1 = createTypedArray("float32", h1);
                    for(o1 = 0; o1 < h1; o1 += 1)l1[o1] = (a1[o1] - s1[o1]) * n1 + s1[o1];
                    return l1;
                }
                return (a1 - s1) * n1 + s1;
            }
            function nearestKey(t1) {
                var e1, r1, i1, s1 = data.k.length;
                if (data.k.length && "number" != typeof data.k[0]) {
                    if (r1 = -1, (t1 *= elem.comp.globalData.frameRate) < data.k[0].t) r1 = 1, i1 = data.k[0].t;
                    else {
                        for(e1 = 0; e1 < s1 - 1; e1 += 1){
                            if (t1 === data.k[e1].t) {
                                r1 = e1 + 1, i1 = data.k[e1].t;
                                break;
                            }
                            if (t1 > data.k[e1].t && t1 < data.k[e1 + 1].t) {
                                i1 = t1 - data.k[e1].t > data.k[e1 + 1].t - t1 ? (r1 = e1 + 2, data.k[e1 + 1].t) : (r1 = e1 + 1, data.k[e1].t);
                                break;
                            }
                        }
                        -1 === r1 && (r1 = e1 + 1, i1 = data.k[e1].t);
                    }
                } else i1 = r1 = 0;
                var a1 = {};
                return a1.index = r1, a1.time = i1 / elem.comp.globalData.frameRate, a1;
            }
            function key(t1) {
                var e1, r1, i1;
                if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t1);
                t1 -= 1, e1 = {
                    time: data.k[t1].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var s1 = Object.prototype.hasOwnProperty.call(data.k[t1], "s") ? data.k[t1].s : data.k[t1 - 1].e;
                for(i1 = s1.length, r1 = 0; r1 < i1; r1 += 1)e1[r1] = s1[r1], e1.value[r1] = s1[r1];
                return e1;
            }
            function framesToTime(t1, e1) {
                return e1 || (e1 = elem.comp.globalData.frameRate), t1 / e1;
            }
            function timeToFrames(t1, e1) {
                return t1 || 0 === t1 || (t1 = time), e1 || (e1 = elem.comp.globalData.frameRate), t1 * e1;
            }
            function seedRandom(t1) {
                BMMath.seedrandom(randSeed + t1);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(t1, e1) {
                return "string" == typeof value ? void 0 === e1 ? value.substring(t1) : value.substring(t1, e1) : "";
            }
            function substr(t1, e1) {
                return "string" == typeof value ? void 0 === e1 ? value.substr(t1) : value.substr(t1, e1) : "";
            }
            function posterizeTime(t1) {
                time = 0 === t1 ? 0 : Math.floor(time * t1) / t1, value = valueAtTime(time);
            }
            var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math.floor(1e6 * Math.random()), globalData = elem.globalData;
            function executeExpression(t1) {
                return value = t1, _needsRandom && seedRandom(randSeed), this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), ($bm_transform = transform) && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, "shape" === scoped_bm_rt.propType && (scoped_bm_rt = scoped_bm_rt.v), scoped_bm_rt);
            }
            return executeExpression;
        }
        return ob.initiateExpression = initiateExpression, ob;
    }(), expressionHelpers = {
        searchExpressions: function(t1, e1, r1) {
            e1.x && (r1.k = !0, r1.x = !0, r1.initiateExpression = ExpressionManager.initiateExpression, r1.effectsSequence.push(r1.initiateExpression(t1, e1, r1).bind(r1)));
        },
        getSpeedAtTime: function(t1) {
            var e1 = this.getValueAtTime(t1), r1 = this.getValueAtTime(t1 + -0.01), i1 = 0;
            if (e1.length) {
                var s1;
                for(s1 = 0; s1 < e1.length; s1 += 1)i1 += Math.pow(r1[s1] - e1[s1], 2);
                i1 = 100 * Math.sqrt(i1);
            } else i1 = 0;
            return i1;
        },
        getVelocityAtTime: function(t1) {
            if (void 0 !== this.vel) return this.vel;
            var e1, r1, i1 = this.getValueAtTime(t1), s1 = this.getValueAtTime(t1 + -0.001);
            if (i1.length) for(e1 = createTypedArray("float32", i1.length), r1 = 0; r1 < i1.length; r1 += 1)e1[r1] = (s1[r1] - i1[r1]) / -0.001;
            else e1 = (s1 - i1) / -0.001;
            return e1;
        },
        getValueAtTime: function(t1) {
            return t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t1 ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t1, this._cachingAtTime), this._cachingAtTime.lastFrame = t1), this._cachingAtTime.value;
        },
        getStaticValueAtTime: function() {
            return this.pv;
        },
        setGroupProperty: function(t1) {
            this.propertyGroup = t1;
        }
    };
    !function() {
        function o1(t1, e1, r1) {
            if (!this.k || !this.keyframes) return this.pv;
            t1 = t1 ? t1.toLowerCase() : "";
            var i1, s1, a1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[l1.length - 1].t;
            if (h1 <= p1) return this.pv;
            if (r1 ? s1 = p1 - (i1 = e1 ? Math.abs(p1 - this.elem.comp.globalData.frameRate * e1) : Math.max(0, p1 - this.elem.data.ip)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = p1 - (s1 = l1[l1.length - 1 - e1].t)), "pingpong" === t1) {
                if (Math.floor((h1 - s1) / i1) % 2 != 0) return this.getValueAtTime((i1 - (h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0);
            } else {
                if ("offset" === t1) {
                    var m1 = this.getValueAtTime(s1 / this.comp.globalData.frameRate, 0), f1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime(((h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0), d1 = Math.floor((h1 - s1) / i1);
                    if (this.pv.length) {
                        for(n1 = (o1 = new Array(m1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = (f1[a1] - m1[a1]) * d1 + c1[a1];
                        return o1;
                    }
                    return (f1 - m1) * d1 + c1;
                }
                if ("continue" === t1) {
                    var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 - .001) / this.comp.globalData.frameRate, 0);
                    if (this.pv.length) {
                        for(n1 = (o1 = new Array(u1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = u1[a1] + (u1[a1] - y1[a1]) * ((h1 - p1) / this.comp.globalData.frameRate) / 5e-4;
                        return o1;
                    }
                    return u1 + (h1 - p1) / .001 * (u1 - y1);
                }
            }
            return this.getValueAtTime(((h1 - s1) % i1 + s1) / this.comp.globalData.frameRate, 0);
        }
        function h1(t1, e1, r1) {
            if (!this.k) return this.pv;
            t1 = t1 ? t1.toLowerCase() : "";
            var i1, s1, a1, n1, o1, h1 = this.comp.renderedFrame, l1 = this.keyframes, p1 = l1[0].t;
            if (p1 <= h1) return this.pv;
            if (r1 ? s1 = p1 + (i1 = e1 ? Math.abs(this.elem.comp.globalData.frameRate * e1) : Math.max(0, this.elem.data.op - p1)) : ((!e1 || e1 > l1.length - 1) && (e1 = l1.length - 1), i1 = (s1 = l1[e1].t) - p1), "pingpong" === t1) {
                if (Math.floor((p1 - h1) / i1) % 2 == 0) return this.getValueAtTime(((p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0);
            } else {
                if ("offset" === t1) {
                    var m1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), f1 = this.getValueAtTime(s1 / this.comp.globalData.frameRate, 0), c1 = this.getValueAtTime((i1 - (p1 - h1) % i1 + p1) / this.comp.globalData.frameRate, 0), d1 = Math.floor((p1 - h1) / i1) + 1;
                    if (this.pv.length) {
                        for(n1 = (o1 = new Array(m1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = c1[a1] - (f1[a1] - m1[a1]) * d1;
                        return o1;
                    }
                    return c1 - (f1 - m1) * d1;
                }
                if ("continue" === t1) {
                    var u1 = this.getValueAtTime(p1 / this.comp.globalData.frameRate, 0), y1 = this.getValueAtTime((p1 + .001) / this.comp.globalData.frameRate, 0);
                    if (this.pv.length) {
                        for(n1 = (o1 = new Array(u1.length)).length, a1 = 0; a1 < n1; a1 += 1)o1[a1] = u1[a1] + (u1[a1] - y1[a1]) * (p1 - h1) / .001;
                        return o1;
                    }
                    return u1 + (u1 - y1) * (p1 - h1) / .001;
                }
            }
            return this.getValueAtTime((i1 - ((p1 - h1) % i1 + p1)) / this.comp.globalData.frameRate, 0);
        }
        function l1(t1, e1) {
            if (!this.k) return this.pv;
            if (t1 = .5 * (t1 || .4), (e1 = Math.floor(e1 || 5)) <= 1) return this.pv;
            var r1, i1, s1 = this.comp.renderedFrame / this.comp.globalData.frameRate, a1 = s1 - t1, n1 = 1 < e1 ? (s1 + t1 - a1) / (e1 - 1) : 1, o1 = 0, h1 = 0;
            for(r1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o1 < e1;){
                if (i1 = this.getValueAtTime(a1 + o1 * n1), this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] += i1[h1];
                else r1 += i1;
                o1 += 1;
            }
            if (this.pv.length) for(h1 = 0; h1 < this.pv.length; h1 += 1)r1[h1] /= e1;
            else r1 /= e1;
            return r1;
        }
        var s1 = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(t1, e1, r1) {
            var i1 = s1(t1, e1, r1);
            return i1.dynamicProperties.length ? i1.getValueAtTime = (function(t1) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e1 = this._transformCachingAtTime.v;
                if (e1.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r1 = this.a.getValueAtTime(t1);
                    e1.translate(-r1[0] * this.a.mult, -r1[1] * this.a.mult, r1[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i1 = this.s.getValueAtTime(t1);
                    e1.scale(i1[0] * this.s.mult, i1[1] * this.s.mult, i1[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var s1 = this.sk.getValueAtTime(t1), a1 = this.sa.getValueAtTime(t1);
                    e1.skewFromAxis(-s1 * this.sk.mult, a1 * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n1 = this.r.getValueAtTime(t1);
                    e1.rotate(-n1 * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o1 = this.rz.getValueAtTime(t1), h1 = this.ry.getValueAtTime(t1), l1 = this.rx.getValueAtTime(t1), p1 = this.or.getValueAtTime(t1);
                    e1.rotateZ(-o1 * this.rz.mult).rotateY(h1 * this.ry.mult).rotateX(l1 * this.rx.mult).rotateZ(-p1[2] * this.or.mult).rotateY(p1[1] * this.or.mult).rotateX(p1[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var m1 = this.px.getValueAtTime(t1), f1 = this.py.getValueAtTime(t1);
                    if (this.data.p.z) {
                        var c1 = this.pz.getValueAtTime(t1);
                        e1.translate(m1 * this.px.mult, f1 * this.py.mult, -c1 * this.pz.mult);
                    } else e1.translate(m1 * this.px.mult, f1 * this.py.mult, 0);
                } else {
                    var d1 = this.p.getValueAtTime(t1);
                    e1.translate(d1[0] * this.p.mult, d1[1] * this.p.mult, -d1[2] * this.p.mult);
                }
                return e1;
            }).bind(i1) : i1.getValueAtTime = (function() {
                return this.v.clone(new Matrix);
            }).bind(i1), i1.setGroupProperty = expressionHelpers.setGroupProperty, i1;
        };
        var p1 = PropertyFactory.getProp;
        PropertyFactory.getProp = function(t1, e1, r1, i1, s1) {
            var a1 = p1(t1, e1, r1, i1, s1);
            a1.kf ? a1.getValueAtTime = expressionHelpers.getValueAtTime.bind(a1) : a1.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(a1), a1.setGroupProperty = expressionHelpers.setGroupProperty, a1.loopOut = o1, a1.loopIn = h1, a1.smooth = l1, a1.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(a1), a1.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(a1), a1.numKeys = 1 === e1.a ? e1.k.length : 0, a1.propertyIndex = e1.ix;
            var n1 = 0;
            return 0 !== r1 && (n1 = createTypedArray("float32", 1 === e1.a ? e1.k[0].s.length : e1.k.length)), a1._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: n1
            }, expressionHelpers.searchExpressions(t1, e1, a1), a1.k && s1.addDynamicProperty(a1), a1;
        };
        var t1 = ShapePropertyFactory.getConstructorFunction(), e1 = ShapePropertyFactory.getKeyframedConstructorFunction();
        function r1() {}
        r1.prototype = {
            vertices: function(t1, e1) {
                this.k && this.getValue();
                var r1, i1 = this.v;
                void 0 !== e1 && (i1 = this.getValueAtTime(e1, 0));
                var s1 = i1._length, a1 = i1[t1], n1 = i1.v, o1 = createSizedArray(s1);
                for(r1 = 0; r1 < s1; r1 += 1)o1[r1] = "i" === t1 || "o" === t1 ? [
                    a1[r1][0] - n1[r1][0],
                    a1[r1][1] - n1[r1][1]
                ] : [
                    a1[r1][0],
                    a1[r1][1]
                ];
                return o1;
            },
            points: function(t1) {
                return this.vertices("v", t1);
            },
            inTangents: function(t1) {
                return this.vertices("i", t1);
            },
            outTangents: function(t1) {
                return this.vertices("o", t1);
            },
            isClosed: function() {
                return this.v.c;
            },
            pointOnPath: function(t1, e1) {
                var r1 = this.v;
                void 0 !== e1 && (r1 = this.getValueAtTime(e1, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r1));
                for(var i1, s1 = this._segmentsLength, a1 = s1.lengths, n1 = s1.totalLength * t1, o1 = 0, h1 = a1.length, l1 = 0; o1 < h1;){
                    if (l1 + a1[o1].addedLength > n1) {
                        var p1 = o1, m1 = r1.c && o1 === h1 - 1 ? 0 : o1 + 1, f1 = (n1 - l1) / a1[o1].addedLength;
                        i1 = bez.getPointInSegment(r1.v[p1], r1.v[m1], r1.o[p1], r1.i[m1], f1, a1[o1]);
                        break;
                    }
                    l1 += a1[o1].addedLength, o1 += 1;
                }
                return i1 || (i1 = r1.c ? [
                    r1.v[0][0],
                    r1.v[0][1]
                ] : [
                    r1.v[r1._length - 1][0],
                    r1.v[r1._length - 1][1]
                ]), i1;
            },
            vectorOnPath: function(t1, e1, r1) {
                1 == t1 ? t1 = this.v.c : 0 == t1 && (t1 = .999);
                var i1 = this.pointOnPath(t1, e1), s1 = this.pointOnPath(t1 + .001, e1), a1 = s1[0] - i1[0], n1 = s1[1] - i1[1], o1 = Math.sqrt(Math.pow(a1, 2) + Math.pow(n1, 2));
                return 0 === o1 ? [
                    0,
                    0
                ] : "tangent" === r1 ? [
                    a1 / o1,
                    n1 / o1
                ] : [
                    -n1 / o1,
                    a1 / o1
                ];
            },
            tangentOnPath: function(t1, e1) {
                return this.vectorOnPath(t1, e1, "tangent");
            },
            normalOnPath: function(t1, e1) {
                return this.vectorOnPath(t1, e1, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        }, extendPrototype([
            r1
        ], t1), extendPrototype([
            r1
        ], e1), e1.prototype.getValueAtTime = function(t1) {
            return this._cachingAtTime || (this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            }), t1 *= this.elem.globalData.frameRate, (t1 -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t1 ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t1, this.interpolateShape(t1, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
        }, e1.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var n1 = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(t1, e1, r1, i1, s1) {
            var a1 = n1(t1, e1, r1, i1, s1);
            return a1.propertyIndex = e1.ix, a1.lock = !1, 3 === r1 ? expressionHelpers.searchExpressions(t1, e1.pt, a1) : 4 === r1 && expressionHelpers.searchExpressions(t1, e1.ks, a1), a1.k && t1.addDynamicProperty(a1), a1;
        };
    }(), TextProperty.prototype.getExpressionValue = function(t1, e1) {
        var r1 = this.calculateExpression(e1);
        if (t1.t === r1) return t1;
        var i1 = {};
        return this.copyData(i1, t1), i1.t = r1.toString(), i1.__complete = !1, i1;
    }, TextProperty.prototype.searchProperty = function() {
        var t1 = this.searchKeyframes(), e1 = this.searchExpressions();
        return this.kf = t1 || e1, this.kf;
    }, TextProperty.prototype.searchExpressions = function() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
    };
    var ShapePathInterface = function(t1, e1, r1) {
        var i1 = e1.sh;
        function s1(t1) {
            return "Shape" === t1 || "shape" === t1 || "Path" === t1 || "path" === t1 || "ADBE Vector Shape" === t1 || 2 === t1 ? s1.path : null;
        }
        var a1 = propertyGroupFactory(s1, r1);
        return i1.setGroupProperty(PropertyInterface("Path", a1)), Object.defineProperties(s1, {
            path: {
                get: function() {
                    return i1.k && i1.getValue(), i1;
                }
            },
            shape: {
                get: function() {
                    return i1.k && i1.getValue(), i1;
                }
            },
            _name: {
                value: t1.nm
            },
            ix: {
                value: t1.ix
            },
            propertyIndex: {
                value: t1.ix
            },
            mn: {
                value: t1.mn
            },
            propertyGroup: {
                value: r1
            }
        }), s1;
    }, propertyGroupFactory = function(e1, r1) {
        return function(t1) {
            return (t1 = void 0 === t1 ? 1 : t1) <= 0 ? e1 : r1(t1 - 1);
        };
    }, PropertyInterface = function(t1, e1) {
        var r1 = {
            _name: t1
        };
        return function(t1) {
            return (t1 = void 0 === t1 ? 1 : t1) <= 0 ? r1 : e1(t1 - 1);
        };
    }, ShapeExpressionInterface = function() {
        function n1(t1, e1, r1) {
            var i1, s1 = [], a1 = t1 ? t1.length : 0;
            for(i1 = 0; i1 < a1; i1 += 1)"gr" === t1[i1].ty ? s1.push(o1(t1[i1], e1[i1], r1)) : "fl" === t1[i1].ty ? s1.push(h1(t1[i1], e1[i1], r1)) : "st" === t1[i1].ty ? s1.push(m1(t1[i1], e1[i1], r1)) : "tm" === t1[i1].ty ? s1.push(f1(t1[i1], e1[i1], r1)) : "tr" === t1[i1].ty || ("el" === t1[i1].ty ? s1.push(d1(t1[i1], e1[i1], r1)) : "sr" === t1[i1].ty ? s1.push(u1(t1[i1], e1[i1], r1)) : "sh" === t1[i1].ty ? s1.push(ShapePathInterface(t1[i1], e1[i1], r1)) : "rc" === t1[i1].ty ? s1.push(y1(t1[i1], e1[i1], r1)) : "rd" === t1[i1].ty ? s1.push(g1(t1[i1], e1[i1], r1)) : "rp" === t1[i1].ty ? s1.push(v1(t1[i1], e1[i1], r1)) : "gf" === t1[i1].ty ? s1.push(l1(t1[i1], e1[i1], r1)) : s1.push(p1(t1[i1], e1[i1])));
            return s1;
        }
        function o1(t1, e1, r1) {
            var i1 = function(t1) {
                switch(t1){
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return i1.content;
                    default:
                        return i1.transform;
                }
            };
            i1.propertyGroup = propertyGroupFactory(i1, r1);
            var s1 = function(t1, e1, r1) {
                var i1, s1 = function(t1) {
                    for(var e1 = 0, r1 = i1.length; e1 < r1;){
                        if (i1[e1]._name === t1 || i1[e1].mn === t1 || i1[e1].propertyIndex === t1 || i1[e1].ix === t1 || i1[e1].ind === t1) return i1[e1];
                        e1 += 1;
                    }
                    return "number" == typeof t1 ? i1[t1 - 1] : null;
                };
                s1.propertyGroup = propertyGroupFactory(s1, r1), i1 = n1(t1.it, e1.it, s1.propertyGroup), s1.numProperties = i1.length;
                var a1 = c1(t1.it[t1.it.length - 1], e1.it[e1.it.length - 1], s1.propertyGroup);
                return s1.transform = a1, s1.propertyIndex = t1.cix, s1._name = t1.nm, s1;
            }(t1, e1, i1.propertyGroup), a1 = c1(t1.it[t1.it.length - 1], e1.it[e1.it.length - 1], i1.propertyGroup);
            return i1.content = s1, i1.transform = a1, Object.defineProperty(i1, "_name", {
                get: function() {
                    return t1.nm;
                }
            }), i1.numProperties = t1.np, i1.propertyIndex = t1.ix, i1.nm = t1.nm, i1.mn = t1.mn, i1;
        }
        function h1(t1, e1, r1) {
            function i1(t1) {
                return "Color" === t1 || "color" === t1 ? i1.color : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
            }
            return Object.defineProperties(i1, {
                color: {
                    get: ExpressionPropertyInterface(e1.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(e1.o)
                },
                _name: {
                    value: t1.nm
                },
                mn: {
                    value: t1.mn
                }
            }), e1.c.setGroupProperty(PropertyInterface("Color", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
        }
        function l1(t1, e1, r1) {
            function i1(t1) {
                return "Start Point" === t1 || "start point" === t1 ? i1.startPoint : "End Point" === t1 || "end point" === t1 ? i1.endPoint : "Opacity" === t1 || "opacity" === t1 ? i1.opacity : null;
            }
            return Object.defineProperties(i1, {
                startPoint: {
                    get: ExpressionPropertyInterface(e1.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(e1.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(e1.o)
                },
                type: {
                    get: function() {
                        return "a";
                    }
                },
                _name: {
                    value: t1.nm
                },
                mn: {
                    value: t1.mn
                }
            }), e1.s.setGroupProperty(PropertyInterface("Start Point", r1)), e1.e.setGroupProperty(PropertyInterface("End Point", r1)), e1.o.setGroupProperty(PropertyInterface("Opacity", r1)), i1;
        }
        function p1() {
            return function() {
                return null;
            };
        }
        function m1(t1, e1, r1) {
            var i1, s1 = propertyGroupFactory(l1, r1), a1 = propertyGroupFactory(h1, s1);
            var n1, o1 = t1.d ? t1.d.length : 0, h1 = {};
            for(i1 = 0; i1 < o1; i1 += 1)n1 = i1, Object.defineProperty(h1, t1.d[n1].nm, {
                get: ExpressionPropertyInterface(e1.d.dataProps[n1].p)
            }), e1.d.dataProps[i1].p.setGroupProperty(a1);
            function l1(t1) {
                return "Color" === t1 || "color" === t1 ? l1.color : "Opacity" === t1 || "opacity" === t1 ? l1.opacity : "Stroke Width" === t1 || "stroke width" === t1 ? l1.strokeWidth : null;
            }
            return Object.defineProperties(l1, {
                color: {
                    get: ExpressionPropertyInterface(e1.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(e1.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(e1.w)
                },
                dash: {
                    get: function() {
                        return h1;
                    }
                },
                _name: {
                    value: t1.nm
                },
                mn: {
                    value: t1.mn
                }
            }), e1.c.setGroupProperty(PropertyInterface("Color", s1)), e1.o.setGroupProperty(PropertyInterface("Opacity", s1)), e1.w.setGroupProperty(PropertyInterface("Stroke Width", s1)), l1;
        }
        function f1(e1, t1, r1) {
            function i1(t1) {
                return t1 === e1.e.ix || "End" === t1 || "end" === t1 ? i1.end : t1 === e1.s.ix ? i1.start : t1 === e1.o.ix ? i1.offset : null;
            }
            var s1 = propertyGroupFactory(i1, r1);
            return i1.propertyIndex = e1.ix, t1.s.setGroupProperty(PropertyInterface("Start", s1)), t1.e.setGroupProperty(PropertyInterface("End", s1)), t1.o.setGroupProperty(PropertyInterface("Offset", s1)), i1.propertyIndex = e1.ix, i1.propertyGroup = r1, Object.defineProperties(i1, {
                start: {
                    get: ExpressionPropertyInterface(t1.s)
                },
                end: {
                    get: ExpressionPropertyInterface(t1.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(t1.o)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        function c1(e1, t1, r1) {
            function i1(t1) {
                return e1.a.ix === t1 || "Anchor Point" === t1 ? i1.anchorPoint : e1.o.ix === t1 || "Opacity" === t1 ? i1.opacity : e1.p.ix === t1 || "Position" === t1 ? i1.position : e1.r.ix === t1 || "Rotation" === t1 || "ADBE Vector Rotation" === t1 ? i1.rotation : e1.s.ix === t1 || "Scale" === t1 ? i1.scale : e1.sk && e1.sk.ix === t1 || "Skew" === t1 ? i1.skew : e1.sa && e1.sa.ix === t1 || "Skew Axis" === t1 ? i1.skewAxis : null;
            }
            var s1 = propertyGroupFactory(i1, r1);
            return t1.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", s1)), t1.transform.mProps.p.setGroupProperty(PropertyInterface("Position", s1)), t1.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", s1)), t1.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", s1)), t1.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", s1)), t1.transform.mProps.sk && (t1.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", s1)), t1.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", s1))), t1.transform.op.setGroupProperty(PropertyInterface("Opacity", s1)), Object.defineProperties(i1, {
                opacity: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(t1.transform.mProps.sa)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.ty = "tr", i1.mn = e1.mn, i1.propertyGroup = r1, i1;
        }
        function d1(e1, t1, r1) {
            function i1(t1) {
                return e1.p.ix === t1 ? i1.position : e1.s.ix === t1 ? i1.size : null;
            }
            var s1 = propertyGroupFactory(i1, r1);
            i1.propertyIndex = e1.ix;
            var a1 = "tm" === t1.sh.ty ? t1.sh.prop : t1.sh;
            return a1.s.setGroupProperty(PropertyInterface("Size", s1)), a1.p.setGroupProperty(PropertyInterface("Position", s1)), Object.defineProperties(i1, {
                size: {
                    get: ExpressionPropertyInterface(a1.s)
                },
                position: {
                    get: ExpressionPropertyInterface(a1.p)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        function u1(e1, t1, r1) {
            function i1(t1) {
                return e1.p.ix === t1 ? i1.position : e1.r.ix === t1 ? i1.rotation : e1.pt.ix === t1 ? i1.points : e1.or.ix === t1 || "ADBE Vector Star Outer Radius" === t1 ? i1.outerRadius : e1.os.ix === t1 ? i1.outerRoundness : !e1.ir || e1.ir.ix !== t1 && "ADBE Vector Star Inner Radius" !== t1 ? e1.is && e1.is.ix === t1 ? i1.innerRoundness : null : i1.innerRadius;
            }
            var s1 = propertyGroupFactory(i1, r1), a1 = "tm" === t1.sh.ty ? t1.sh.prop : t1.sh;
            return i1.propertyIndex = e1.ix, a1.or.setGroupProperty(PropertyInterface("Outer Radius", s1)), a1.os.setGroupProperty(PropertyInterface("Outer Roundness", s1)), a1.pt.setGroupProperty(PropertyInterface("Points", s1)), a1.p.setGroupProperty(PropertyInterface("Position", s1)), a1.r.setGroupProperty(PropertyInterface("Rotation", s1)), e1.ir && (a1.ir.setGroupProperty(PropertyInterface("Inner Radius", s1)), a1.is.setGroupProperty(PropertyInterface("Inner Roundness", s1))), Object.defineProperties(i1, {
                position: {
                    get: ExpressionPropertyInterface(a1.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(a1.r)
                },
                points: {
                    get: ExpressionPropertyInterface(a1.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(a1.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(a1.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(a1.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(a1.is)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        function y1(e1, t1, r1) {
            function i1(t1) {
                return e1.p.ix === t1 ? i1.position : e1.r.ix === t1 ? i1.roundness : e1.s.ix === t1 || "Size" === t1 || "ADBE Vector Rect Size" === t1 ? i1.size : null;
            }
            var s1 = propertyGroupFactory(i1, r1), a1 = "tm" === t1.sh.ty ? t1.sh.prop : t1.sh;
            return i1.propertyIndex = e1.ix, a1.p.setGroupProperty(PropertyInterface("Position", s1)), a1.s.setGroupProperty(PropertyInterface("Size", s1)), a1.r.setGroupProperty(PropertyInterface("Rotation", s1)), Object.defineProperties(i1, {
                position: {
                    get: ExpressionPropertyInterface(a1.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(a1.r)
                },
                size: {
                    get: ExpressionPropertyInterface(a1.s)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        function g1(e1, t1, r1) {
            function i1(t1) {
                return e1.r.ix === t1 || "Round Corners 1" === t1 ? i1.radius : null;
            }
            var s1 = propertyGroupFactory(i1, r1), a1 = t1;
            return i1.propertyIndex = e1.ix, a1.rd.setGroupProperty(PropertyInterface("Radius", s1)), Object.defineProperties(i1, {
                radius: {
                    get: ExpressionPropertyInterface(a1.rd)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        function v1(e1, t1, r1) {
            function i1(t1) {
                return e1.c.ix === t1 || "Copies" === t1 ? i1.copies : e1.o.ix === t1 || "Offset" === t1 ? i1.offset : null;
            }
            var s1 = propertyGroupFactory(i1, r1), a1 = t1;
            return i1.propertyIndex = e1.ix, a1.c.setGroupProperty(PropertyInterface("Copies", s1)), a1.o.setGroupProperty(PropertyInterface("Offset", s1)), Object.defineProperties(i1, {
                copies: {
                    get: ExpressionPropertyInterface(a1.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(a1.o)
                },
                _name: {
                    value: e1.nm
                }
            }), i1.mn = e1.mn, i1;
        }
        return function(t1, e1, i1) {
            var s1;
            function r1(t1) {
                if ("number" == typeof t1) return 0 === (t1 = void 0 === t1 ? 1 : t1) ? i1 : s1[t1 - 1];
                for(var e1 = 0, r1 = s1.length; e1 < r1;){
                    if (s1[e1]._name === t1) return s1[e1];
                    e1 += 1;
                }
                return null;
            }
            return r1.propertyGroup = propertyGroupFactory(r1, function() {
                return i1;
            }), s1 = n1(t1, e1, r1.propertyGroup), r1.numProperties = s1.length, r1._name = "Contents", r1;
        };
    }(), TextExpressionInterface = function(e1) {
        var r1;
        function i1(t1) {
            switch(t1){
                case "ADBE Text Document":
                    return i1.sourceText;
                default:
                    return null;
            }
        }
        return Object.defineProperty(i1, "sourceText", {
            get: function() {
                e1.textProperty.getValue();
                var t1 = e1.textProperty.currentData.t;
                return void 0 !== t1 && (e1.textProperty.currentData.t = void 0, (r1 = new String(t1)).value = t1 || new String(t1)), r1;
            }
        }), i1;
    }, LayerExpressionInterface = function() {
        function s1(t1) {
            var e1 = new Matrix;
            void 0 !== t1 ? this._elem.finalTransform.mProp.getValueAtTime(t1).clone(e1) : this._elem.finalTransform.mProp.applyToMatrix(e1);
            return e1;
        }
        function a1(t1, e1) {
            var r1 = this.getMatrix(e1);
            return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.applyPoint(r1, t1);
        }
        function n1(t1, e1) {
            var r1 = this.getMatrix(e1);
            return this.applyPoint(r1, t1);
        }
        function o1(t1, e1) {
            var r1 = this.getMatrix(e1);
            return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.invertPoint(r1, t1);
        }
        function h1(t1, e1) {
            var r1 = this.getMatrix(e1);
            return this.invertPoint(r1, t1);
        }
        function l1(t1, e1) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var r1, i1 = this._elem.hierarchy.length;
                for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
            }
            return t1.applyToPointArray(e1[0], e1[1], e1[2] || 0);
        }
        function p1(t1, e1) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var r1, i1 = this._elem.hierarchy.length;
                for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t1);
            }
            return t1.inversePoint(e1);
        }
        function m1(t1) {
            var e1 = new Matrix;
            if (e1.reset(), this._elem.finalTransform.mProp.applyToMatrix(e1), this._elem.hierarchy && this._elem.hierarchy.length) {
                var r1, i1 = this._elem.hierarchy.length;
                for(r1 = 0; r1 < i1; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(e1);
                return e1.inversePoint(t1);
            }
            return e1.inversePoint(t1);
        }
        function f1() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(e1) {
            var r1;
            function i1(t1) {
                switch(t1){
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return i1.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return r1;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return i1.effect;
                    case "ADBE Text Properties":
                        return i1.textInterface;
                    default:
                        return null;
                }
            }
            i1.getMatrix = s1, i1.invertPoint = p1, i1.applyPoint = l1, i1.toWorld = n1, i1.toWorldVec = a1, i1.fromWorld = h1, i1.fromWorldVec = o1, i1.toComp = n1, i1.fromComp = m1, i1.sampleImage = f1, i1.sourceRectAtTime = e1.sourceRectAtTime.bind(e1);
            var t1 = getDescriptor(r1 = TransformExpressionInterface((i1._elem = e1).finalTransform.mProp), "anchorPoint");
            return Object.defineProperties(i1, {
                hasParent: {
                    get: function() {
                        return e1.hierarchy.length;
                    }
                },
                parent: {
                    get: function() {
                        return e1.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(r1, "rotation"),
                scale: getDescriptor(r1, "scale"),
                position: getDescriptor(r1, "position"),
                opacity: getDescriptor(r1, "opacity"),
                anchorPoint: t1,
                anchor_point: t1,
                transform: {
                    get: function() {
                        return r1;
                    }
                },
                active: {
                    get: function() {
                        return e1.isInRange;
                    }
                }
            }), i1.startTime = e1.data.st, i1.index = e1.data.ind, i1.source = e1.data.refId, i1.height = 0 === e1.data.ty ? e1.data.h : 100, i1.width = 0 === e1.data.ty ? e1.data.w : 100, i1.inPoint = e1.data.ip / e1.comp.globalData.frameRate, i1.outPoint = e1.data.op / e1.comp.globalData.frameRate, i1._name = e1.data.nm, i1.registerMaskInterface = function(t1) {
                i1.mask = new MaskManagerInterface(t1, e1);
            }, i1.registerEffectsInterface = function(t1) {
                i1.effect = t1;
            }, i1;
        };
    }(), FootageInterface = (f6 = function(t1) {
        function e1(t1) {
            return "Outline" === t1 ? e1.outlineInterface() : null;
        }
        return e1._name = "Outline", e1.outlineInterface = function(t1) {
            var i1 = "", s1 = t1.getFootageData();
            function a1(t1) {
                if (s1[t1]) return "object" == typeof (s1 = s1[i1 = t1]) ? a1 : s1;
                var e1 = t1.indexOf(i1);
                if (-1 === e1) return "";
                var r1 = parseInt(t1.substr(e1 + i1.length), 10);
                return "object" == typeof (s1 = s1[r1]) ? a1 : s1;
            }
            return function() {
                return i1 = "", s1 = t1.getFootageData(), a1;
            };
        }(t1), e1;
    }, function(t1) {
        function e1(t1) {
            return "Data" === t1 ? e1.dataInterface : null;
        }
        return e1._name = "Data", e1.dataInterface = f6(t1), e1;
    }), f6, CompExpressionInterface = function(i1) {
        function t1(t1) {
            for(var e1 = 0, r1 = i1.layers.length; e1 < r1;){
                if (i1.layers[e1].nm === t1 || i1.layers[e1].ind === t1) return i1.elements[e1].layerInterface;
                e1 += 1;
            }
            return null;
        }
        return Object.defineProperty(t1, "_name", {
            value: i1.data.nm
        }), (t1.layer = t1).pixelAspect = 1, t1.height = i1.data.h || i1.globalData.compSize.h, t1.width = i1.data.w || i1.globalData.compSize.w, t1.pixelAspect = 1, t1.frameDuration = 1 / i1.globalData.frameRate, t1.displayStartTime = 0, t1.numLayers = i1.layers.length, t1;
    }, TransformExpressionInterface = function(t1) {
        function e1(t1) {
            switch(t1){
                case "scale":
                case "Scale":
                case "ADBE Scale":
                case 6:
                    return e1.scale;
                case "rotation":
                case "Rotation":
                case "ADBE Rotation":
                case "ADBE Rotate Z":
                case 10:
                    return e1.rotation;
                case "ADBE Rotate X":
                    return e1.xRotation;
                case "ADBE Rotate Y":
                    return e1.yRotation;
                case "position":
                case "Position":
                case "ADBE Position":
                case 2:
                    return e1.position;
                case "ADBE Position_0":
                    return e1.xPosition;
                case "ADBE Position_1":
                    return e1.yPosition;
                case "ADBE Position_2":
                    return e1.zPosition;
                case "anchorPoint":
                case "AnchorPoint":
                case "Anchor Point":
                case "ADBE AnchorPoint":
                case 1:
                    return e1.anchorPoint;
                case "opacity":
                case "Opacity":
                case 11:
                    return e1.opacity;
                default:
                    return null;
            }
        }
        var r1, i1, s1, a1;
        return Object.defineProperty(e1, "rotation", {
            get: ExpressionPropertyInterface(t1.r || t1.rz)
        }), Object.defineProperty(e1, "zRotation", {
            get: ExpressionPropertyInterface(t1.rz || t1.r)
        }), Object.defineProperty(e1, "xRotation", {
            get: ExpressionPropertyInterface(t1.rx)
        }), Object.defineProperty(e1, "yRotation", {
            get: ExpressionPropertyInterface(t1.ry)
        }), Object.defineProperty(e1, "scale", {
            get: ExpressionPropertyInterface(t1.s)
        }), t1.p ? a1 = ExpressionPropertyInterface(t1.p) : (r1 = ExpressionPropertyInterface(t1.px), i1 = ExpressionPropertyInterface(t1.py), t1.pz && (s1 = ExpressionPropertyInterface(t1.pz))), Object.defineProperty(e1, "position", {
            get: function() {
                return t1.p ? a1() : [
                    r1(),
                    i1(),
                    s1 ? s1() : 0
                ];
            }
        }), Object.defineProperty(e1, "xPosition", {
            get: ExpressionPropertyInterface(t1.px)
        }), Object.defineProperty(e1, "yPosition", {
            get: ExpressionPropertyInterface(t1.py)
        }), Object.defineProperty(e1, "zPosition", {
            get: ExpressionPropertyInterface(t1.pz)
        }), Object.defineProperty(e1, "anchorPoint", {
            get: ExpressionPropertyInterface(t1.a)
        }), Object.defineProperty(e1, "opacity", {
            get: ExpressionPropertyInterface(t1.o)
        }), Object.defineProperty(e1, "skew", {
            get: ExpressionPropertyInterface(t1.sk)
        }), Object.defineProperty(e1, "skewAxis", {
            get: ExpressionPropertyInterface(t1.sa)
        }), Object.defineProperty(e1, "orientation", {
            get: ExpressionPropertyInterface(t1.or)
        }), e1;
    }, ProjectInterface = function() {
        function e1(t1) {
            this.compositions.push(t1);
        }
        return function() {
            function t1(t1) {
                for(var e1 = 0, r1 = this.compositions.length; e1 < r1;){
                    if (this.compositions[e1].data && this.compositions[e1].data.nm === t1) return this.compositions[e1].prepareFrame && this.compositions[e1].data.xt && this.compositions[e1].prepareFrame(this.currentFrame), this.compositions[e1].compInterface;
                    e1 += 1;
                }
                return null;
            }
            return t1.compositions = [], t1.currentFrame = 0, t1.registerComposition = e1, t1;
        };
    }(), EffectsExpressionInterface = function() {
        function l1(s1, t1, e1, r1) {
            function i1(t1) {
                for(var e1 = s1.ef, r1 = 0, i1 = e1.length; r1 < i1;){
                    if (t1 === e1[r1].nm || t1 === e1[r1].mn || t1 === e1[r1].ix) return 5 === e1[r1].ty ? o1[r1] : o1[r1]();
                    r1 += 1;
                }
                throw new Error;
            }
            var a1, n1 = propertyGroupFactory(i1, e1), o1 = [], h1 = s1.ef.length;
            for(a1 = 0; a1 < h1; a1 += 1)5 === s1.ef[a1].ty ? o1.push(l1(s1.ef[a1], t1.effectElements[a1], t1.effectElements[a1].propertyGroup, r1)) : o1.push(p1(t1.effectElements[a1], s1.ef[a1].ty, r1, n1));
            return "ADBE Color Control" === s1.mn && Object.defineProperty(i1, "color", {
                get: function() {
                    return o1[0]();
                }
            }), Object.defineProperties(i1, {
                numProperties: {
                    get: function() {
                        return s1.np;
                    }
                },
                _name: {
                    value: s1.nm
                },
                propertyGroup: {
                    value: n1
                }
            }), i1.enabled = 0 !== s1.en, i1.active = i1.enabled, i1;
        }
        function p1(t1, e1, r1, i1) {
            var s1 = ExpressionPropertyInterface(t1.p);
            return t1.p.setGroupProperty && t1.p.setGroupProperty(PropertyInterface("", i1)), function() {
                return 10 === e1 ? r1.comp.compInterface(t1.p.v) : s1();
            };
        }
        return {
            createEffectsInterface: function(t1, e1) {
                if (t1.effectsManager) {
                    var r1, i1 = [], s1 = t1.data.ef, a1 = t1.effectsManager.effectElements.length;
                    for(r1 = 0; r1 < a1; r1 += 1)i1.push(l1(s1[r1], t1.effectsManager.effectElements[r1], e1, t1));
                    var n1 = t1.data.ef || [], o1 = function(t1) {
                        for(r1 = 0, a1 = n1.length; r1 < a1;){
                            if (t1 === n1[r1].nm || t1 === n1[r1].mn || t1 === n1[r1].ix) return i1[r1];
                            r1 += 1;
                        }
                        return null;
                    };
                    return Object.defineProperty(o1, "numProperties", {
                        get: function() {
                            return n1.length;
                        }
                    }), o1;
                }
                return null;
            }
        };
    }(), MaskManagerInterface = function() {
        function t1(t1, e1) {
            this._mask = t1, this._data = e1;
        }
        Object.defineProperty(t1.prototype, "maskPath", {
            get: function() {
                return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
            }
        }), Object.defineProperty(t1.prototype, "maskOpacity", {
            get: function() {
                return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
            }
        });
        return function(e1) {
            var r1, i1 = createSizedArray(e1.viewData.length), s1 = e1.viewData.length;
            for(r1 = 0; r1 < s1; r1 += 1)i1[r1] = new t1(e1.viewData[r1], e1.masksProperties[r1]);
            return function(t1) {
                for(r1 = 0; r1 < s1;){
                    if (e1.masksProperties[r1].nm === t1) return i1[r1];
                    r1 += 1;
                }
                return null;
            };
        };
    }(), ExpressionPropertyInterface = function() {
        var s1 = {
            pv: 0,
            v: 0,
            mult: 1
        }, n1 = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function o1(i1, s1, a1) {
            Object.defineProperty(i1, "velocity", {
                get: function() {
                    return s1.getVelocityAtTime(s1.comp.currentFrame);
                }
            }), i1.numKeys = s1.keyframes ? s1.keyframes.length : 0, i1.key = function(t1) {
                if (!i1.numKeys) return 0;
                var e1 = "";
                e1 = "s" in s1.keyframes[t1 - 1] ? s1.keyframes[t1 - 1].s : "e" in s1.keyframes[t1 - 2] ? s1.keyframes[t1 - 2].e : s1.keyframes[t1 - 2].s;
                var r1 = "unidimensional" === a1 ? new Number(e1) : Object.assign({}, e1);
                return r1.time = s1.keyframes[t1 - 1].t / s1.elem.comp.globalData.frameRate, r1.value = "unidimensional" === a1 ? e1[0] : e1, r1;
            }, i1.valueAtTime = s1.getValueAtTime, i1.speedAtTime = s1.getSpeedAtTime, i1.velocityAtTime = s1.getVelocityAtTime, i1.propertyGroup = s1.propertyGroup;
        }
        function e1() {
            return s1;
        }
        return function(t1) {
            return t1 ? "unidimensional" === t1.propType ? function(t1) {
                t1 && "pv" in t1 || (t1 = s1);
                var e1 = 1 / t1.mult, r1 = t1.pv * e1, i1 = new Number(r1);
                return i1.value = r1, o1(i1, t1, "unidimensional"), function() {
                    return t1.k && t1.getValue(), r1 = t1.v * e1, i1.value !== r1 && ((i1 = new Number(r1)).value = r1, o1(i1, t1, "unidimensional")), i1;
                };
            }(t1) : function(e1) {
                e1 && "pv" in e1 || (e1 = n1);
                var r1 = 1 / e1.mult, i1 = e1.data && e1.data.l || e1.pv.length, s1 = createTypedArray("float32", i1), a1 = createTypedArray("float32", i1);
                return s1.value = a1, o1(s1, e1, "multidimensional"), function() {
                    e1.k && e1.getValue();
                    for(var t1 = 0; t1 < i1; t1 += 1)a1[t1] = e1.v[t1] * r1, s1[t1] = a1[t1];
                    return s1;
                };
            }(t1) : e1;
        };
    }(), TextExpressionSelectorPropFactory = function() {
        function r1(t1, e1) {
            return this.textIndex = t1 + 1, this.textTotal = e1, this.v = this.getValue() * this.mult, this.v;
        }
        return function(t1, e1) {
            this.pv = 1, this.comp = t1.comp, this.elem = t1, this.mult = .01, this.propType = "textSelector", this.textTotal = e1.totalChars, this.selectorValue = 100, this.lastValue = [
                1,
                1,
                1
            ], this.k = !0, this.x = !0, this.getValue = ExpressionManager.initiateExpression.bind(this)(t1, e1, this), this.getMult = r1, this.getVelocityAtTime = expressionHelpers.getVelocityAtTime, this.kf ? this.getValueAtTime = expressionHelpers.getValueAtTime.bind(this) : this.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(this), this.setGroupProperty = expressionHelpers.setGroupProperty;
        };
    }(), propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
    function SliderEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
    }
    function AngleEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
    }
    function ColorEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
    }
    function PointEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 1, 0, r1);
    }
    function LayerIndexEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
    }
    function MaskIndexEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
    }
    function CheckboxEffect(t1, e1, r1) {
        this.p = PropertyFactory.getProp(e1, t1.v, 0, 0, r1);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(t1, e1) {
        var r1, i1 = t1.ef || [];
        this.effectElements = [];
        var s1, a1 = i1.length;
        for(r1 = 0; r1 < a1; r1 += 1)s1 = new GroupEffect(i1[r1], e1), this.effectElements.push(s1);
    }
    function GroupEffect(t1, e1) {
        this.init(t1, e1);
    }
    TextSelectorProp.getTextSelectorProp = function(t1, e1, r1) {
        return 1 === e1.t ? new TextExpressionSelectorPropFactory(t1, e1, r1) : propertyGetTextProp(t1, e1, r1);
    }, extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t1, e1) {
        var r1;
        this.data = t1, this.effectElements = [], this.initDynamicPropertyContainer(e1);
        var i1, s1 = this.data.ef.length, a1 = this.data.ef;
        for(r1 = 0; r1 < s1; r1 += 1){
            switch(i1 = null, a1[r1].ty){
                case 0:
                    i1 = new SliderEffect(a1[r1], e1, this);
                    break;
                case 1:
                    i1 = new AngleEffect(a1[r1], e1, this);
                    break;
                case 2:
                    i1 = new ColorEffect(a1[r1], e1, this);
                    break;
                case 3:
                    i1 = new PointEffect(a1[r1], e1, this);
                    break;
                case 4:
                case 7:
                    i1 = new CheckboxEffect(a1[r1], e1, this);
                    break;
                case 10:
                    i1 = new LayerIndexEffect(a1[r1], e1, this);
                    break;
                case 11:
                    i1 = new MaskIndexEffect(a1[r1], e1, this);
                    break;
                case 5:
                    i1 = new EffectsManager(a1[r1], e1, this);
                    break;
                default:
                    i1 = new NoValueEffect(a1[r1], e1, this);
            }
            i1 && this.effectElements.push(i1);
        }
    };
    var lottie = {};
    function setLocationHref(t1) {
        locationHref = t1;
    }
    function searchAnimations() {
        !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
    }
    function setSubframeRendering(t1) {
        subframeEnabled = t1;
    }
    function setIDPrefix(t1) {
        idPrefix = t1;
    }
    function loadAnimation(t1) {
        return !0 === standalone && (t1.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t1);
    }
    function setQuality(t1) {
        if ("string" == typeof t1) switch(t1){
            case "high":
                defaultCurveSegments = 200;
                break;
            default:
            case "medium":
                defaultCurveSegments = 50;
                break;
            case "low":
                defaultCurveSegments = 10;
        }
        else !isNaN(t1) && 1 < t1 && (defaultCurveSegments = t1);
        roundValues(!(50 <= defaultCurveSegments));
    }
    function inBrowser() {
        return "undefined" != typeof navigator;
    }
    function installPlugin(t1, e1) {
        "expressions" === t1 && (expressionsPlugin = e1);
    }
    function getFactory(t1) {
        switch(t1){
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null;
        }
    }
    function checkReady() {
        "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t1) {
        for(var e1 = queryString.split("&"), r1 = 0; r1 < e1.length; r1 += 1){
            var i1 = e1[r1].split("=");
            if (decodeURIComponent(i1[0]) == t1) return decodeURIComponent(i1[1]);
        }
        return null;
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocationHref, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.setIDPrefix = setIDPrefix, lottie.__getFactory = getFactory, lottie.version = "5.7.12";
    var standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "", queryString;
    if (standalone) {
        var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
            src: ""
        };
        queryString = myScript.src.replace(/^[^\?]+\??/, ""), renderer = getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    return lottie;
});

//# sourceMappingURL=index.ce209796.js.map
